// Master Spanish → (EN/PT/FR/DE/IT) dictionary for hardcoded UI strings.
// Update here to adjust translations globally across Landing + Dashboard.
/* eslint-disable */

const DICT = {
  en: {
    // Nav + generic
    "Dashboard": "Dashboard",
    "Resumen": "Overview",
    "Calendario": "Calendar",
    "Generador": "Generator",
    "Imágenes": "Images",
    "Videos": "Videos",
    "Feed": "Feed",
    "Banco": "Bank",
    "Banco de contenido": "Content bank",
    "Analítica": "Analytics",
    "Competencia": "Competitors",
    "Competidores": "Competitors",
    "Escucha social": "Social listening",
    "Cuentas sociales": "Social accounts",
    "Marca": "Brand",
    "Seguridad": "Security",
    "API Keys": "API Keys",
    "API": "API",
    "Marketplace": "Marketplace",
    "SEO": "SEO",
    "Referidos": "Referrals",
    "Suscripción": "Subscription",
    "Admin": "Admin",
    "NUEVO POST": "NEW POST",
    "NUEVA": "NEW",
    "NUEVO": "NEW",
    "Nuevo": "New",
    "Nueva": "New",
    "GUARDAR": "SAVE",
    "Guardar": "Save",
    "CANCELAR": "CANCEL",
    "Cancelar": "Cancel",
    "ELIMINAR": "DELETE",
    "Eliminar": "Delete",
    "CERRAR": "CLOSE",
    "Cerrar": "Close",
    "EDITAR": "EDIT",
    "Editar": "Edit",
    "VER": "VIEW",
    "Ver": "View",
    "CARGAR": "LOAD",
    "CARGANDO": "LOADING",
    "Cargando…": "Loading…",
    "Cargando...": "Loading...",
    "APLICAR": "APPLY",
    "FILTRAR": "FILTER",
    "BUSCAR": "SEARCH",
    "Buscar": "Search",
    "COPIAR": "COPY",
    "Copiar": "Copy",
    "DESCARGAR": "DOWNLOAD",
    "Descargar": "Download",
    "PUBLICAR": "PUBLISH",
    "Publicar": "Publish",
    "PROGRAMAR": "SCHEDULE",
    "Programar": "Schedule",
    "APROBAR": "APPROVE",
    "Aprobar": "Approve",
    "RECHAZAR": "REJECT",
    "Rechazar": "Reject",
    "GENERAR": "GENERATE",
    "Generar": "Generate",
    "CONECTAR": "CONNECT",
    "Conectar": "Connect",
    "DESCONECTAR": "DISCONNECT",
    "Desconectar": "Disconnect",
    "SALIR": "LOG OUT",
    "Salir": "Log out",
    "CERRAR SESIÓN": "LOG OUT",
    "VOLVER": "BACK",
    "Volver": "Back",
    "SIGUIENTE": "NEXT",
    "Siguiente": "Next",

    // Shared status
    "Activo": "Active",
    "Inactivo": "Inactive",
    "Pendiente": "Pending",
    "Aprobado": "Approved",
    "Rechazado": "Rejected",
    "Publicado": "Published",
    "Programado": "Scheduled",
    "Fallido": "Failed",
    "Procesando": "Processing",
    "Listo": "Ready",
    "Entregado": "Delivered",
    "Borrador": "Draft",
    "Completado": "Completed",
    "En proceso": "In progress",
    "Sí": "Yes",
    "No": "No",

    // Overview
    "Bienvenido": "Welcome",
    "Posts este mes": "Posts this month",
    "Imágenes generadas": "Images generated",
    "Videos generados": "Videos generated",
    "Uso de tu plan": "Plan usage",
    "Próximas publicaciones": "Upcoming posts",
    "Sin publicaciones programadas": "No scheduled posts",
    "Crear mi primer post": "Create my first post",
    "Generar": "Generate",
    "Atajos": "Shortcuts",
    "Generar post": "Generate post",
    "Generar imagen": "Generate image",
    "Generar video": "Generate video",
    "Ver calendario": "View calendar",

    // Generator
    "Generador de contenido": "Content generator",
    "¿Sobre qué quieres publicar?": "What do you want to post about?",
    "Prompt": "Prompt",
    "Plataforma": "Platform",
    "Tipo de contenido": "Content type",
    "Tono": "Tone",
    "Idioma": "Language",
    "Generando…": "Generating…",
    "Variantes": "Variants",
    "Copiar al portapapeles": "Copy to clipboard",
    "Guardar en banco": "Save to bank",
    "PLANTILLA": "TEMPLATE",
    "Guardar como plantilla": "Save as template",
    "Hacer pública": "Make public",
    "Añadir al calendario": "Add to calendar",
    "Post": "Post",
    "Hilo": "Thread",
    "Carrusel": "Carousel",
    "Script": "Script",
    "Caption corto": "Short caption",

    // Images
    "Generador de imágenes": "Image generator",
    "Describe la imagen": "Describe the image",
    "Estilo": "Style",
    "Galería": "Gallery",
    "Sin imágenes aún": "No images yet",
    "Descargar PNG": "Download PNG",

    // Videos
    "Generador de videos": "Video generator",
    "Biblioteca de videos": "Video library",
    "Aspect ratio": "Aspect ratio",
    "Duración": "Duration",
    "Modelo": "Model",
    "Frecuencia": "Frequency",
    "Diaria": "Daily",
    "Semanal": "Weekly",
    "Quincenal": "Biweekly",
    "Personalizada": "Custom",
    "Guardar ajustes": "Save settings",
    "Publicar este video": "Publish this video",
    "Elegir red": "Choose network",
    "Caption sugerido": "Suggested caption",

    // Calendar
    "Arrastra para reprogramar": "Drag to reschedule",
    "Aprobación pendiente": "Pending approval",
    "Sin publicaciones en este día": "No posts on this day",
    "Detalle del post": "Post details",
    "Hora": "Time",
    "Red": "Network",
    "Contenido": "Content",
    "Video adjunto": "Attached video",

    // Feed
    "Feed de aprobación": "Approval feed",
    "Posts pendientes": "Pending posts",
    "Sin pendientes": "Nothing pending",

    // Content Bank
    "Favoritos": "Favorites",
    "Todos": "All",
    "Filtrar por red": "Filter by network",
    "Sin contenido guardado": "No saved content",

    // Analytics
    "Analytics unificado": "Unified analytics",
    "Impresiones totales": "Total impressions",
    "Engagement total": "Total engagement",
    "Crecimiento de seguidores": "Follower growth",
    "Mejor contenido del mes": "Best content of the month",
    "Rango de fechas": "Date range",
    "Últimos 30 días": "Last 30 days",
    "Últimos 7 días": "Last 7 days",

    // Competitors
    "Radar de competidores": "Competitor radar",
    "Añadir competidor": "Add competitor",
    "Handle o URL": "Handle or URL",
    "Frecuencia de post": "Post frequency",
    "Tono detectado": "Detected tone",
    "Sin competidores aún": "No competitors yet",

    // Social Listening
    "Palabras clave": "Keywords",
    "Menciones recientes": "Recent mentions",
    "Añadir keyword": "Add keyword",
    "Sin keywords aún": "No keywords yet",

    // Social Accounts
    "Redes sociales": "Social networks",
    "Conectar cuenta": "Connect account",
    "Cuenta conectada": "Account connected",
    "Próximamente OAuth real": "Real OAuth coming soon",

    // Brand Config
    "Configuración de marca": "Brand configuration",
    "Nombre de la marca": "Brand name",
    "Color primario": "Primary color",
    "Tono de voz": "Voice tone",
    "Temas preferidos": "Preferred topics",
    "Palabras prohibidas": "Forbidden words",
    "Usar emojis": "Use emojis",
    "Idioma de publicación": "Publishing language",
    "Marcas": "Brands",
    "Marca activa": "Active brand",

    // Referrals
    "Tu código de referido": "Your referral code",
    "Invitaciones": "Invitations",
    "Recompensas acumuladas": "Rewards earned",
    "Copiar link": "Copy link",

    // Subscription
    "Plan actual": "Current plan",
    "Cambiar plan": "Change plan",
    "Factura": "Invoice",
    "Histórico de pagos": "Billing history",
    "Video add-on": "Video add-on",
    "ACTIVO": "ACTIVE",
    "INACTIVO": "INACTIVE",
    "Mensual": "Monthly",
    "Anual": "Annual",
    "Activar": "Activate",
    "Renovación": "Renewal",
    "Cancelar suscripción": "Cancel subscription",

    // Admin MRR
    "Panel MRR": "MRR panel",
    "MRR total": "Total MRR",
    "Suscripciones activas": "Active subscriptions",
    "Churn": "Churn",

    // Security
    "Seguridad de la cuenta": "Account security",
    "Autenticación 2 factores": "Two-factor authentication",
    "2FA activado": "2FA enabled",
    "2FA desactivado": "2FA disabled",
    "Activar 2FA": "Enable 2FA",
    "Desactivar 2FA": "Disable 2FA",
    "Escanea el QR con tu app de autenticación": "Scan the QR with your authenticator app",
    "Código de 6 dígitos": "6-digit code",
    "Verificar": "Verify",

    // API Keys
    "Gestiona tus llaves API": "Manage your API keys",
    "Crear nueva key": "Create new key",
    "Nombre de la key": "Key name",
    "Revocar": "Revoke",
    "Copia tu secret ahora — no volverá a mostrarse": "Copy your secret now — it won't be shown again",
    "Solo plan Agencia": "Agency plan only",

    // Marketplace
    "Marketplace de plantillas": "Template marketplace",
    "Explorar plantillas": "Browse templates",
    "Más populares": "Most popular",
    "Más recientes": "Most recent",
    "Solo gratis": "Free only",
    "USAR": "USE",
    "Usar plantilla": "Use template",
    "Industria": "Industry",
    "Creada por": "Created by",

    // SEO
    "Módulo SEO": "SEO module",
    "Blog post IA": "AI blog post",
    "Auditoría on-page": "On-page audit",
    "Auto-publicar a CMS": "Auto-publish to CMS",
    "Título": "Title",
    "Meta descripción": "Meta description",
    "Palabra clave principal": "Main keyword",
    "Generar artículo": "Generate article",
    "URL del sitio": "Site URL",
    "Auditar": "Audit",
    "Score": "Score",
    "Issues encontrados": "Issues found",
    "Conexiones activas": "Active connections",
    "Nueva conexión": "New connection",
    "Token API": "API token",
    "Tipo de CMS": "CMS type",

    // Landing specific extra
    "Precios sin trampas.": "Clear pricing. No hidden terms.",
    "Elige tu plan. Añade el módulo de": "Choose your plan. Add the",
    "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "module if you need it — it doubles the plan price and you get up to 1 video/day.",
    "ABRIR CALCULADORA DE PRECIOS": "OPEN PRICING CALCULATOR",
    "CON VIDEOS IA · 2×": "WITH AI VIDEOS · 2×",
    "VER DETALLES": "SEE DETAILS",
    "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* VIDEO PRICE = 2× BASE · INCLUDES UP TO 30 VIDEOS/MONTH · CONFIGURABLE FREQUENCY",
    "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · SAMPLES",
    "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOICES",
    "DOSSIER 04 · TARIFAS": "DOSSIER 04 · PRICING",
    "Así se ve tu contenido en cada red.": "This is how your content looks on every network.",
    "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Real mockups of what the platform publishes: vertical video, Instagram feed, carousel and LinkedIn post.",
    "El copy que enganchó a miles.": "The copy that hooked thousands.",
    "Generado por IA.": "Generated by AI.",
    "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, captions and scripts already breaking metrics worldwide. All from a 2-line prompt.",
    "GENERAR MI PRIMER POST GRATIS": "GENERATE MY FIRST POST FREE",
    "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "NO CARD REQUIRED · CANCEL ANYTIME",
    "ANTES": "BEFORE",
    "DESPUÉS": "AFTER",
    "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",

    // Pricing plan features (from backend)
    "1 red social": "1 social network",
    "10 posts/mes generados": "10 posts/month generated",
    "Sin programación automática": "No auto-scheduling",
    "Sin imágenes AI": "No AI images",
    "Sin videos IA": "No AI videos",
    "3 redes sociales": "3 social networks",
    "100 posts/mes": "100 posts/month",
    "20 imágenes/mes": "20 images/month",
    "Programación manual": "Manual scheduling",
    "Analytics básico": "Basic analytics",
    "Todas las redes sociales": "All social networks",
    "500 posts/mes": "500 posts/month",
    "100 imágenes/mes": "100 images/month",
    "Programación automática": "Auto-scheduling",
    "Monitor de 3 competidores": "3 competitor monitors",
    "Modo autopilot": "Autopilot mode",
    "Posts ilimitados": "Unlimited posts",
    "Múltiples marcas / clientes (hasta 5)": "Multiple brands / clients (up to 5)",
    "API access": "API access",
    "White label opcional": "Optional white label",
    "Soporte prioritario": "Priority support",
    "+Video: hasta 30 videos/mes (1/día)": "+Video: up to 30 videos/month (1/day)",

    // Stats / demo labels
    "EN VIVO": "LIVE",
    "GENERADO": "GENERATED",
    "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GENERATED · 8S · AUTO-PUBLISHED 09:32",
    "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERATED · AUTO-APPROVED · PUBLISHED 18:00",
    "CDMX · MÉXICO": "CDMX · MEXICO",
    "2,340 SEGUIDORES · HACE 2H": "2,340 FOLLOWERS · 2H AGO",
    "me gusta": "likes",
    "ver 42 comentarios": "view 42 comments",
    "892 · 104 comentarios · 67 republicaciones": "892 · 104 comments · 67 reposts",

    // Before/after
    "Café especialidad · CDMX": "Specialty coffee · CDMX",
    "E-commerce ropa · Guadalajara": "Fashion e-commerce · Guadalajara",
    "B2B software · Medellín": "B2B software · Medellín",
    "Logo casero · Canva": "Homemade logo · Canva",
    "Identidad CIA Marketing®": "CIA Marketing® identity",
    "Sin guía de marca": "No brand guide",
    "Branding + autopilot": "Branding + autopilot",
    "Solo landing · sin redes": "Landing only · no socials",
    "Branding + LinkedIn auto": "Branding + LinkedIn auto",
    "2% CTR · 340 seguidores": "2% CTR · 340 followers",
    "9.4% CTR · 12,800 seguidores (+3,671%)": "9.4% CTR · 12,800 followers (+3,671%)",
    "ROAS 1.1× · 42 compras/mes": "ROAS 1.1× · 42 purchases/mo",
    "ROAS 4.7× · 680 compras/mes (+1,519%)": "ROAS 4.7× · 680 purchases/mo (+1,519%)",
    "120 MQLs/mes · CAC $88": "120 MQLs/mo · CAC $88",
    "480 MQLs/mes · CAC $29 (-67%)": "480 MQLs/mo · CAC $29 (-67%)",
  },
};

// PT-BR
DICT.pt = {
  "Dashboard": "Painel",
  "Resumen": "Resumo",
  "Calendario": "Calendário",
  "Generador": "Gerador",
  "Imágenes": "Imagens",
  "Videos": "Vídeos",
  "Feed": "Feed",
  "Banco": "Banco",
  "Banco de contenido": "Banco de conteúdo",
  "Analítica": "Análises",
  "Competencia": "Concorrência",
  "Competidores": "Concorrentes",
  "Escucha social": "Escuta social",
  "Cuentas sociales": "Contas sociais",
  "Marca": "Marca",
  "Seguridad": "Segurança",
  "API Keys": "Chaves de API",
  "Marketplace": "Marketplace",
  "SEO": "SEO",
  "Referidos": "Indicações",
  "Suscripción": "Assinatura",
  "Admin": "Admin",
  "NUEVO POST": "NOVO POST",
  "NUEVA": "NOVA",
  "NUEVO": "NOVO",
  "GUARDAR": "SALVAR",
  "CANCELAR": "CANCELAR",
  "ELIMINAR": "EXCLUIR",
  "CERRAR": "FECHAR",
  "EDITAR": "EDITAR",
  "VER": "VER",
  "CARGAR": "CARREGAR",
  "APLICAR": "APLICAR",
  "FILTRAR": "FILTRAR",
  "BUSCAR": "BUSCAR",
  "COPIAR": "COPIAR",
  "DESCARGAR": "BAIXAR",
  "PUBLICAR": "PUBLICAR",
  "PROGRAMAR": "AGENDAR",
  "APROBAR": "APROVAR",
  "RECHAZAR": "REJEITAR",
  "GENERAR": "GERAR",
  "CONECTAR": "CONECTAR",
  "DESCONECTAR": "DESCONECTAR",
  "SALIR": "SAIR",
  "CERRAR SESIÓN": "SAIR",
  "VOLVER": "VOLTAR",
  "SIGUIENTE": "PRÓXIMO",
  "Activo": "Ativo", "Inactivo": "Inativo", "Pendiente": "Pendente",
  "Aprobado": "Aprovado", "Rechazado": "Rejeitado", "Publicado": "Publicado",
  "Programado": "Agendado", "Fallido": "Falhou", "Procesando": "Processando",
  "Listo": "Pronto", "Entregado": "Entregue", "Borrador": "Rascunho",
  "Completado": "Concluído", "En proceso": "Em andamento",
  "Sí": "Sim", "No": "Não",
  "Bienvenido": "Bem-vindo",
  "Posts este mes": "Posts este mês",
  "Imágenes generadas": "Imagens geradas",
  "Videos generados": "Vídeos gerados",
  "Uso de tu plan": "Uso do plano",
  "Próximas publicaciones": "Próximas publicações",
  "Sin publicaciones programadas": "Sem publicações agendadas",
  "Crear mi primer post": "Criar meu primeiro post",
  "Atajos": "Atalhos",
  "Generar post": "Gerar post",
  "Generar imagen": "Gerar imagem",
  "Generar video": "Gerar vídeo",
  "Ver calendario": "Ver calendário",
  "Generador de contenido": "Gerador de conteúdo",
  "¿Sobre qué quieres publicar?": "Sobre o que quer publicar?",
  "Prompt": "Prompt", "Plataforma": "Plataforma", "Tipo de contenido": "Tipo de conteúdo",
  "Tono": "Tom", "Idioma": "Idioma", "Generando…": "Gerando…", "Variantes": "Variantes",
  "Copiar al portapapeles": "Copiar para área de transferência",
  "Guardar en banco": "Salvar no banco", "PLANTILLA": "MODELO",
  "Guardar como plantilla": "Salvar como modelo",
  "Hacer pública": "Tornar pública",
  "Añadir al calendario": "Adicionar ao calendário",
  "Post": "Post", "Hilo": "Thread", "Carrusel": "Carrossel",
  "Script": "Script", "Caption corto": "Legenda curta",
  "Generador de imágenes": "Gerador de imagens",
  "Describe la imagen": "Descreva a imagem",
  "Estilo": "Estilo", "Galería": "Galeria",
  "Sin imágenes aún": "Ainda sem imagens",
  "Generador de videos": "Gerador de vídeos",
  "Biblioteca de videos": "Biblioteca de vídeos",
  "Aspect ratio": "Proporção", "Duración": "Duração", "Modelo": "Modelo",
  "Frecuencia": "Frequência", "Diaria": "Diária", "Semanal": "Semanal",
  "Quincenal": "Quinzenal", "Personalizada": "Personalizada",
  "Guardar ajustes": "Salvar configurações",
  "Publicar este video": "Publicar este vídeo",
  "Elegir red": "Escolher rede",
  "Caption sugerido": "Legenda sugerida",
  "Arrastra para reprogramar": "Arraste para reagendar",
  "Aprobación pendiente": "Aprovação pendente",
  "Sin publicaciones en este día": "Sem publicações neste dia",
  "Detalle del post": "Detalhes do post",
  "Hora": "Hora", "Red": "Rede", "Contenido": "Conteúdo", "Video adjunto": "Vídeo anexo",
  "Feed de aprobación": "Feed de aprovação",
  "Posts pendientes": "Posts pendentes", "Sin pendientes": "Nada pendente",
  "Favoritos": "Favoritos", "Todos": "Todos",
  "Filtrar por red": "Filtrar por rede",
  "Sin contenido guardado": "Sem conteúdo salvo",
  "Analytics unificado": "Análises unificadas",
  "Impresiones totales": "Impressões totais",
  "Engagement total": "Engajamento total",
  "Crecimiento de seguidores": "Crescimento de seguidores",
  "Mejor contenido del mes": "Melhor conteúdo do mês",
  "Rango de fechas": "Período",
  "Últimos 30 días": "Últimos 30 dias",
  "Últimos 7 días": "Últimos 7 dias",
  "Radar de competidores": "Radar de concorrentes",
  "Añadir competidor": "Adicionar concorrente",
  "Handle o URL": "Handle ou URL",
  "Frecuencia de post": "Frequência de posts",
  "Tono detectado": "Tom detectado",
  "Sin competidores aún": "Ainda sem concorrentes",
  "Palabras clave": "Palavras-chave",
  "Menciones recientes": "Menções recentes",
  "Añadir keyword": "Adicionar palavra-chave",
  "Sin keywords aún": "Ainda sem palavras-chave",
  "Redes sociales": "Redes sociais",
  "Conectar cuenta": "Conectar conta",
  "Cuenta conectada": "Conta conectada",
  "Próximamente OAuth real": "OAuth real em breve",
  "Configuración de marca": "Configuração da marca",
  "Nombre de la marca": "Nome da marca",
  "Color primario": "Cor primária",
  "Tono de voz": "Tom de voz",
  "Temas preferidos": "Temas preferidos",
  "Palabras prohibidas": "Palavras proibidas",
  "Usar emojis": "Usar emojis",
  "Idioma de publicación": "Idioma de publicação",
  "Marcas": "Marcas", "Marca activa": "Marca ativa",
  "Tu código de referido": "Seu código de indicação",
  "Invitaciones": "Convites",
  "Recompensas acumuladas": "Recompensas acumuladas",
  "Copiar link": "Copiar link",
  "Plan actual": "Plano atual", "Cambiar plan": "Mudar plano",
  "Factura": "Fatura", "Histórico de pagos": "Histórico de pagamentos",
  "Video add-on": "Add-on de vídeo",
  "ACTIVO": "ATIVO", "INACTIVO": "INATIVO",
  "Mensual": "Mensal", "Anual": "Anual",
  "Activar": "Ativar", "Renovación": "Renovação",
  "Cancelar suscripción": "Cancelar assinatura",
  "Panel MRR": "Painel MRR", "MRR total": "MRR total",
  "Suscripciones activas": "Assinaturas ativas", "Churn": "Churn",
  "Seguridad de la cuenta": "Segurança da conta",
  "Autenticación 2 factores": "Autenticação de 2 fatores",
  "2FA activado": "2FA ativado", "2FA desactivado": "2FA desativado",
  "Activar 2FA": "Ativar 2FA", "Desactivar 2FA": "Desativar 2FA",
  "Escanea el QR con tu app de autenticación": "Escaneie o QR com seu app autenticador",
  "Código de 6 dígitos": "Código de 6 dígitos", "Verificar": "Verificar",
  "Gestiona tus llaves API": "Gerencie suas chaves de API",
  "Crear nueva key": "Criar nova chave",
  "Nombre de la key": "Nome da chave",
  "Revocar": "Revogar",
  "Copia tu secret ahora — no volverá a mostrarse": "Copie seu segredo agora — não será mostrado novamente",
  "Solo plan Agencia": "Apenas plano Agência",
  "Marketplace de plantillas": "Marketplace de modelos",
  "Explorar plantillas": "Explorar modelos",
  "Más populares": "Mais populares",
  "Más recientes": "Mais recentes",
  "Solo gratis": "Apenas grátis",
  "USAR": "USAR", "Usar plantilla": "Usar modelo",
  "Industria": "Setor", "Creada por": "Criado por",
  "Módulo SEO": "Módulo SEO",
  "Blog post IA": "Post de blog IA",
  "Auditoría on-page": "Auditoria on-page",
  "Auto-publicar a CMS": "Auto-publicar em CMS",
  "Título": "Título", "Meta descripción": "Meta descrição",
  "Palabra clave principal": "Palavra-chave principal",
  "Generar artículo": "Gerar artigo", "URL del sitio": "URL do site",
  "Auditar": "Auditar", "Score": "Pontuação",
  "Issues encontrados": "Problemas encontrados",
  "Conexiones activas": "Conexões ativas",
  "Nueva conexión": "Nova conexão",
  "Token API": "Token API", "Tipo de CMS": "Tipo de CMS",
  "Precios sin trampas.": "Preços sem pegadinhas.",
  "Elige tu plan. Añade el módulo de": "Escolha seu plano. Adicione o módulo de",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "se precisar — dobra o preço do plano e você ganha até 1 vídeo/dia.",
  "ABRIR CALCULADORA DE PRECIOS": "ABRIR CALCULADORA DE PREÇOS",
  "CON VIDEOS IA · 2×": "COM VÍDEOS IA · 2×",
  "VER DETALLES": "VER DETALHES",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PREÇO COM VÍDEO = 2× BASE · INCLUI ATÉ 30 VÍDEOS/MÊS · FREQUÊNCIA CONFIGURÁVEL",
  "DOSSIER 03 · MUESTRAS": "DOSSIÊ 03 · AMOSTRAS",
  "DOSSIER 03.2 · VOCES": "DOSSIÊ 03.2 · VOZES",
  "DOSSIER 04 · TARIFAS": "DOSSIÊ 04 · PREÇOS",
  "Así se ve tu contenido en cada red.": "Assim fica seu conteúdo em cada rede.",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Mockups reais do que a plataforma publica: vídeo vertical, feed de Instagram, carrossel e post do LinkedIn.",
  "El copy que enganchó a miles.": "O copy que engajou milhares.",
  "Generado por IA.": "Gerado por IA.",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, legendas e scripts já quebrando métricas globalmente. Todos saíram de um prompt de 2 linhas.",
  "GENERAR MI PRIMER POST GRATIS": "GERAR MEU PRIMEIRO POST GRÁTIS",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "SEM CARTÃO · CANCELE QUANDO QUISER",
  "ANTES": "ANTES", "DESPUÉS": "DEPOIS",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "1 red social": "1 rede social",
  "10 posts/mes generados": "10 posts/mês gerados",
  "Sin programación automática": "Sem agendamento automático",
  "Sin imágenes AI": "Sem imagens IA",
  "Sin videos IA": "Sem vídeos IA",
  "3 redes sociales": "3 redes sociais",
  "100 posts/mes": "100 posts/mês",
  "20 imágenes/mes": "20 imagens/mês",
  "Programación manual": "Agendamento manual",
  "Analytics básico": "Análises básicas",
  "Todas las redes sociales": "Todas as redes sociais",
  "500 posts/mes": "500 posts/mês",
  "100 imágenes/mes": "100 imagens/mês",
  "Programación automática": "Agendamento automático",
  "Monitor de 3 competidores": "Monitor de 3 concorrentes",
  "Modo autopilot": "Modo autopilot",
  "Posts ilimitados": "Posts ilimitados",
  "Múltiples marcas / clientes (hasta 5)": "Múltiplas marcas / clientes (até 5)",
  "API access": "Acesso à API",
  "White label opcional": "White label opcional",
  "Soporte prioritario": "Suporte prioritário",
  "+Video: hasta 30 videos/mes (1/día)": "+Vídeo: até 30 vídeos/mês (1/dia)",
  "EN VIVO": "AO VIVO", "GENERADO": "GERADO",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GERADO · 8S · AUTO-PUBLICADO 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GERADO · APROVADO AUTO · PUBLICADO 18:00",
  "CDMX · MÉXICO": "CDMX · MÉXICO",
  "2,340 SEGUIDORES · HACE 2H": "2.340 SEGUIDORES · HÁ 2H",
  "me gusta": "curtidas", "ver 42 comentarios": "ver 42 comentários",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 comentários · 67 compartilhamentos",
  "Café especialidad · CDMX": "Café especial · CDMX",
  "E-commerce ropa · Guadalajara": "E-commerce moda · Guadalajara",
  "B2B software · Medellín": "Software B2B · Medellín",
  "Logo casero · Canva": "Logo caseiro · Canva",
  "Identidad CIA Marketing®": "Identidade CIA Marketing®",
  "Sin guía de marca": "Sem guia de marca",
  "Branding + autopilot": "Branding + autopilot",
  "Solo landing · sin redes": "Só landing · sem redes",
  "Branding + LinkedIn auto": "Branding + LinkedIn auto",
  "2% CTR · 340 seguidores": "2% CTR · 340 seguidores",
  "9.4% CTR · 12,800 seguidores (+3,671%)": "9,4% CTR · 12.800 seguidores (+3.671%)",
  "ROAS 1.1× · 42 compras/mes": "ROAS 1,1× · 42 compras/mês",
  "ROAS 4.7× · 680 compras/mes (+1,519%)": "ROAS 4,7× · 680 compras/mês (+1.519%)",
  "120 MQLs/mes · CAC $88": "120 MQLs/mês · CAC $88",
  "480 MQLs/mes · CAC $29 (-67%)": "480 MQLs/mês · CAC $29 (-67%)",
};

// French — covers same keys
DICT.fr = Object.fromEntries(Object.entries(DICT.en).map(([k, _v]) => [k, _v])); // start from EN base, will be auto-overridden
// Core overrides for FR
Object.assign(DICT.fr, {
  "Dashboard": "Tableau de bord", "Resumen": "Aperçu", "Calendario": "Calendrier",
  "Generador": "Générateur", "Imágenes": "Images", "Videos": "Vidéos", "Feed": "Flux",
  "Banco": "Banque", "Banco de contenido": "Banque de contenu", "Analítica": "Analyses",
  "Competencia": "Concurrence", "Competidores": "Concurrents",
  "Escucha social": "Écoute sociale", "Cuentas sociales": "Comptes sociaux",
  "Marca": "Marque", "Seguridad": "Sécurité", "Referidos": "Parrainage", "Suscripción": "Abonnement",
  "NUEVO POST": "NOUVEAU POST", "NUEVA": "NOUVELLE", "NUEVO": "NOUVEAU",
  "GUARDAR": "ENREGISTRER", "CANCELAR": "ANNULER", "ELIMINAR": "SUPPRIMER",
  "CERRAR": "FERMER", "EDITAR": "MODIFIER", "VER": "VOIR", "CARGAR": "CHARGER",
  "APLICAR": "APPLIQUER", "FILTRAR": "FILTRER", "BUSCAR": "RECHERCHER",
  "COPIAR": "COPIER", "DESCARGAR": "TÉLÉCHARGER", "PUBLICAR": "PUBLIER",
  "PROGRAMAR": "PLANIFIER", "APROBAR": "APPROUVER", "RECHAZAR": "REJETER",
  "GENERAR": "GÉNÉRER", "CONECTAR": "CONNECTER", "DESCONECTAR": "DÉCONNECTER",
  "SALIR": "DÉCONNEXION", "CERRAR SESIÓN": "DÉCONNEXION", "VOLVER": "RETOUR", "SIGUIENTE": "SUIVANT",
  "Activo": "Actif", "Inactivo": "Inactif", "Pendiente": "En attente",
  "Aprobado": "Approuvé", "Rechazado": "Rejeté", "Publicado": "Publié",
  "Programado": "Planifié", "Fallido": "Échoué", "Procesando": "En cours",
  "Listo": "Prêt", "Entregado": "Livré", "Borrador": "Brouillon",
  "Completado": "Terminé", "En proceso": "En cours", "Sí": "Oui", "No": "Non",
  "Bienvenido": "Bienvenue", "Posts este mes": "Posts ce mois-ci",
  "Imágenes generadas": "Images générées", "Videos generados": "Vidéos générées",
  "Uso de tu plan": "Utilisation du plan", "Próximas publicaciones": "Prochaines publications",
  "Sin publicaciones programadas": "Aucune publication planifiée",
  "Crear mi primer post": "Créer mon premier post",
  "Atajos": "Raccourcis", "Ver calendario": "Voir le calendrier",
  "Generar post": "Générer un post", "Generar imagen": "Générer une image", "Generar video": "Générer une vidéo",
  "Generador de contenido": "Générateur de contenu",
  "¿Sobre qué quieres publicar?": "Sur quoi voulez-vous publier ?",
  "Plataforma": "Plateforme", "Tipo de contenido": "Type de contenu",
  "Tono": "Ton", "Idioma": "Langue", "Generando…": "Génération…", "Variantes": "Variantes",
  "Copiar al portapapeles": "Copier dans le presse-papier",
  "Guardar en banco": "Enregistrer dans la banque",
  "PLANTILLA": "MODÈLE", "Guardar como plantilla": "Enregistrer comme modèle",
  "Hacer pública": "Rendre publique", "Añadir al calendario": "Ajouter au calendrier",
  "Post": "Post", "Hilo": "Fil", "Carrusel": "Carrousel", "Script": "Script", "Caption corto": "Légende courte",
  "Generador de imágenes": "Générateur d'images",
  "Describe la imagen": "Décrivez l'image",
  "Estilo": "Style", "Galería": "Galerie", "Sin imágenes aún": "Pas encore d'images",
  "Generador de videos": "Générateur de vidéos",
  "Biblioteca de videos": "Bibliothèque vidéo",
  "Aspect ratio": "Format", "Duración": "Durée", "Modelo": "Modèle",
  "Frecuencia": "Fréquence", "Diaria": "Quotidienne", "Semanal": "Hebdomadaire",
  "Quincenal": "Bimensuelle", "Personalizada": "Personnalisée",
  "Guardar ajustes": "Enregistrer les paramètres",
  "Publicar este video": "Publier cette vidéo", "Elegir red": "Choisir un réseau",
  "Caption sugerido": "Légende suggérée",
  "Arrastra para reprogramar": "Glisser pour replanifier",
  "Aprobación pendiente": "Approbation en attente",
  "Sin publicaciones en este día": "Aucune publication ce jour-là",
  "Detalle del post": "Détails du post",
  "Hora": "Heure", "Red": "Réseau", "Contenido": "Contenu", "Video adjunto": "Vidéo jointe",
  "Feed de aprobación": "Flux d'approbation",
  "Posts pendientes": "Posts en attente", "Sin pendientes": "Rien en attente",
  "Favoritos": "Favoris", "Todos": "Tous", "Filtrar por red": "Filtrer par réseau",
  "Sin contenido guardado": "Aucun contenu enregistré",
  "Analytics unificado": "Analyses unifiées",
  "Impresiones totales": "Impressions totales", "Engagement total": "Engagement total",
  "Crecimiento de seguidores": "Croissance d'abonnés",
  "Mejor contenido del mes": "Meilleur contenu du mois",
  "Rango de fechas": "Plage de dates",
  "Últimos 30 días": "30 derniers jours", "Últimos 7 días": "7 derniers jours",
  "Radar de competidores": "Radar concurrentiel",
  "Añadir competidor": "Ajouter un concurrent",
  "Handle o URL": "Handle ou URL", "Frecuencia de post": "Fréquence de publication",
  "Tono detectado": "Ton détecté", "Sin competidores aún": "Aucun concurrent",
  "Palabras clave": "Mots-clés", "Menciones recientes": "Mentions récentes",
  "Añadir keyword": "Ajouter un mot-clé", "Sin keywords aún": "Aucun mot-clé",
  "Redes sociales": "Réseaux sociaux", "Conectar cuenta": "Connecter un compte",
  "Cuenta conectada": "Compte connecté", "Próximamente OAuth real": "OAuth réel bientôt",
  "Configuración de marca": "Configuration de marque",
  "Nombre de la marca": "Nom de marque", "Color primario": "Couleur primaire",
  "Tono de voz": "Ton de voix", "Temas preferidos": "Thèmes préférés",
  "Palabras prohibidas": "Mots interdits", "Usar emojis": "Utiliser des émojis",
  "Idioma de publicación": "Langue de publication",
  "Marcas": "Marques", "Marca activa": "Marque active",
  "Tu código de referido": "Votre code de parrainage",
  "Invitaciones": "Invitations", "Recompensas acumuladas": "Récompenses cumulées",
  "Copiar link": "Copier le lien",
  "Plan actual": "Plan actuel", "Cambiar plan": "Changer de plan",
  "Factura": "Facture", "Histórico de pagos": "Historique de paiements",
  "Video add-on": "Module vidéo",
  "ACTIVO": "ACTIF", "INACTIVO": "INACTIF",
  "Mensual": "Mensuel", "Anual": "Annuel",
  "Activar": "Activer", "Renovación": "Renouvellement",
  "Cancelar suscripción": "Annuler l'abonnement",
  "Panel MRR": "Panneau MRR", "MRR total": "MRR total",
  "Suscripciones activas": "Abonnements actifs", "Churn": "Churn",
  "Seguridad de la cuenta": "Sécurité du compte",
  "Autenticación 2 factores": "Authentification à 2 facteurs",
  "2FA activado": "2FA activé", "2FA desactivado": "2FA désactivé",
  "Activar 2FA": "Activer 2FA", "Desactivar 2FA": "Désactiver 2FA",
  "Escanea el QR con tu app de autenticación": "Scannez le QR avec votre app d'authentification",
  "Código de 6 dígitos": "Code à 6 chiffres", "Verificar": "Vérifier",
  "Gestiona tus llaves API": "Gérez vos clés API",
  "Crear nueva key": "Créer une nouvelle clé", "Nombre de la key": "Nom de la clé",
  "Revocar": "Révoquer",
  "Copia tu secret ahora — no volverá a mostrarse": "Copiez votre secret maintenant — il ne sera plus affiché",
  "Solo plan Agencia": "Plan Agence uniquement",
  "Marketplace de plantillas": "Marketplace de modèles",
  "Explorar plantillas": "Parcourir les modèles",
  "Más populares": "Plus populaires", "Más recientes": "Plus récents",
  "Solo gratis": "Gratuit uniquement",
  "USAR": "UTILISER", "Usar plantilla": "Utiliser le modèle",
  "Industria": "Secteur", "Creada por": "Créé par",
  "Módulo SEO": "Module SEO",
  "Blog post IA": "Article de blog IA",
  "Auditoría on-page": "Audit on-page",
  "Auto-publicar a CMS": "Auto-publier sur CMS",
  "Título": "Titre", "Meta descripción": "Méta-description",
  "Palabra clave principal": "Mot-clé principal",
  "Generar artículo": "Générer l'article", "URL del sitio": "URL du site",
  "Auditar": "Auditer", "Score": "Score",
  "Issues encontrados": "Problèmes trouvés",
  "Conexiones activas": "Connexions actives",
  "Nueva conexión": "Nouvelle connexion",
  "Token API": "Token API", "Tipo de CMS": "Type de CMS",
  "Precios sin trampas.": "Tarifs clairs. Sans pièges.",
  "Elige tu plan. Añade el módulo de": "Choisissez votre plan. Ajoutez le module",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "si besoin — il double le prix du plan et vous obtenez jusqu'à 1 vidéo/jour.",
  "ABRIR CALCULADORA DE PRECIOS": "OUVRIR LE CALCULATEUR DE PRIX",
  "CON VIDEOS IA · 2×": "AVEC VIDÉOS IA · 2×",
  "VER DETALLES": "VOIR LES DÉTAILS",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PRIX AVEC VIDÉO = 2× PRIX DE BASE · INCLUT JUSQU'À 30 VIDÉOS/MOIS · FRÉQUENCE CONFIGURABLE",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · ÉCHANTILLONS",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOIX",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · TARIFS",
  "Así se ve tu contenido en cada red.": "Voici à quoi ressemble votre contenu sur chaque réseau.",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Maquettes réelles de ce que la plateforme publie : vidéo verticale, feed Instagram, carrousel et post LinkedIn.",
  "El copy que enganchó a miles.": "Le copy qui a accroché des milliers.",
  "Generado por IA.": "Généré par IA.",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Accroches, légendes et scripts qui explosent les métriques à l'échelle mondiale. Tous issus d'un prompt de 2 lignes.",
  "GENERAR MI PRIMER POST GRATIS": "GÉNÉRER MON PREMIER POST GRATUIT",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "SANS CARTE · ANNULEZ À TOUT MOMENT",
  "ANTES": "AVANT", "DESPUÉS": "APRÈS",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "1 red social": "1 réseau social",
  "10 posts/mes generados": "10 posts/mois générés",
  "Sin programación automática": "Sans planification auto",
  "Sin imágenes AI": "Sans images IA",
  "Sin videos IA": "Sans vidéos IA",
  "3 redes sociales": "3 réseaux sociaux",
  "100 posts/mes": "100 posts/mois",
  "20 imágenes/mes": "20 images/mois",
  "Programación manual": "Planification manuelle",
  "Analytics básico": "Analyses basiques",
  "Todas las redes sociales": "Tous les réseaux sociaux",
  "500 posts/mes": "500 posts/mois",
  "100 imágenes/mes": "100 images/mois",
  "Programación automática": "Planification auto",
  "Monitor de 3 competidores": "Suivi de 3 concurrents",
  "Modo autopilot": "Mode pilote auto",
  "Posts ilimitados": "Posts illimités",
  "Múltiples marcas / clientes (hasta 5)": "Multiples marques / clients (jusqu'à 5)",
  "API access": "Accès API",
  "White label opcional": "Marque blanche optionnelle",
  "Soporte prioritario": "Support prioritaire",
  "+Video: hasta 30 videos/mes (1/día)": "+Vidéo : jusqu'à 30 vidéos/mois (1/jour)",
  "EN VIVO": "EN DIRECT", "GENERADO": "GÉNÉRÉ",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GÉNÉRÉ · 8S · AUTO-PUBLIÉ 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GÉNÉRÉ · AUTO-APPROUVÉ · PUBLIÉ 18:00",
  "CDMX · MÉXICO": "CDMX · MEXIQUE",
  "2,340 SEGUIDORES · HACE 2H": "2 340 ABONNÉS · IL Y A 2H",
  "me gusta": "j'aime", "ver 42 comentarios": "voir 42 commentaires",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 commentaires · 67 partages",
  "Café especialidad · CDMX": "Café de spécialité · CDMX",
  "E-commerce ropa · Guadalajara": "E-commerce mode · Guadalajara",
  "B2B software · Medellín": "Logiciel B2B · Medellín",
  "Logo casero · Canva": "Logo maison · Canva",
  "Identidad CIA Marketing®": "Identité CIA Marketing®",
  "Sin guía de marca": "Sans charte graphique",
  "Branding + autopilot": "Branding + pilote auto",
  "Solo landing · sin redes": "Landing seule · sans réseaux",
  "Branding + LinkedIn auto": "Branding + LinkedIn auto",
  "2% CTR · 340 seguidores": "2% CTR · 340 abonnés",
  "9.4% CTR · 12,800 seguidores (+3,671%)": "9,4% CTR · 12 800 abonnés (+3 671%)",
  "ROAS 1.1× · 42 compras/mes": "ROAS 1,1× · 42 achats/mois",
  "ROAS 4.7× · 680 compras/mes (+1,519%)": "ROAS 4,7× · 680 achats/mois (+1 519%)",
  "120 MQLs/mes · CAC $88": "120 MQLs/mois · CAC $88",
  "480 MQLs/mes · CAC $29 (-67%)": "480 MQLs/mois · CAC $29 (-67%)",
});

// German
DICT.de = Object.fromEntries(Object.entries(DICT.en).map(([k, _v]) => [k, _v]));
Object.assign(DICT.de, {
  "Dashboard": "Dashboard", "Resumen": "Übersicht", "Calendario": "Kalender",
  "Generador": "Generator", "Imágenes": "Bilder", "Videos": "Videos", "Feed": "Feed",
  "Banco": "Bank", "Banco de contenido": "Content-Bank", "Analítica": "Analysen",
  "Competencia": "Konkurrenz", "Competidores": "Konkurrenten",
  "Escucha social": "Social Listening", "Cuentas sociales": "Social Accounts",
  "Marca": "Marke", "Seguridad": "Sicherheit", "Referidos": "Empfehlungen", "Suscripción": "Abonnement",
  "NUEVO POST": "NEUER POST", "NUEVA": "NEU", "NUEVO": "NEU",
  "GUARDAR": "SPEICHERN", "CANCELAR": "ABBRECHEN", "ELIMINAR": "LÖSCHEN",
  "CERRAR": "SCHLIESSEN", "EDITAR": "BEARBEITEN", "VER": "ANSEHEN",
  "APLICAR": "ANWENDEN", "FILTRAR": "FILTERN", "BUSCAR": "SUCHEN",
  "COPIAR": "KOPIEREN", "DESCARGAR": "HERUNTERLADEN", "PUBLICAR": "VERÖFFENTLICHEN",
  "PROGRAMAR": "PLANEN", "APROBAR": "GENEHMIGEN", "RECHAZAR": "ABLEHNEN",
  "GENERAR": "GENERIEREN", "CONECTAR": "VERBINDEN", "DESCONECTAR": "TRENNEN",
  "SALIR": "ABMELDEN", "CERRAR SESIÓN": "ABMELDEN", "VOLVER": "ZURÜCK", "SIGUIENTE": "WEITER",
  "Activo": "Aktiv", "Inactivo": "Inaktiv", "Pendiente": "Ausstehend",
  "Aprobado": "Genehmigt", "Rechazado": "Abgelehnt", "Publicado": "Veröffentlicht",
  "Programado": "Geplant", "Procesando": "In Bearbeitung",
  "Listo": "Fertig", "Entregado": "Geliefert", "Borrador": "Entwurf",
  "Completado": "Abgeschlossen", "Sí": "Ja", "No": "Nein",
  "Bienvenido": "Willkommen", "Posts este mes": "Posts diesen Monat",
  "Imágenes generadas": "Generierte Bilder", "Videos generados": "Generierte Videos",
  "Uso de tu plan": "Plan-Nutzung", "Próximas publicaciones": "Kommende Posts",
  "Sin publicaciones programadas": "Keine geplanten Posts",
  "Crear mi primer post": "Meinen ersten Post erstellen",
  "Atajos": "Verknüpfungen", "Ver calendario": "Kalender ansehen",
  "Generar post": "Post generieren", "Generar imagen": "Bild generieren", "Generar video": "Video generieren",
  "Generador de contenido": "Content-Generator",
  "¿Sobre qué quieres publicar?": "Worüber möchtest du posten?",
  "Plataforma": "Plattform", "Tipo de contenido": "Content-Typ",
  "Tono": "Ton", "Idioma": "Sprache", "Variantes": "Varianten",
  "Copiar al portapapeles": "In die Zwischenablage kopieren",
  "Guardar en banco": "In Bank speichern",
  "PLANTILLA": "VORLAGE", "Guardar como plantilla": "Als Vorlage speichern",
  "Añadir al calendario": "Zum Kalender hinzufügen",
  "Post": "Post", "Hilo": "Thread", "Carrusel": "Karussell",
  "Generador de imágenes": "Bild-Generator",
  "Describe la imagen": "Bild beschreiben",
  "Estilo": "Stil", "Galería": "Galerie",
  "Generador de videos": "Video-Generator",
  "Biblioteca de videos": "Videobibliothek",
  "Duración": "Dauer", "Modelo": "Modell", "Frecuencia": "Häufigkeit",
  "Diaria": "Täglich", "Semanal": "Wöchentlich",
  "Publicar este video": "Dieses Video veröffentlichen",
  "Elegir red": "Netzwerk wählen", "Caption sugerido": "Vorgeschlagene Caption",
  "Hora": "Uhrzeit", "Red": "Netzwerk", "Contenido": "Inhalt",
  "Feed de aprobación": "Freigabe-Feed",
  "Posts pendientes": "Ausstehende Posts",
  "Favoritos": "Favoriten", "Todos": "Alle",
  "Analytics unificado": "Vereinheitlichte Analysen",
  "Impresiones totales": "Gesamtimpressionen", "Engagement total": "Gesamt-Engagement",
  "Crecimiento de seguidores": "Follower-Wachstum",
  "Mejor contenido del mes": "Bester Content des Monats",
  "Rango de fechas": "Datumsbereich",
  "Últimos 30 días": "Letzte 30 Tage", "Últimos 7 días": "Letzte 7 Tage",
  "Radar de competidores": "Wettbewerbs-Radar",
  "Añadir competidor": "Konkurrent hinzufügen",
  "Palabras clave": "Keywords", "Menciones recientes": "Aktuelle Erwähnungen",
  "Redes sociales": "Soziale Netzwerke", "Conectar cuenta": "Account verbinden",
  "Configuración de marca": "Markenkonfiguration",
  "Nombre de la marca": "Markenname", "Color primario": "Primärfarbe",
  "Tono de voz": "Tonalität", "Palabras prohibidas": "Verbotene Wörter",
  "Marcas": "Marken", "Marca activa": "Aktive Marke",
  "Tu código de referido": "Dein Empfehlungscode",
  "Plan actual": "Aktueller Plan", "Cambiar plan": "Plan wechseln",
  "Factura": "Rechnung", "Histórico de pagos": "Zahlungsverlauf",
  "Video add-on": "Video-Add-on",
  "ACTIVO": "AKTIV", "INACTIVO": "INAKTIV",
  "Mensual": "Monatlich", "Anual": "Jährlich",
  "Cancelar suscripción": "Abo kündigen",
  "Panel MRR": "MRR-Panel", "Suscripciones activas": "Aktive Abos",
  "Seguridad de la cuenta": "Kontosicherheit",
  "Autenticación 2 factores": "Zwei-Faktor-Authentifizierung",
  "2FA activado": "2FA aktiviert", "Activar 2FA": "2FA aktivieren", "Desactivar 2FA": "2FA deaktivieren",
  "Código de 6 dígitos": "6-stelliger Code", "Verificar": "Überprüfen",
  "Gestiona tus llaves API": "Verwalte deine API-Schlüssel",
  "Crear nueva key": "Neuen Schlüssel erstellen",
  "Revocar": "Widerrufen", "Solo plan Agencia": "Nur Agency-Plan",
  "Marketplace de plantillas": "Vorlagen-Marketplace",
  "Explorar plantillas": "Vorlagen durchsuchen",
  "Más populares": "Beliebteste", "Más recientes": "Neueste",
  "USAR": "VERWENDEN", "Usar plantilla": "Vorlage verwenden",
  "Módulo SEO": "SEO-Modul", "Blog post IA": "KI-Blogpost",
  "Auditoría on-page": "On-Page-Audit", "Auto-publicar a CMS": "Auto-Publish ins CMS",
  "Título": "Titel", "Meta descripción": "Meta-Beschreibung",
  "Palabra clave principal": "Hauptkeyword", "Generar artículo": "Artikel generieren",
  "URL del sitio": "Website-URL", "Auditar": "Auditieren",
  "Issues encontrados": "Gefundene Probleme",
  "Precios sin trampas.": "Klare Preise. Ohne Haken.",
  "Elige tu plan. Añade el módulo de": "Wähle deinen Plan. Füge das",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "Modul bei Bedarf hinzu — es verdoppelt den Planpreis und du bekommst bis zu 1 Video/Tag.",
  "ABRIR CALCULADORA DE PRECIOS": "PREISRECHNER ÖFFNEN",
  "CON VIDEOS IA · 2×": "MIT KI-VIDEOS · 2×",
  "VER DETALLES": "DETAILS ANZEIGEN",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* VIDEO-PREIS = 2× GRUNDPREIS · BIS ZU 30 VIDEOS/MONAT · KONFIGURIERBARE HÄUFIGKEIT",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · BEISPIELE",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · STIMMEN",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · PREISE",
  "Así se ve tu contenido en cada red.": "So sieht dein Content auf jedem Netzwerk aus.",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Echte Mockups dessen, was die Plattform veröffentlicht: vertikales Video, Instagram-Feed, Karussell und LinkedIn-Post.",
  "El copy que enganchó a miles.": "Der Copy, der Tausende gefesselt hat.",
  "Generado por IA.": "Von KI generiert.",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, Captions und Skripte, die bereits weltweit Metriken sprengen. Alle aus einem 2-Zeilen-Prompt.",
  "GENERAR MI PRIMER POST GRATIS": "MEINEN ERSTEN POST GRATIS GENERIEREN",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "KEINE KARTE · JEDERZEIT KÜNDBAR",
  "ANTES": "VORHER", "DESPUÉS": "NACHHER",
  "1 red social": "1 soziales Netzwerk",
  "10 posts/mes generados": "10 Posts/Monat generiert",
  "Sin programación automática": "Keine Auto-Planung",
  "Sin imágenes AI": "Keine KI-Bilder", "Sin videos IA": "Keine KI-Videos",
  "3 redes sociales": "3 soziale Netzwerke",
  "100 posts/mes": "100 Posts/Monat",
  "20 imágenes/mes": "20 Bilder/Monat",
  "Programación manual": "Manuelle Planung",
  "Analytics básico": "Basis-Analysen",
  "Todas las redes sociales": "Alle sozialen Netzwerke",
  "500 posts/mes": "500 Posts/Monat",
  "100 imágenes/mes": "100 Bilder/Monat",
  "Programación automática": "Auto-Planung",
  "Monitor de 3 competidores": "3 Konkurrenten-Monitor",
  "Modo autopilot": "Autopilot-Modus",
  "Posts ilimitados": "Unbegrenzte Posts",
  "Múltiples marcas / clientes (hasta 5)": "Mehrere Marken / Kunden (bis zu 5)",
  "API access": "API-Zugang",
  "White label opcional": "Optionales White Label",
  "Soporte prioritario": "Priority-Support",
  "EN VIVO": "LIVE", "GENERADO": "GENERIERT",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GENERIERT · 8S · AUTO-VERÖFFENTLICHT 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERIERT · AUTO-FREIGEGEBEN · VERÖFFENTLICHT 18:00",
  "2,340 SEGUIDORES · HACE 2H": "2.340 FOLLOWER · VOR 2H",
  "me gusta": "Likes",
  "Café especialidad · CDMX": "Specialty-Café · CDMX",
  "E-commerce ropa · Guadalajara": "Mode-E-Commerce · Guadalajara",
  "B2B software · Medellín": "B2B-Software · Medellín",
  "Logo casero · Canva": "Heim-Logo · Canva",
  "Sin guía de marca": "Ohne Markenleitfaden",
  "Solo landing · sin redes": "Nur Landing · keine Netzwerke",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
});

// Italian
DICT.it = Object.fromEntries(Object.entries(DICT.en).map(([k, _v]) => [k, _v]));
Object.assign(DICT.it, {
  "Dashboard": "Dashboard", "Resumen": "Panoramica", "Calendario": "Calendario",
  "Generador": "Generatore", "Imágenes": "Immagini", "Videos": "Video", "Feed": "Feed",
  "Banco": "Banca", "Banco de contenido": "Banca dei contenuti", "Analítica": "Analisi",
  "Competencia": "Concorrenza", "Competidores": "Concorrenti",
  "Escucha social": "Social listening", "Cuentas sociales": "Account social",
  "Marca": "Brand", "Seguridad": "Sicurezza", "Referidos": "Referral", "Suscripción": "Abbonamento",
  "NUEVO POST": "NUOVO POST", "NUEVA": "NUOVA", "NUEVO": "NUOVO",
  "GUARDAR": "SALVA", "CANCELAR": "ANNULLA", "ELIMINAR": "ELIMINA",
  "CERRAR": "CHIUDI", "EDITAR": "MODIFICA", "VER": "VEDI",
  "APLICAR": "APPLICA", "FILTRAR": "FILTRA", "BUSCAR": "CERCA",
  "COPIAR": "COPIA", "DESCARGAR": "SCARICA", "PUBLICAR": "PUBBLICA",
  "PROGRAMAR": "PROGRAMMA", "APROBAR": "APPROVA", "RECHAZAR": "RIFIUTA",
  "GENERAR": "GENERA", "CONECTAR": "CONNETTI", "DESCONECTAR": "DISCONNETTI",
  "SALIR": "ESCI", "CERRAR SESIÓN": "ESCI", "VOLVER": "INDIETRO", "SIGUIENTE": "AVANTI",
  "Activo": "Attivo", "Inactivo": "Inattivo", "Pendiente": "In attesa",
  "Aprobado": "Approvato", "Rechazado": "Rifiutato", "Publicado": "Pubblicato",
  "Programado": "Programmato", "Procesando": "In elaborazione",
  "Listo": "Pronto", "Entregado": "Consegnato", "Borrador": "Bozza",
  "Completado": "Completato", "Sí": "Sì", "No": "No",
  "Bienvenido": "Benvenuto", "Posts este mes": "Post questo mese",
  "Imágenes generadas": "Immagini generate", "Videos generados": "Video generati",
  "Uso de tu plan": "Utilizzo del piano", "Próximas publicaciones": "Prossime pubblicazioni",
  "Sin publicaciones programadas": "Nessun post programmato",
  "Crear mi primer post": "Crea il mio primo post",
  "Atajos": "Scorciatoie", "Ver calendario": "Vedi calendario",
  "Generar post": "Genera post", "Generar imagen": "Genera immagine", "Generar video": "Genera video",
  "Generador de contenido": "Generatore di contenuti",
  "¿Sobre qué quieres publicar?": "Su cosa vuoi pubblicare?",
  "Plataforma": "Piattaforma", "Tipo de contenido": "Tipo di contenuto",
  "Tono": "Tono", "Idioma": "Lingua", "Variantes": "Varianti",
  "Copiar al portapapeles": "Copia negli appunti",
  "Guardar en banco": "Salva nella banca",
  "PLANTILLA": "MODELLO", "Guardar como plantilla": "Salva come modello",
  "Añadir al calendario": "Aggiungi al calendario",
  "Post": "Post", "Hilo": "Thread", "Carrusel": "Carosello",
  "Generador de imágenes": "Generatore di immagini",
  "Describe la imagen": "Descrivi l'immagine",
  "Estilo": "Stile", "Galería": "Galleria",
  "Generador de videos": "Generatore di video",
  "Biblioteca de videos": "Libreria video",
  "Duración": "Durata", "Modelo": "Modello", "Frecuencia": "Frequenza",
  "Diaria": "Giornaliera", "Semanal": "Settimanale",
  "Publicar este video": "Pubblica questo video",
  "Hora": "Ora", "Red": "Rete", "Contenido": "Contenuto",
  "Feed de aprobación": "Feed di approvazione",
  "Favoritos": "Preferiti", "Todos": "Tutti",
  "Analytics unificado": "Analisi unificate",
  "Impresiones totales": "Impression totali", "Engagement total": "Engagement totale",
  "Crecimiento de seguidores": "Crescita follower",
  "Mejor contenido del mes": "Miglior contenuto del mese",
  "Rango de fechas": "Intervallo date",
  "Últimos 30 días": "Ultimi 30 giorni", "Últimos 7 días": "Ultimi 7 giorni",
  "Radar de competidores": "Radar concorrenti",
  "Añadir competidor": "Aggiungi concorrente",
  "Palabras clave": "Parole chiave", "Menciones recientes": "Menzioni recenti",
  "Redes sociales": "Reti social", "Conectar cuenta": "Connetti account",
  "Configuración de marca": "Configurazione brand",
  "Nombre de la marca": "Nome del brand", "Color primario": "Colore primario",
  "Tono de voz": "Tono di voce", "Palabras prohibidas": "Parole vietate",
  "Marcas": "Brand", "Marca activa": "Brand attivo",
  "Tu código de referido": "Il tuo codice referral",
  "Plan actual": "Piano attuale", "Cambiar plan": "Cambia piano",
  "Factura": "Fattura", "Histórico de pagos": "Storico pagamenti",
  "Video add-on": "Add-on video",
  "ACTIVO": "ATTIVO", "INACTIVO": "INATTIVO",
  "Mensual": "Mensile", "Anual": "Annuale",
  "Cancelar suscripción": "Annulla abbonamento",
  "Panel MRR": "Pannello MRR",
  "Seguridad de la cuenta": "Sicurezza account",
  "Autenticación 2 factores": "Autenticazione a 2 fattori",
  "Activar 2FA": "Attiva 2FA", "Desactivar 2FA": "Disattiva 2FA",
  "Verificar": "Verifica",
  "Gestiona tus llaves API": "Gestisci le tue chiavi API",
  "Crear nueva key": "Crea nuova chiave", "Revocar": "Revoca",
  "Marketplace de plantillas": "Marketplace dei modelli",
  "Más populares": "Più popolari", "Más recientes": "Più recenti",
  "USAR": "USA", "Usar plantilla": "Usa modello",
  "Módulo SEO": "Modulo SEO", "Blog post IA": "Blog post IA",
  "Auditoría on-page": "Audit on-page",
  "Auto-publicar a CMS": "Auto-pubblica su CMS",
  "Título": "Titolo", "Meta descripción": "Meta descrizione",
  "Palabra clave principal": "Parola chiave principale",
  "Generar artículo": "Genera articolo", "URL del sitio": "URL del sito",
  "Auditar": "Verifica", "Issues encontrados": "Problemi trovati",
  "Precios sin trampas.": "Prezzi chiari. Senza trucchi.",
  "Elige tu plan. Añade el módulo de": "Scegli il tuo piano. Aggiungi il modulo",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "se serve — raddoppia il prezzo del piano e ottieni fino a 1 video/giorno.",
  "ABRIR CALCULADORA DE PRECIOS": "APRI CALCOLATORE PREZZI",
  "CON VIDEOS IA · 2×": "CON VIDEO IA · 2×",
  "VER DETALLES": "VEDI DETTAGLI",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PREZZO CON VIDEO = 2× BASE · INCLUDE FINO A 30 VIDEO/MESE · FREQUENZA CONFIGURABILE",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · ESEMPI",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOCI",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · PREZZI",
  "Así se ve tu contenido en cada red.": "Ecco come appare il tuo contenuto su ogni rete.",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Mockup reali di ciò che la piattaforma pubblica: video verticale, feed Instagram, carosello e post LinkedIn.",
  "El copy que enganchó a miles.": "Il copy che ha agganciato migliaia.",
  "Generado por IA.": "Generato dall'IA.",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hook, caption e script che stanno rompendo le metriche a livello globale. Tutti da un prompt di 2 righe.",
  "GENERAR MI PRIMER POST GRATIS": "GENERA IL MIO PRIMO POST GRATIS",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "NESSUNA CARTA · ANNULLA QUANDO VUOI",
  "ANTES": "PRIMA", "DESPUÉS": "DOPO",
  "1 red social": "1 rete social",
  "10 posts/mes generados": "10 post/mese generati",
  "Sin programación automática": "Senza programmazione auto",
  "Sin imágenes AI": "Senza immagini IA", "Sin videos IA": "Senza video IA",
  "3 redes sociales": "3 reti social",
  "100 posts/mes": "100 post/mese",
  "20 imágenes/mes": "20 immagini/mese",
  "Programación manual": "Programmazione manuale",
  "Analytics básico": "Analisi basiche",
  "Todas las redes sociales": "Tutte le reti social",
  "500 posts/mes": "500 post/mese",
  "100 imágenes/mes": "100 immagini/mese",
  "Programación automática": "Programmazione auto",
  "Monitor de 3 competidores": "Monitor di 3 concorrenti",
  "Modo autopilot": "Modalità autopilot",
  "Posts ilimitados": "Post illimitati",
  "Múltiples marcas / clientes (hasta 5)": "Brand / clienti multipli (fino a 5)",
  "API access": "Accesso API",
  "White label opcional": "White label opzionale",
  "Soporte prioritario": "Supporto prioritario",
  "EN VIVO": "LIVE", "GENERADO": "GENERATO",
  "me gusta": "mi piace",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "ANTES": "PRIMA", "DESPUÉS": "DOPO",
});


// Auto-added extra keys
Object.assign(DICT.en ||= {}, {
  "AUTOMATIZACIÓN IA": "AI AUTOMATION",
  "MARCAS DEL DOSSIER": "DOSSIER BRANDS",
  "GESTIONAR MARCAS": "MANAGE BRANDS",
  "MARCA": "BRAND",
  "Marca activa actualizada": "Active brand updated",
  "Error al cambiar marca": "Error switching brand",
  "MENSUAL": "MONTHLY",
  "ANUAL": "ANNUAL",
  "Nuevo post": "New post",
  "NUEVO POST": "NEW POST",
  "Resumen": "Overview",
  "Bienvenido de vuelta": "Welcome back",
  "Uso de este mes": "This month usage",
  "posts generados": "posts generated",
  "imágenes creadas": "images created",
  "videos producidos": "videos produced",
  "Ver todos": "View all",
  "Hoy": "Today",
  "Esta semana": "This week",
  "Este mes": "This month",
  "Sin datos aún": "No data yet",
  "Inicia tu primer post": "Start your first post",
  "Generar ahora": "Generate now",
  "Accesos rápidos": "Quick access",
  "Nuevo contenido": "New content",
  "Enviar al calendario": "Send to calendar",
  "Programar post": "Schedule post",
  "Ver analytics": "View analytics",
  "Publicar ahora": "Publish now",
  "Pendiente aprobación": "Pending approval",
  "Ver en calendario": "View in calendar",
  "Agregar": "Add",
  "AGREGAR": "ADD",
  "Fecha": "Date",
  "Texto": "Text",
  "Red social": "Social network",
  "Guardando...": "Saving...",
  "Guardando…": "Saving…",
  "Crear": "Create",
  "CREAR": "CREATE",
  "Detalles": "Details",
  "DETALLES": "DETAILS",
  "Próximamente": "Coming soon",
  "PRÓXIMAMENTE": "COMING SOON",
  "Conectado": "Connected",
  "Desconectado": "Disconnected",
  "Cambiar color primario": "Change primary color",
  "Ajustes guardados": "Settings saved",
  "Error al guardar": "Error saving",
});
Object.assign(DICT.pt ||= {}, {
  "AUTOMATIZACIÓN IA": "AUTOMAÇÃO IA",
  "MARCAS DEL DOSSIER": "MARCAS DO DOSSIÊ",
  "GESTIONAR MARCAS": "GERENCIAR MARCAS",
  "MARCA": "MARCA",
  "Marca activa actualizada": "Marca ativa atualizada",
  "Error al cambiar marca": "Erro ao trocar marca",
  "MENSUAL": "MENSAL",
  "ANUAL": "ANUAL",
  "Nuevo post": "Novo post",
  "NUEVO POST": "NOVO POST",
  "Bienvenido de vuelta": "Bem-vindo de volta",
  "Uso de este mes": "Uso deste mês",
  "posts generados": "posts gerados",
  "imágenes creadas": "imagens criadas",
  "videos producidos": "vídeos produzidos",
  "Ver todos": "Ver todos",
  "Hoy": "Hoje",
  "Esta semana": "Esta semana",
  "Este mes": "Este mês",
  "Sin datos aún": "Sem dados ainda",
  "Inicia tu primer post": "Inicie seu primeiro post",
  "Generar ahora": "Gerar agora",
  "Accesos rápidos": "Acessos rápidos",
  "Agregar": "Adicionar",
  "AGREGAR": "ADICIONAR",
  "Fecha": "Data",
  "Texto": "Texto",
  "Guardando...": "Salvando...",
  "Guardando…": "Salvando…",
  "Crear": "Criar",
  "CREAR": "CRIAR",
  "Detalles": "Detalhes",
  "DETALLES": "DETALHES",
  "Próximamente": "Em breve",
  "PRÓXIMAMENTE": "EM BREVE",
  "Conectado": "Conectado",
  "Desconectado": "Desconectado",
  "Ajustes guardados": "Ajustes salvos",
  "Error al guardar": "Erro ao salvar",
});
Object.assign(DICT.fr ||= {}, {
  "AUTOMATIZACIÓN IA": "AUTOMATISATION IA",
  "MARCAS DEL DOSSIER": "MARQUES DU DOSSIER",
  "GESTIONAR MARCAS": "GÉRER LES MARQUES",
  "MARCA": "MARQUE",
  "Marca activa actualizada": "Marque active mise à jour",
  "Error al cambiar marca": "Erreur lors du changement de marque",
  "MENSUAL": "MENSUEL",
  "ANUAL": "ANNUEL",
  "Nuevo post": "Nouveau post",
  "NUEVO POST": "NOUVEAU POST",
  "Bienvenido de vuelta": "Content de vous revoir",
  "Uso de este mes": "Utilisation ce mois-ci",
  "posts generados": "posts générés",
  "imágenes creadas": "images créées",
  "videos producidos": "vidéos produites",
  "Ver todos": "Tout voir",
  "Hoy": "Aujourd'hui",
  "Esta semana": "Cette semaine",
  "Este mes": "Ce mois-ci",
  "Sin datos aún": "Pas encore de données",
  "Inicia tu primer post": "Démarrez votre premier post",
  "Generar ahora": "Générer maintenant",
  "Accesos rápidos": "Accès rapides",
  "Agregar": "Ajouter",
  "AGREGAR": "AJOUTER",
  "Fecha": "Date",
  "Texto": "Texte",
  "Guardando...": "Enregistrement...",
  "Guardando…": "Enregistrement…",
  "Crear": "Créer",
  "CREAR": "CRÉER",
  "Detalles": "Détails",
  "DETALLES": "DÉTAILS",
  "Próximamente": "Bientôt",
  "PRÓXIMAMENTE": "BIENTÔT",
  "Conectado": "Connecté",
  "Desconectado": "Déconnecté",
  "Ajustes guardados": "Paramètres enregistrés",
  "Error al guardar": "Erreur d'enregistrement",
});
Object.assign(DICT.de ||= {}, {
  "AUTOMATIZACIÓN IA": "KI-AUTOMATISIERUNG",
  "MARCAS DEL DOSSIER": "DOSSIER-MARKEN",
  "GESTIONAR MARCAS": "MARKEN VERWALTEN",
  "MARCA": "MARKE",
  "Marca activa actualizada": "Aktive Marke aktualisiert",
  "Error al cambiar marca": "Fehler beim Markenwechsel",
  "MENSUAL": "MONATLICH",
  "ANUAL": "JÄHRLICH",
  "Nuevo post": "Neuer Post",
  "NUEVO POST": "NEUER POST",
  "Bienvenido de vuelta": "Willkommen zurück",
  "Uso de este mes": "Nutzung diesen Monat",
  "posts generados": "Posts generiert",
  "imágenes creadas": "Bilder erstellt",
  "videos producidos": "Videos produziert",
  "Ver todos": "Alle ansehen",
  "Hoy": "Heute",
  "Esta semana": "Diese Woche",
  "Este mes": "Diesen Monat",
  "Sin datos aún": "Noch keine Daten",
  "Inicia tu primer post": "Starte deinen ersten Post",
  "Generar ahora": "Jetzt generieren",
  "Accesos rápidos": "Schnellzugriffe",
  "Agregar": "Hinzufügen",
  "AGREGAR": "HINZUFÜGEN",
  "Fecha": "Datum",
  "Texto": "Text",
  "Crear": "Erstellen",
  "CREAR": "ERSTELLEN",
  "Detalles": "Details",
  "DETALLES": "DETAILS",
  "Próximamente": "Demnächst",
  "PRÓXIMAMENTE": "DEMNÄCHST",
  "Conectado": "Verbunden",
  "Desconectado": "Getrennt",
  "Ajustes guardados": "Einstellungen gespeichert",
  "Error al guardar": "Fehler beim Speichern",
});
Object.assign(DICT.it ||= {}, {
  "AUTOMATIZACIÓN IA": "AUTOMAZIONE IA",
  "MARCAS DEL DOSSIER": "BRAND DEL DOSSIER",
  "GESTIONAR MARCAS": "GESTISCI BRAND",
  "MARCA": "BRAND",
  "Marca activa actualizada": "Brand attivo aggiornato",
  "Error al cambiar marca": "Errore nel cambio di brand",
  "MENSUAL": "MENSILE",
  "ANUAL": "ANNUALE",
  "Nuevo post": "Nuovo post",
  "NUEVO POST": "NUOVO POST",
  "Bienvenido de vuelta": "Bentornato",
  "Uso de este mes": "Utilizzo questo mese",
  "posts generados": "post generati",
  "imágenes creadas": "immagini create",
  "videos producidos": "video prodotti",
  "Ver todos": "Vedi tutti",
  "Hoy": "Oggi",
  "Esta semana": "Questa settimana",
  "Este mes": "Questo mese",
  "Sin datos aún": "Nessun dato ancora",
  "Inicia tu primer post": "Inizia il tuo primo post",
  "Generar ahora": "Genera ora",
  "Accesos rápidos": "Accessi rapidi",
  "Agregar": "Aggiungi",
  "AGREGAR": "AGGIUNGI",
  "Fecha": "Data",
  "Texto": "Testo",
  "Crear": "Crea",
  "CREAR": "CREA",
  "Detalles": "Dettagli",
  "DETALLES": "DETTAGLI",
  "Próximamente": "Presto",
  "PRÓXIMAMENTE": "PRESTO",
  "Conectado": "Connesso",
  "Desconectado": "Disconnesso",
  "Ajustes guardados": "Impostazioni salvate",
  "Error al guardar": "Errore nel salvataggio",
});


// Auto-translated batch (Iter 16)
Object.assign(DICT.en ||= {}, {
  "% DE MRR": "% OF MRR",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PRICE WITH VIDEO = 2× BASE PRICE · INCLUDES UP TO 30 VIDEOS/MONTH · CONFIGURABLE FREQUENCY",
  "1 video por día": "1 video per day",
  "2,340 SEGUIDORES · HACE 2H": "2,340 FOLLOWERS · 2H AGO",
  "2× el precio de tu plan": "2× the price of your plan",
  "30 días Pro": "30 days Pro",
  "30 días Pro gratis": "30 days Pro free",
  "30 días de Pro": "30 days of Pro",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 comments · 67 reposts",
  "ABRIR CALCULADORA DE PRECIOS": "OPEN PRICE CALCULATOR",
  "ACTIVAR ADD-ON DE VIDEO": "ACTIVATE VIDEO ADD-ON",
  "ADD-ON DE VIDEO IA ACTIVO": "AI VIDEO ADD-ON ACTIVE",
  "ADMIN · TELEMETRÍA FINANCIERA": "ADMIN · FINANCIAL TELEMETRY",
  "AGENDA · PRÓXIMOS": "SCHEDULE · UPCOMING",
  "ANTES": "BEFORE",
  "API pública · solo Agencia": "Public API · Agency only",
  "APROBAR Y PROGRAMAR": "APPROVE AND SCHEDULE",
  "ARCHIVO VACÍO": "EMPTY FILE",
  "ARCHIVO VISUAL · IA DE IMAGEN": "VISUAL FILE · IMAGE AI",
  "AUTOMATIZACIÓN IA": "AI AUTOMATION",
  "Activa el módulo de Video IA": "Activate the AI Video module",
  "Actualiza tu plan para desbloquear blog generator, keyword research y on-page audit.": "Upgrade your plan to unlock blog generator, keyword research, and on-page audit.",
  "Actívalo para proteger tu cuenta.": "Activate it to protect your account.",
  "Agrega al menos un keyword para ver actividad.": "Add at least one keyword to see activity.",
  "Agrega competidores para monitorearlos.": "Add competitors to monitor them.",
  "Algo falló.": "Something went wrong.",
  "Así se ve tu contenido en cada red.": "Here's how your content looks on each network.",
  "Autenticación de 2 factores": "2-factor authentication",
  "AÑADIR VIDEOS IA": "ADD AI VIDEOS",
  "Aún no has generado imágenes.": "You haven't generated images yet.",
  "Aún no hay keywords. Agrega al menos una.": "No keywords yet. Add at least one.",
  "Aún no tienes CMS conectado. Conecta uno para publicar automáticamente.": "You don't have a CMS connected yet. Connect one to publish automatically.",
  "BANDEJA VACÍA": "INBOX EMPTY",
  "BANDEJA · APROBACIÓN": "INBOX · APPROVAL",
  "BIBLIOTECA VACÍA": "LIBRARY EMPTY",
  "Banco de contenido": "Content bank",
  "Banco de imágenes IA": "AI Image Bank",
  "CADA CUÁNTOS DÍAS:": "HOW MANY DAYS:",
  "CARGANDO TELEMETRÍA…": "LOADING TELEMETRY…",
  "CDMX · MÉXICO": "CDMX · MÉXICO",
  "CIA MARKETING® CONVIERTE EL MD A HTML E INYECTA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBLE).": "CIA MARKETING® CONVERTS MD TO HTML AND INJECTS SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBLE).",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "CIA MARKETING® · OPERACIÓN": "CIA MARKETING® · OPERATION",
  "COLA · PENDIENTES DE APROBACIÓN": "QUEUE · PENDING APPROVAL",
  "CON VIDEOS IA · 2×": "WITH AI VIDEOS · 2×",
  "CONECTAR UN CMS · WORDPRESS / SHOPIFY": "CONNECT A CMS · WORDPRESS / SHOPIFY",
  "CONECTAR Y GUARDAR": "CONNECT AND SAVE",
  "CONTRASEÑA (MÍN 6)": "PASSWORD (MIN 6)",
  "COPIA ESTA CLAVE AHORA — NO SE VOLVERÁ A MOSTRAR": "COPY THIS KEY NOW — IT WILL NOT BE SHOWN AGAIN",
  "COPIAR CÓDIGO": "COPY CODE",
  "COPIAR LINK DE INVITACIÓN": "COPY INVITE LINK",
  "CREA TU CUENTA CIA MARKETING®": "CREATE YOUR CIA MARKETING® ACCOUNT",
  "CREA UNA CUSTOM APP EN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content": "CREATE A CUSTOM APP IN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content",
  "CREAR CUENTA PARA ELEGIR": "CREATE ACCOUNT TO CHOOSE",
  "Cada amigo que se registre con tu código, ambos ganan": "Every friend who registers with your code, both win",
  "Completa contraseña y código": "Complete password and code",
  "Completa los datos": "Complete the data",
  "Completa todos los campos requeridos": "Complete all required fields",
  "Conexión eliminada": "Connection deleted",
  "Conexión verificada y guardada": "Connection verified and saved",
  "Contraseña actual": "Current password",
  "Contraseña actualizada. Inicia sesión.": "Password updated. Log in.",
  "Crea una": "Create one",
  "CÓDIGO DE REFERIDO (OPCIONAL)": "REFERRAL CODE (OPTIONAL)",
  "Código 2FA actual · 6 dígitos": "Current 2FA code · 6 digits",
  "DESGLOSE POR PLAN": "BREAKDOWN BY PLAN",
  "DESPUÉS": "AFTER",
  "DETALLE POR RED": "DETAIL BY NETWORK",
  "DOCUMENTACIÓN · ENDPOINTS PÚBLICOS": "DOCUMENTATION · PUBLIC ENDPOINTS",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · SAMPLES",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOICES",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · RATES",
  "DURACIÓN": "DURATION",
  "Describe el tema del artículo": "Describe the article's topic",
  "Describe el tema del post": "Describe the post's topic",
  "Describe el tema para la imagen": "Describe the topic for the image",
  "Describe la imagen: fondo minimalista, producto en primer plano…": "Describe the image: minimalist background, product in foreground…",
  "Describe tu video con al menos 5 caracteres": "Describe your video with at least 5 characters",
  "DÍAS BONUS": "BONUS DAYS",
  "DÍAS PRO BONUS": "PRO BONUS DAYS",
  "EN VIVO": "LIVE",
  "ESPERANDO ÓRDENES": "AWAITING ORDERS",
  "ESTÁNDAR": "STANDARD",
  "Ej: Barista sirviendo café especialidad en CDMX, cámara lenta, luz cálida, enfoque suave en el vapor del café.": "Ex: Barista serving specialty coffee in CDMX, slow motion, warm light, soft focus on coffee steam.",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Ex: How to choose the best CRM for SMEs in 2026",
  "Ej: Lanzamiento de nuevo café frío para oficina en CDMX": "Ex: Launch of new cold coffee for office in CDMX",
  "Ej: Zapier producción": "Ex: Zapier production",
  "El copy que enganchó a miles.": "The copy that hooked thousands.",
  "El código debe tener 6 dígitos": "The code must have 6 digits",
  "El marketplace está apenas arrancando.": "The marketplace is just getting started.",
  "Elige red, tipo y describe el tema. La IA generará variantes listas para publicar.": "Choose network, type, and describe the topic. The AI will generate variants ready to publish.",
  "Elige tu plan": "Choose your plan",
  "Elige tu plan. Añade el módulo de": "Choose your plan. Add the module for",
  "Elige un blog post y una conexión": "Choose a blog post and a connection",
  "Escribe tu usuario": "Enter your username",
  "Escribe un prompt": "Write a prompt",
  "Español": "Spanish",
  "Español (MX)": "Spanish (MX)",
  "FLUJO EN VIVO · ÚLTIMAS MENCIONES": "LIVE FEED · LATEST MENTIONS",
  "GENERA UN APP PASSWORD EN: USUARIOS → PERFIL → APPLICATION PASSWORDS": "GENERATE AN APP PASSWORD IN: USERS → PROFILE → APPLICATION PASSWORDS",
  "GENERADO": "GENERATED",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GENERATED · 8S · AUTO-PUBLISHED 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERATED · AUTO-APPROVED · PUBLISHED 18:00",
  "GENERAR MI PRIMER POST GRATIS": "GENERATE MY FIRST FREE POST",
  "GESTIONAR MARCAS": "MANAGE BRANDS",
  "Genera artículos optimizados, encuentra keywords que valen la pena, y audita tu sitio web en minutos.": "Generate optimized articles, find valuable keywords, and audit your website in minutes.",
  "Genera keys para conectar integraciones externas. Cabecera:": "Generate keys to connect external integrations. Header:",
  "Genera tu primer video con IA.": "Generate your first AI video.",
  "Genera, programa y publica en todas tus redes sociales con IA. Sin contratar agencia.": "Generate, schedule, and publish on all your social media with AI. Without hiring an agency.",
  "Generado por IA.": "Generated by AI.",
  "Generador de contenido IA": "AI Content Generator",
  "Generador de videos IA": "AI Video Generator",
  "Guarda posts desde el Generador para reutilizarlos.": "Save posts from the Generator to reuse them.",
  "Guardado en el banco": "Saved to the bank",
  "Hasta 1 video/día": "Up to 1 video/day",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, captions, and scripts that are already breaking metrics worldwide. All came from a 2-line prompt.",
  "INGRESA EL CÓDIGO DE TU APP DE AUTENTICACIÓN": "ENTER THE CODE FROM YOUR AUTHENTICATION APP",
  "INICIA SESIÓN EN TU CUENTA": "LOG IN TO YOUR ACCOUNT",
  "INTELIGENCIA · MÉTRICAS": "INTELLIGENCE · METRICS",
  "Ingresa tu correo y te enviaremos un link para crear una contraseña nueva.": "Enter your email and we will send you a link to create a new password.",
  "Ingresa una URL": "Enter a URL",
  "Ingresa una keyword semilla": "Enter a seed keyword",
  "Inicia sesión": "Log in",
  "Invita y gana": "Invite & earn",
  "Invita y gana Pro gratis": "Invite & earn Pro for free",
  "LO QUE LES FUNCIONA": "WHAT WORKS FOR THEM",
  "La API REST (": "The REST API (",
  "La IA crea además el caption de Instagram, hook de TikTok, tweet y hashtags — listos para publicar.": "AI also creates the Instagram caption, TikTok hook, tweet, and hashtags — ready to publish.",
  "La IA tarda aproximadamente 2–5 min. Te avisamos cuando esté listo.": "AI takes approximately 2–5 min. We'll let you know when it's ready.",
  "MARCA": "BRAND",
  "MARCAS DEL DOSSIER": "DOSSIER BRANDS",
  "MISIÓN · GENERACIÓN": "MISSION · GENERATION",
  "Mi Empresa SA": "My Company SA",
  "Mi blog WordPress": "My WordPress blog",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Real mockups of what the platform publishes: vertical video, Instagram feed, carousel, and LinkedIn post.",
  "Monitor de competidores": "Competitor monitor",
  "Muchos pagos pendientes. Revisa el flujo de checkout.": "Many pending payments. Check the checkout flow.",
  "MÁXIMO MENSUAL CON ESTA FRECUENCIA": "MAXIMUM MONTHLY WITH THIS FREQUENCY",
  "Mínimo 2 caracteres": "Minimum 2 characters",
  "Módulo SEO": "SEO Module",
  "Módulo SEO · solo Pro y Agencia": "SEO Module · Pro and Agency only",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "NO CARD REQUIRED · CANCEL ANYTIME",
  "NOMBRE DE LA MARCA": "BRAND NAME",
  "NUEVA CONTRASEÑA (MÍN 6)": "NEW PASSWORD (MIN 6)",
  "No has creado ninguna key todavía.": "You haven't created any keys yet.",
  "No hay posts pendientes de aprobación.": "No posts pending approval.",
  "Nueva contraseña": "New password",
  "Nómbrala para identificarla después": "Name it to identify it later",
  "O ingresa esta clave manualmente:": "Or enter this key manually:",
  "OK, ya la guardé": "OK, I saved it",
  "OLVIDÉ MI CONTRASEÑA": "FORGOT MY PASSWORD",
  "OPERACIÓN · PANEL CENTRAL": "OPERATION · CENTRAL PANEL",
  "PAQUETE COMPLETO · LISTO PARA PUBLICAR": "COMPLETE PACKAGE · READY TO PUBLISH",
  "PASO 1 · ESCANEA ESTE CÓDIGO": "STEP 1 · SCAN THIS CODE",
  "PASO 2 · INGRESA EL CÓDIGO DE 6 DÍGITOS": "STEP 2 · ENTER THE 6-DIGIT CODE",
  "POR RED · IMPRESIONES": "PER NETWORK · IMPRESSIONS",
  "PRECIOS APROXIMADOS · CARGO REAL EN USD POR STRIPE ·": "APPROXIMATE PRICES · ACTUAL CHARGE IN USD BY STRIPE ·",
  "PROGRAMA DE REFERIDOS": "REFERRAL PROGRAM",
  "PROMPT · DESCRIBE EL VIDEO": "PROMPT · DESCRIBE THE VIDEO",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOL · HOW IT WORKS",
  "PUBLICAR BLOG POST EN UN CLIC": "PUBLISH BLOG POST IN ONE CLICK",
  "Paga 1 vez al año": "Pay 1 time per year",
  "Plantilla cargada en el generador": "Template loaded in the generator",
  "Plantilla cargada · edita y regenera": "Template loaded · edit and regenerate",
  "Precio claro. Sin letras chiquitas.": "Clear pricing. No small print.",
  "Precios sin trampas.": "No hidden fees.",
  "Programado para mañana a esta hora": "Scheduled for tomorrow at this time",
  "Protege tu cuenta con TOTP. Funciona con": "Protect your account with TOTP. Works with",
  "REQUIERE PLAN PAGO · ELIGE UN PLAN DE ABAJO CON LA OPCIÓN +VIDEO": "REQUIRES PAID PLAN · CHOOSE A PLAN BELOW WITH THE +VIDEO OPTION",
  "Recibimos tu pedido de": "We received your order for",
  "Recupera tu acceso": "Recover your access",
  "SALIR": "Log out",
  "SE APLICA A BOTONES, BADGES Y ACENTOS DEL DASHBOARD CUANDO ESTA MARCA ESTÁ ACTIVA.": "APPLIES TO BUTTONS, BADGES AND DASHBOARD ACCENTS WHEN THIS BRAND IS ACTIVE.",
  "SIN ITEMS": "NO ITEMS",
  "SIN MENCIONES": "NO MENTIONS",
  "SIN OBJETIVOS": "NO GOALS",
  "SIN REGISTROS": "NO RECORDS",
  "SIN VIDEO": "NO VIDEO",
  "Selecciona una marca para editarla.": "Select a brand to edit it.",
  "Servicio de Branding": "Branding Service",
  "Si no, usamos el primero disponible": "If not, we use the first available",
  "Sin issues críticos": "No critical issues",
  "Sin pagos confirmados todavía.": "No payments confirmed yet.",
  "Solicitud de acceso": "Access request",
  "Solo texto + imágenes": "Text + images only",
  "Suscripción y uso": "Subscription & usage",
  "Sé el primero en publicar una plantilla — desde el Generador, guarda tu mejor post como plantilla pública y ayuda a otras marcas a crecer.": "Be the first to publish a template — from the Generator, save your best post as a public template and help other brands grow.",
  "TELEMETRÍA · 14 DÍAS": "TELEMETRY · 14 DAYS",
  "TEMAS (MÁX 10, COMA)": "TOPICS (MAX 10, COMMA)",
  "TIPO DE CONTENIDO": "CONTENT TYPE",
  "TONO DE VOZ": "TONE OF VOICE",
  "TU CÓDIGO": "YOUR CODE",
  "Tienes el add-on de Video activo. Elige tu frecuencia máxima (nunca más de 1 video/día):": "You have the Video add-on active. Choose your maximum frequency (never more than 1 video/day):",
  "Tu cuenta está protegida.": "Your account is protected.",
  "Tu marca,": "Your brand,",
  "Tu plan": "Your plan",
  "Tú eliges frecuencia": "You choose frequency",
  "VER DETALLES": "VIEW DETAILS",
  "ZONA DE RIESGO · DESACTIVAR 2FA": "RISK ZONE · DISABLE 2FA",
  "cafeterías": "coffee shops",
  "café de especialidad": "specialty coffee",
  "con el código": "with the code",
  "me gusta": "likes",
  "mi marca, producto…": "my brand, product…",
  "quedó activo. Bienvenido al nivel superior.": "is now active. Welcome to the next level.",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "if you need it — double the plan price and get up to 1 video/day.",
  "tu@empresa.com": "your@company.com",
  "y cualquier app compatible.": "and any compatible app.",
  "y permite hasta": "and allows up to",
  "¿Cómo quieres pagar?": "How do you want to pay?",
  "¿Olvidaste tu contraseña?": "Forgot your password?",
  "¿Quieres videos IA?": "Do you want AI videos?",
  "¿TIENES CÓDIGO DE REFERIDO?": "DO YOU HAVE A REFERRAL CODE?",
  "ÚLTIMOS PAGOS CONFIRMADOS": "LATEST CONFIRMED PAYMENTS",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ TO SUBSCRIBE YOU NEED AN ACCOUNT ·",
});
Object.assign(DICT.pt ||= {}, {
  "% DE MRR": "% DO MRR",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PREÇO COM VÍDEO = 2× PREÇO BASE · INCLUI ATÉ 30 VÍDEOS/MÊS · FREQUÊNCIA CONFIGURÁVEL",
  "1 video por día": "1 vídeo por dia",
  "2,340 SEGUIDORES · HACE 2H": "2.340 SEGUIDORES · HÁ 2H",
  "2× el precio de tu plan": "2× o preço do seu plano",
  "30 días Pro": "30 dias Pro",
  "30 días Pro gratis": "30 dias Pro grátis",
  "30 días de Pro": "30 dias de Pro",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 comentários · 67 republicações",
  "ABRIR CALCULADORA DE PRECIOS": "ABRIR CALCULADORA DE PREÇOS",
  "ACTIVAR ADD-ON DE VIDEO": "ATIVAR ADD-ON DE VÍDEO",
  "ADD-ON DE VIDEO IA ACTIVO": "ADD-ON DE VÍDEO IA ATIVO",
  "ADMIN · TELEMETRÍA FINANCIERA": "ADMIN · TELEMETRIA FINANCEIRA",
  "AGENDA · PRÓXIMOS": "AGENDA · PRÓXIMOS",
  "ANTES": "ANTES",
  "API pública · solo Agencia": "API pública · apenas Agência",
  "APROBAR Y PROGRAMAR": "APROVAR E PROGRAMAR",
  "ARCHIVO VACÍO": "ARQUIVO VAZIO",
  "ARCHIVO VISUAL · IA DE IMAGEN": "ARQUIVO VISUAL · IA DE IMAGEM",
  "AUTOMATIZACIÓN IA": "AUTOMAÇÃO IA",
  "Activa el módulo de Video IA": "Ative o módulo de Vídeo IA",
  "Actualiza tu plan para desbloquear blog generator, keyword research y on-page audit.": "Atualize seu plano para desbloquear blog generator, keyword research e on-page audit.",
  "Actívalo para proteger tu cuenta.": "Ative-o para proteger sua conta.",
  "Agrega al menos un keyword para ver actividad.": "Adicione ao menos uma keyword para ver atividade.",
  "Agrega competidores para monitorearlos.": "Adicione concorrentes para monitorá-los.",
  "Algo falló.": "Algo deu errado.",
  "Así se ve tu contenido en cada red.": "Assim seu conteúdo aparece em cada rede.",
  "Autenticación de 2 factores": "Autenticação de 2 fatores",
  "AÑADIR VIDEOS IA": "ADICIONAR VÍDEOS IA",
  "Aún no has generado imágenes.": "Você ainda não gerou imagens.",
  "Aún no hay keywords. Agrega al menos una.": "Ainda não há keywords. Adicione ao menos uma.",
  "Aún no tienes CMS conectado. Conecta uno para publicar automáticamente.": "Você ainda não tem um CMS conectado. Conecte um para publicar automaticamente.",
  "BANDEJA VACÍA": "CAIXA DE ENTRADA VAZIA",
  "BANDEJA · APROBACIÓN": "CAIXA DE ENTRADA · APROVAÇÃO",
  "BIBLIOTECA VACÍA": "BIBLIOTECA VAZIA",
  "Banco de contenido": "Banco de conteúdo",
  "Banco de imágenes IA": "Banco de imagens IA",
  "CADA CUÁNTOS DÍAS:": "A CADA QUANTOS DIAS:",
  "CARGANDO TELEMETRÍA…": "CARREGANDO TELEMETRIA…",
  "CDMX · MÉXICO": "CDMX · MÉXICO",
  "CIA MARKETING® CONVIERTE EL MD A HTML E INYECTA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBLE).": "CIA MARKETING® CONVERTE MD PARA HTML E INJETA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATÍVEL).",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "CIA MARKETING® · OPERACIÓN": "CIA MARKETING® · OPERAÇÃO",
  "COLA · PENDIENTES DE APROBACIÓN": "FILA · PENDENTES DE APROVAÇÃO",
  "CON VIDEOS IA · 2×": "COM VÍDEOS IA · 2×",
  "CONECTAR UN CMS · WORDPRESS / SHOPIFY": "CONECTAR UM CMS · WORDPRESS / SHOPIFY",
  "CONECTAR Y GUARDAR": "CONECTAR E SALVAR",
  "CONTRASEÑA (MÍN 6)": "SENHA (MÍN 6)",
  "COPIA ESTA CLAVE AHORA — NO SE VOLVERÁ A MOSTRAR": "COPIE ESTA CHAVE AGORA — NÃO SERÁ EXIBIDA NOVAMENTE",
  "COPIAR CÓDIGO": "COPIAR CÓDIGO",
  "COPIAR LINK DE INVITACIÓN": "COPIAR LINK DE CONVITE",
  "CREA TU CUENTA CIA MARKETING®": "CRIE SUA CONTA CIA MARKETING®",
  "CREA UNA CUSTOM APP EN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content": "CRIE UM CUSTOM APP EM SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content",
  "CREAR CUENTA PARA ELEGIR": "CRIAR CONTA PARA ESCOLHER",
  "Cada amigo que se registre con tu código, ambos ganan": "Cada amigo que se registrar com seu código, ambos ganham",
  "Completa contraseña y código": "Complete senha e código",
  "Completa los datos": "Complete os dados",
  "Completa todos los campos requeridos": "Preencha todos os campos obrigatórios",
  "Conexión eliminada": "Conexão excluída",
  "Conexión verificada y guardada": "Conexão verificada e salva",
  "Contraseña actual": "Senha atual",
  "Contraseña actualizada. Inicia sesión.": "Senha atualizada. Faça login.",
  "Crea una": "Crie uma",
  "CÓDIGO DE REFERIDO (OPCIONAL)": "CÓDIGO DE INDICADO (OPCIONAL)",
  "Código 2FA actual · 6 dígitos": "Código 2FA atual · 6 dígitos",
  "DESGLOSE POR PLAN": "DETALHAMENTO POR PLANO",
  "DESPUÉS": "DEPOIS",
  "DETALLE POR RED": "DETALHE POR REDE",
  "DOCUMENTACIÓN · ENDPOINTS PÚBLICOS": "DOCUMENTAÇÃO · ENDPOINTS PÚBLICOS",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · AMOSTRAS",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOZES",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · TARIFAS",
  "DURACIÓN": "DURAÇÃO",
  "Describe el tema del artículo": "Descreva o tema do artigo",
  "Describe el tema del post": "Descreva o tema da publicação",
  "Describe el tema para la imagen": "Descreva o tema para a imagem",
  "Describe la imagen: fondo minimalista, producto en primer plano…": "Descreva a imagem: fundo minimalista, produto em primeiro plano…",
  "Describe tu video con al menos 5 caracteres": "Descreva seu vídeo com pelo menos 5 caracteres",
  "DÍAS BONUS": "DIAS BÔNUS",
  "DÍAS PRO BONUS": "DIAS PRO BÔNUS",
  "EN VIVO": "AO VIVO",
  "ESPERANDO ÓRDENES": "AGUARDANDO PEDIDOS",
  "ESTÁNDAR": "PADRÃO",
  "Ej: Barista sirviendo café especialidad en CDMX, cámara lenta, luz cálida, enfoque suave en el vapor del café.": "Ex: Barista servindo café especial em CDMX, câmera lenta, luz quente, foco suave no vapor do café.",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Ex: Como escolher o melhor CRM para PMEs em 2026",
  "Ej: Lanzamiento de nuevo café frío para oficina en CDMX": "Ex: Lançamento de novo café gelado para escritório em CDMX",
  "Ej: Zapier producción": "Ex: Produção Zapier",
  "El copy que enganchó a miles.": "O copy que atraiu milhares.",
  "El código debe tener 6 dígitos": "O código deve ter 6 dígitos",
  "El marketplace está apenas arrancando.": "O marketplace está apenas começando.",
  "Elige red, tipo y describe el tema. La IA generará variantes listas para publicar.": "Escolha rede, tipo e descreva o tema. A IA gerará variantes prontas para publicar.",
  "Elige tu plan": "Escolha seu plano",
  "Elige tu plan. Añade el módulo de": "Escolha seu plano. Adicione o módulo de",
  "Elige un blog post y una conexión": "Escolha um blog post e uma conexão",
  "Escribe tu usuario": "Digite seu usuário",
  "Escribe un prompt": "Escreva um prompt",
  "Español": "Espanhol",
  "Español (MX)": "Espanhol (MX)",
  "FLUJO EN VIVO · ÚLTIMAS MENCIONES": "FLUXO AO VIVO · ÚLTIMAS MENÇÕES",
  "GENERA UN APP PASSWORD EN: USUARIOS → PERFIL → APPLICATION PASSWORDS": "GENERE UMA APP PASSWORD EM: USUÁRIOS → PERFIL → APPLICATION PASSWORDS",
  "GENERADO": "GERADO",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GERADO · 8S · AUTO-PUBLICADO 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GERADO · APROVADO AUTO · PUBLICADO 18:00",
  "GENERAR MI PRIMER POST GRATIS": "GERAR MINHA PRIMEIRA PUBLICAÇÃO GRÁTIS",
  "GESTIONAR MARCAS": "GERENCIAR MARCAS",
  "Genera artículos optimizados, encuentra keywords que valen la pena, y audita tu sitio web en minutos.": "Gere artigos otimizados, encontre keywords que valem a pena e audite seu site em minutos.",
  "Genera keys para conectar integraciones externas. Cabecera:": "Gere chaves para conectar integrações externas. Cabeçalho:",
  "Genera tu primer video con IA.": "Gere seu primeiro vídeo com IA.",
  "Genera, programa y publica en todas tus redes sociales con IA. Sin contratar agencia.": "Gere, programe e publique em todas as suas redes sociais com IA. Sem contratar agência.",
  "Generado por IA.": "Gerado por IA.",
  "Generador de contenido IA": "Gerador de conteúdo IA",
  "Generador de videos IA": "Gerador de vídeos IA",
  "Guarda posts desde el Generador para reutilizarlos.": "Guarde posts do Gerador para reutilizá-los.",
  "Guardado en el banco": "Salvo no banco",
  "Hasta 1 video/día": "Até 1 vídeo/dia",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, captions e scripts que já estão batendo métricas globalmente. Todos saíram de um prompt de 2 linhas.",
  "INGRESA EL CÓDIGO DE TU APP DE AUTENTICACIÓN": "DIGITE O CÓDIGO DO SEU APP DE AUTENTICAÇÃO",
  "INICIA SESIÓN EN TU CUENTA": "FAÇA LOGIN NA SUA CONTA",
  "INTELIGENCIA · MÉTRICAS": "INTELIGÊNCIA · MÉTRICAS",
  "Ingresa tu correo y te enviaremos un link para crear una contraseña nueva.": "Digite seu e-mail e enviaremos um link para criar uma nova senha.",
  "Ingresa una URL": "Insira uma URL",
  "Ingresa una keyword semilla": "Insira uma palavra-chave semente",
  "Inicia sesión": "Fazer login",
  "Invita y gana": "Convide e ganhe",
  "Invita y gana Pro gratis": "Convide e ganhe Pro grátis",
  "LO QUE LES FUNCIONA": "O QUE FUNCIONA PARA ELES",
  "La API REST (": "A API REST (",
  "La IA crea además el caption de Instagram, hook de TikTok, tweet y hashtags — listos para publicar.": "A IA também cria a legenda do Instagram, o hook do TikTok, o tweet e as hashtags — prontos para publicar.",
  "La IA tarda aproximadamente 2–5 min. Te avisamos cuando esté listo.": "A IA leva aproximadamente 2–5 min. Avisaremos quando estiver pronto.",
  "MARCA": "MARCA",
  "MARCAS DEL DOSSIER": "MARCAS DO DOSSIER",
  "MISIÓN · GENERACIÓN": "MISSÃO · GERAÇÃO",
  "Mi Empresa SA": "Minha Empresa S.A.",
  "Mi blog WordPress": "Meu blog WordPress",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Mockups reais do que a plataforma publica: vídeo vertical, feed do Instagram, carrossel e post do LinkedIn.",
  "Monitor de competidores": "Monitor de concorrentes",
  "Muchos pagos pendientes. Revisa el flujo de checkout.": "Muitos pagamentos pendentes. Verifique o fluxo de checkout.",
  "MÁXIMO MENSUAL CON ESTA FRECUENCIA": "MÁXIMO MENSAL COM ESTA FREQUÊNCIA",
  "Mínimo 2 caracteres": "Mínimo 2 caracteres",
  "Módulo SEO": "Módulo SEO",
  "Módulo SEO · solo Pro y Agencia": "Módulo SEO · somente Pro e Agência",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "NÃO REQUER CARTÃO · CANCELE QUANDO QUISER",
  "NOMBRE DE LA MARCA": "NOME DA MARCA",
  "NUEVA CONTRASEÑA (MÍN 6)": "NOVA SENHA (MÍN 6)",
  "No has creado ninguna key todavía.": "Você ainda não criou nenhuma key.",
  "No hay posts pendientes de aprobación.": "Não há posts pendentes de aprovação.",
  "Nueva contraseña": "Nova senha",
  "Nómbrala para identificarla después": "Nomeie-a para identificá-la depois",
  "O ingresa esta clave manualmente:": "Ou insira esta chave manualmente:",
  "OK, ya la guardé": "OK, já salvei",
  "OLVIDÉ MI CONTRASEÑA": "ESQUECI MINHA SENHA",
  "OPERACIÓN · PANEL CENTRAL": "OPERAÇÃO · PAINEL CENTRAL",
  "PAQUETE COMPLETO · LISTO PARA PUBLICAR": "PACOTE COMPLETO · PRONTO PARA PUBLICAR",
  "PASO 1 · ESCANEA ESTE CÓDIGO": "PASSO 1 · ESCANEIE ESTE CÓDIGO",
  "PASO 2 · INGRESA EL CÓDIGO DE 6 DÍGITOS": "PASSO 2 · INSIRA O CÓDIGO DE 6 DÍGITOS",
  "POR RED · IMPRESIONES": "POR REDE · IMPRESSÕES",
  "PRECIOS APROXIMADOS · CARGO REAL EN USD POR STRIPE ·": "PREÇOS APROXIMADOS · COBRANÇA REAL EM USD VIA STRIPE ·",
  "PROGRAMA DE REFERIDOS": "PROGRAMA DE INDICAÇÃO",
  "PROMPT · DESCRIBE EL VIDEO": "PROMPT · DESCREVA O VÍDEO",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOLO · COMO FUNCIONA",
  "PUBLICAR BLOG POST EN UN CLIC": "PUBLICAR BLOG POST EM UM CLIQUE",
  "Paga 1 vez al año": "Pague 1 vez ao ano",
  "Plantilla cargada en el generador": "Modelo carregado no gerador",
  "Plantilla cargada · edita y regenera": "Modelo carregado · edite e regenere",
  "Precio claro. Sin letras chiquitas.": "Preço claro. Sem letras miúdas.",
  "Precios sin trampas.": "Preços sem pegadinhas.",
  "Programado para mañana a esta hora": "Programado para amanhã a esta hora",
  "Protege tu cuenta con TOTP. Funciona con": "Proteja sua conta com TOTP. Funciona com",
  "REQUIERE PLAN PAGO · ELIGE UN PLAN DE ABAJO CON LA OPCIÓN +VIDEO": "REQUER UM PLANO PAGO · ESCOLHA UM PLANO ABAIXO COM A OPÇÃO +VÍDEO",
  "Recibimos tu pedido de": "Recebemos seu pedido de",
  "Recupera tu acceso": "Recupere seu acesso",
  "SALIR": "SAIR",
  "SE APLICA A BOTONES, BADGES Y ACENTOS DEL DASHBOARD CUANDO ESTA MARCA ESTÁ ACTIVA.": "APLICA-SE A BOTÕES, BADGES E DESTAQUES DO DASHBOARD QUANDO ESTA MARCA ESTÁ ATIVA.",
  "SIN ITEMS": "SEM ITENS",
  "SIN MENCIONES": "SEM MENÇÕES",
  "SIN OBJETIVOS": "SEM OBJETIVOS",
  "SIN REGISTROS": "SEM REGISTROS",
  "SIN VIDEO": "SEM VÍDEO",
  "Selecciona una marca para editarla.": "Selecione uma marca para editá-la.",
  "Servicio de Branding": "Serviço de Branding",
  "Si no, usamos el primero disponible": "Se não, usamos o primeiro disponível",
  "Sin issues críticos": "Sem problemas críticos",
  "Sin pagos confirmados todavía.": "Nenhum pagamento confirmado ainda.",
  "Solicitud de acceso": "Solicitação de acesso",
  "Solo texto + imágenes": "Apenas texto + imagens",
  "Suscripción y uso": "Assinatura e uso",
  "Sé el primero en publicar una plantilla — desde el Generador, guarda tu mejor post como plantilla pública y ayuda a otras marcas a crecer.": "Seja o primeiro a publicar um modelo — no Gerador, salve seu melhor post como um modelo público e ajude outras marcas a crescer.",
  "TELEMETRÍA · 14 DÍAS": "TELEMETRIA · 14 DIAS",
  "TEMAS (MÁX 10, COMA)": "TEMAS (MÁX 10, VÍRGULA)",
  "TIPO DE CONTENIDO": "TIPO DE CONTEÚDO",
  "TONO DE VOZ": "TOM DE VOZ",
  "TU CÓDIGO": "SEU CÓDIGO",
  "Tienes el add-on de Video activo. Elige tu frecuencia máxima (nunca más de 1 video/día):": "Você tem o add-on de Vídeo ativo. Escolha sua frequência máxima (nunca mais de 1 vídeo/dia):",
  "Tu cuenta está protegida.": "Sua conta está protegida.",
  "Tu marca,": "Sua marca,",
  "Tu plan": "Seu plano",
  "Tú eliges frecuencia": "Você escolhe a frequência",
  "VER DETALLES": "VER DETALHES",
  "ZONA DE RIESGO · DESACTIVAR 2FA": "ZONA DE RISCO · DESATIVAR 2FA",
  "cafeterías": "cafeterias",
  "café de especialidad": "café especial",
  "con el código": "com o código",
  "me gusta": "curtidas",
  "mi marca, producto…": "minha marca, produto…",
  "quedó activo. Bienvenido al nivel superior.": "ficou ativo. Bem-vindo ao nível superior.",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "se precisar — duplique o preço do plano e obtenha até 1 vídeo/dia.",
  "tu@empresa.com": "seu@empresa.com",
  "y cualquier app compatible.": "e qualquer app compatível.",
  "y permite hasta": "e permite até",
  "¿Cómo quieres pagar?": "Como você quer pagar?",
  "¿Olvidaste tu contraseña?": "Esqueceu sua senha?",
  "¿Quieres videos IA?": "Quer vídeos de IA?",
  "¿TIENES CÓDIGO DE REFERIDO?": "VOCÊ TEM CÓDIGO DE REFERÊNCIA?",
  "ÚLTIMOS PAGOS CONFIRMADOS": "ÚLTIMOS PAGAMENTOS CONFIRMADOS",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ PARA CONTRATAR VOCÊ PRECISA DE UMA CONTA ·",
});
Object.assign(DICT.fr ||= {}, {
  "% DE MRR": "% DE MRR",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PRIX AVEC VIDÉO = 2× PRIX DE BASE · INCLUT JUSQU'À 30 VIDÉOS/MOIS · FRÉQUENCE CONFIGURABLE",
  "1 video por día": "1 vidéo par jour",
  "2,340 SEGUIDORES · HACE 2H": "2 340 ABONNÉS · IL Y A 2H",
  "2× el precio de tu plan": "2× le prix de votre plan",
  "30 días Pro": "30 jours Pro",
  "30 días Pro gratis": "30 jours Pro gratuits",
  "30 días de Pro": "30 jours de Pro",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 commentaires · 67 partages",
  "ABRIR CALCULADORA DE PRECIOS": "OUVRIR LA CALCULATRICE DE PRIX",
  "ACTIVAR ADD-ON DE VIDEO": "ACTIVER L'ADD-ON VIDÉO",
  "ADD-ON DE VIDEO IA ACTIVO": "ADD-ON VIDÉO IA ACTIF",
  "ADMIN · TELEMETRÍA FINANCIERA": "ADMIN · TÉLÉMÉTRIE FINANCIÈRE",
  "AGENDA · PRÓXIMOS": "AGENDA · À VENIR",
  "ANTES": "AVANT",
  "API pública · solo Agencia": "API publique · uniquement Agence",
  "APROBAR Y PROGRAMAR": "APPROUVER ET PROGRAMMER",
  "ARCHIVO VACÍO": "FICHIER VIDE",
  "ARCHIVO VISUAL · IA DE IMAGEN": "FICHIER VISUEL · IA D'IMAGE",
  "AUTOMATIZACIÓN IA": "AUTOMATISATION IA",
  "Activa el módulo de Video IA": "Activez le module Vidéo IA",
  "Actualiza tu plan para desbloquear blog generator, keyword research y on-page audit.": "Mettez à niveau votre plan pour débloquer blog generator, keyword research et on-page audit.",
  "Actívalo para proteger tu cuenta.": "Activez-le pour protéger votre compte.",
  "Agrega al menos un keyword para ver actividad.": "Ajoutez au moins un mot-clé pour voir l'activité.",
  "Agrega competidores para monitorearlos.": "Ajoutez des concurrents pour les surveiller.",
  "Algo falló.": "Quelque chose a échoué.",
  "Así se ve tu contenido en cada red.": "Voici à quoi ressemble votre contenu sur chaque réseau.",
  "Autenticación de 2 factores": "Authentification à 2 facteurs",
  "AÑADIR VIDEOS IA": "AJOUTER DES VIDÉOS IA",
  "Aún no has generado imágenes.": "Vous n'avez pas encore généré d'images.",
  "Aún no hay keywords. Agrega al menos una.": "Il n'y a pas encore de mots-clés. Ajoutez-en au moins un.",
  "Aún no tienes CMS conectado. Conecta uno para publicar automáticamente.": "Vous n'avez pas encore de CMS connecté. Connectez-en un pour publier automatiquement.",
  "BANDEJA VACÍA": "BOÎTE DE RÉCEPTION VIDE",
  "BANDEJA · APROBACIÓN": "FILE D'ATTENTE · APPROBATION",
  "BIBLIOTECA VACÍA": "BIBLIOTHÈQUE VIDE",
  "Banco de contenido": "Banque de contenu",
  "Banco de imágenes IA": "Banque d'images IA",
  "CADA CUÁNTOS DÍAS:": "TOUS LES COMBIEN DE JOURS :",
  "CARGANDO TELEMETRÍA…": "CHARGEMENT TÉLÉMÉTRIE…",
  "CDMX · MÉXICO": "CDMX · MEXIQUE",
  "CIA MARKETING® CONVIERTE EL MD A HTML E INYECTA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBLE).": "CIA MARKETING® CONVERTIT LE MD EN HTML ET INJECTE SCHEMA.ORG JSON-LD + META TAGS (COMPATIBLE YOAST).",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "CIA MARKETING® · OPERACIÓN": "CIA MARKETING® · OPÉRATION",
  "COLA · PENDIENTES DE APROBACIÓN": "FILE D'ATTENTE · EN ATTENTE D'APPROBATION",
  "CON VIDEOS IA · 2×": "AVEC VIDÉOS IA · 2×",
  "CONECTAR UN CMS · WORDPRESS / SHOPIFY": "CONNECTER UN CMS · WORDPRESS / SHOPIFY",
  "CONECTAR Y GUARDAR": "CONNECTER ET ENREGISTRER",
  "CONTRASEÑA (MÍN 6)": "MOT DE PASSE (MIN 6)",
  "COPIA ESTA CLAVE AHORA — NO SE VOLVERÁ A MOSTRAR": "COPIEZ CETTE CLÉ MAINTENANT — NE SERA PLUS AFFICHÉE",
  "COPIAR CÓDIGO": "COPIER LE CODE",
  "COPIAR LINK DE INVITACIÓN": "COPIER LE LIEN D'INVITATION",
  "CREA TU CUENTA CIA MARKETING®": "CRÉEZ VOTRE COMPTE CIA MARKETING®",
  "CREA UNA CUSTOM APP EN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content": "CRÉEZ UNE CUSTOM APP DANS SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content",
  "CREAR CUENTA PARA ELEGIR": "CRÉER UN COMPTE POUR CHOISIR",
  "Cada amigo que se registre con tu código, ambos ganan": "Chaque ami qui s'inscrit avec votre code, vous gagnez tous les deux",
  "Completa contraseña y código": "Complétez le mot de passe et le code",
  "Completa los datos": "Complétez les données",
  "Completa todos los campos requeridos": "Complétez tous les champs requis",
  "Conexión eliminada": "Connexion supprimée",
  "Conexión verificada y guardada": "Connexion vérifiée et enregistrée",
  "Contraseña actual": "Mot de passe actuel",
  "Contraseña actualizada. Inicia sesión.": "Mot de passe mis à jour. Connectez-vous.",
  "Crea una": "Créez-en une",
  "CÓDIGO DE REFERIDO (OPCIONAL)": "CODE DE PARRAINAGE (OPTIONNEL)",
  "Código 2FA actual · 6 dígitos": "Code 2FA actuel · 6 chiffres",
  "DESGLOSE POR PLAN": "RÉPARTITION PAR PLAN",
  "DESPUÉS": "APRÈS",
  "DETALLE POR RED": "DÉTAIL PAR RÉSEAU",
  "DOCUMENTACIÓN · ENDPOINTS PÚBLICOS": "DOCUMENTATION · ENDPOINTS PUBLICS",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · ÉCHANTILLONS",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOIX",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · TARIFS",
  "DURACIÓN": "DURÉE",
  "Describe el tema del artículo": "Décrivez le thème de l'article",
  "Describe el tema del post": "Décrivez le thème du post",
  "Describe el tema para la imagen": "Décrivez le thème pour l'image",
  "Describe la imagen: fondo minimalista, producto en primer plano…": "Décrivez l'image : fond minimaliste, produit au premier plan…",
  "Describe tu video con al menos 5 caracteres": "Décrivez votre vidéo avec au moins 5 caractères",
  "DÍAS BONUS": "JOURS BONUS",
  "DÍAS PRO BONUS": "JOURS PRO BONUS",
  "EN VIVO": "EN DIRECT",
  "ESPERANDO ÓRDENES": "EN ATTENTE DE COMMANDES",
  "ESTÁNDAR": "STANDARD",
  "Ej: Barista sirviendo café especialidad en CDMX, cámara lenta, luz cálida, enfoque suave en el vapor del café.": "Ex: Barista servant un café de spécialité à CDMX, ralenti, lumière chaude, mise au point douce sur la vapeur du café.",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Ex: Comment choisir le meilleur CRM pour PME en 2026",
  "Ej: Lanzamiento de nuevo café frío para oficina en CDMX": "Ex: Lancement d'un nouveau café froid pour bureau à CDMX",
  "Ej: Zapier producción": "Ex: Production Zapier",
  "El copy que enganchó a miles.": "Le copy qui a accroché des milliers de personnes.",
  "El código debe tener 6 dígitos": "Le code doit avoir 6 chiffres",
  "El marketplace está apenas arrancando.": "Le marketplace est à peine en train de démarrer.",
  "Elige red, tipo y describe el tema. La IA generará variantes listas para publicar.": "Choisissez le réseau, le type et décrivez le thème. L'IA générera des variantes prêtes à être publiées.",
  "Elige tu plan": "Choisissez votre plan",
  "Elige tu plan. Añade el módulo de": "Choisissez votre plan. Ajoutez le module de",
  "Elige un blog post y una conexión": "Choisissez un article de blog et une connexion",
  "Escribe tu usuario": "Entrez votre nom d'utilisateur",
  "Escribe un prompt": "Écrivez un prompt",
  "Español": "Espagnol",
  "Español (MX)": "Espagnol (MX)",
  "FLUJO EN VIVO · ÚLTIMAS MENCIONES": "FLUX EN DIRECT · DERNIÈRES MENTIONS",
  "GENERA UN APP PASSWORD EN: USUARIOS → PERFIL → APPLICATION PASSWORDS": "GÉNÉREZ UN MOT DE PASSE D'APPLICATION DANS : UTILISATEURS → PROFIL → APPLICATION PASSWORDS",
  "GENERADO": "GÉNÉRÉ",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GÉNÉRÉ · 8S · AUTO-PUBLIÉ 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GÉNÉRÉ · APPROUVÉ AUTO · PUBLIÉ 18:00",
  "GENERAR MI PRIMER POST GRATIS": "GÉNÉRER MON PREMIER POST GRATUIT",
  "GESTIONAR MARCAS": "GÉRER LES MARQUES",
  "Genera artículos optimizados, encuentra keywords que valen la pena, y audita tu sitio web en minutos.": "Générez des articles optimisés, trouvez des mots-clés qui en valent la peine, et auditez votre site web en quelques minutes.",
  "Genera keys para conectar integraciones externas. Cabecera:": "Générez des clés pour connecter des intégrations externes. En-tête :",
  "Genera tu primer video con IA.": "Générez votre première vidéo avec IA.",
  "Genera, programa y publica en todas tus redes sociales con IA. Sin contratar agencia.": "Générez, programmez et publiez sur tous vos réseaux sociaux avec IA. Sans engager d'agence.",
  "Generado por IA.": "Généré par IA.",
  "Generador de contenido IA": "Générateur de contenu IA",
  "Generador de videos IA": "Générateur de vidéos IA",
  "Guarda posts desde el Generador para reutilizarlos.": "Enregistrez les posts depuis le Générateur pour les réutiliser.",
  "Guardado en el banco": "Enregistré dans la banque",
  "Hasta 1 video/día": "Jusqu'à 1 vidéo/jour",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Des hooks, des captions et des scripts qui battent déjà des records dans le monde entier. Tous sont issus d'un prompt de 2 lignes.",
  "INGRESA EL CÓDIGO DE TU APP DE AUTENTICACIÓN": "ENTREZ LE CODE DE VOTRE APPLICATION D'AUTHENTIFICATION",
  "INICIA SESIÓN EN TU CUENTA": "CONNECTEZ-VOUS À VOTRE COMPTE",
  "INTELIGENCIA · MÉTRICAS": "INTELLIGENCE · MÉTRIQUES",
  "Ingresa tu correo y te enviaremos un link para crear una contraseña nueva.": "Entrez votre e-mail et nous vous enverrons un lien pour créer un nouveau mot de passe.",
  "Ingresa una URL": "Entrez une URL",
  "Ingresa una keyword semilla": "Entrez un mot-clé de base",
  "Inicia sesión": "Connectez-vous",
  "Invita y gana": "Invitez et gagnez",
  "Invita y gana Pro gratis": "Invitez et gagnez Pro gratuitement",
  "LO QUE LES FUNCIONA": "CE QUI FONCTIONNE POUR EUX",
  "La API REST (": "L'API REST (",
  "La IA crea además el caption de Instagram, hook de TikTok, tweet y hashtags — listos para publicar.": "L'IA crée également la légende Instagram, le hook TikTok, le tweet et les hashtags — prêts à être publiés.",
  "La IA tarda aproximadamente 2–5 min. Te avisamos cuando esté listo.": "L'IA prend environ 2 à 5 min. Nous vous préviendrons lorsque ce sera prêt.",
  "MARCA": "MARQUE",
  "MARCAS DEL DOSSIER": "MARQUES DU DOSSIER",
  "MISIÓN · GENERACIÓN": "MISSION · GÉNÉRATION",
  "Mi Empresa SA": "Mon Entreprise SA",
  "Mi blog WordPress": "Mon blog WordPress",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Mockups réels de ce que la plateforme publie : vidéo verticale, feed Instagram, carrousel et post LinkedIn.",
  "Monitor de competidores": "Moniteur de concurrents",
  "Muchos pagos pendientes. Revisa el flujo de checkout.": "De nombreux paiements en attente. Vérifiez le flux de checkout.",
  "MÁXIMO MENSUAL CON ESTA FRECUENCIA": "MAXIMUM MENSUEL AVEC CETTE FRÉQUENCE",
  "Mínimo 2 caracteres": "Minimum 2 caractères",
  "Módulo SEO": "Module SEO",
  "Módulo SEO · solo Pro y Agencia": "Module SEO · Pro et Agence uniquement",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "AUCUNE CARTE REQUISE · ANNULEZ QUAND VOUS VOULEZ",
  "NOMBRE DE LA MARCA": "NOM DE LA MARQUE",
  "NUEVA CONTRASEÑA (MÍN 6)": "NOUVEAU MOT DE PASSE (MIN 6)",
  "No has creado ninguna key todavía.": "Vous n'avez pas encore créé de clé.",
  "No hay posts pendientes de aprobación.": "Aucun post en attente d'approbation.",
  "Nueva contraseña": "Nouveau mot de passe",
  "Nómbrala para identificarla después": "Nommez-la pour l'identifier plus tard",
  "O ingresa esta clave manualmente:": "Ou entrez cette clé manuellement :",
  "OK, ya la guardé": "OK, je l'ai sauvegardée",
  "OLVIDÉ MI CONTRASEÑA": "J'AI OUBLIÉ MON MOT DE PASSE",
  "OPERACIÓN · PANEL CENTRAL": "OPÉRATION · PANNEAU CENTRAL",
  "PAQUETE COMPLETO · LISTO PARA PUBLICAR": "PACK COMPLET · PRÊT À PUBLIER",
  "PASO 1 · ESCANEA ESTE CÓDIGO": "ÉTAPE 1 · SCANNEZ CE CODE",
  "PASO 2 · INGRESA EL CÓDIGO DE 6 DÍGITOS": "ÉTAPE 2 · ENTREZ LE CODE À 6 CHIFFRES",
  "POR RED · IMPRESIONES": "PAR RÉSEAU · IMPRESSIONS",
  "PRECIOS APROXIMADOS · CARGO REAL EN USD POR STRIPE ·": "PRIX APPROXIMATIFS · MONTANT RÉEL EN USD PAR STRIPE ·",
  "PROGRAMA DE REFERIDOS": "PROGRAMME DE PARRAINAGE",
  "PROMPT · DESCRIBE EL VIDEO": "PROMPT · DÉCRIVEZ LA VIDÉO",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOLE · COMMENT ÇA FONCTIONNE",
  "PUBLICAR BLOG POST EN UN CLIC": "PUBLIER UN ARTICLE DE BLOG EN UN CLIC",
  "Paga 1 vez al año": "Payez 1 fois par an",
  "Plantilla cargada en el generador": "Modèle chargé dans le générateur",
  "Plantilla cargada · edita y regenera": "Modèle chargé · modifiez et régénérez",
  "Precio claro. Sin letras chiquitas.": "Prix clairs. Sans petits caractères.",
  "Precios sin trampas.": "Prix sans pièges.",
  "Programado para mañana a esta hora": "Programmé pour demain à cette heure",
  "Protege tu cuenta con TOTP. Funciona con": "Protégez votre compte avec TOTP. Fonctionne avec",
  "REQUIERE PLAN PAGO · ELIGE UN PLAN DE ABAJO CON LA OPCIÓN +VIDEO": "NÉCESSITE UN PLAN PAYANT · CHOISISSEZ UN PLAN CI-DESSOUS AVEC L'OPTION +VIDÉO",
  "Recibimos tu pedido de": "Nous avons reçu votre commande de",
  "Recupera tu acceso": "Récupérez votre accès",
  "SALIR": "SORTIR",
  "SE APLICA A BOTONES, BADGES Y ACENTOS DEL DASHBOARD CUANDO ESTA MARCA ESTÁ ACTIVA.": "S'APPLIQUE AUX BOUTONS, BADGES ET ACCENTS DU TABLEAU DE BORD LORSQUE CETTE MARQUE EST ACTIVE.",
  "SIN ITEMS": "SANS ITEMS",
  "SIN MENCIONES": "SANS MENTIONS",
  "SIN OBJETIVOS": "SANS OBJECTIFS",
  "SIN REGISTROS": "SANS ENREGISTREMENTS",
  "SIN VIDEO": "SANS VIDÉO",
  "Selecciona una marca para editarla.": "Sélectionnez une marque pour la modifier.",
  "Servicio de Branding": "Service de Branding",
  "Si no, usamos el primero disponible": "Sinon, nous utilisons le premier disponible",
  "Sin issues críticos": "Aucun problème critique",
  "Sin pagos confirmados todavía.": "Aucun paiement confirmé pour l'instant.",
  "Solicitud de acceso": "Demande d'accès",
  "Solo texto + imágenes": "Texte seul + images",
  "Suscripción y uso": "Abonnement et utilisation",
  "Sé el primero en publicar una plantilla — desde el Generador, guarda tu mejor post como plantilla pública y ayuda a otras marcas a crecer.": "Sois le premier à publier un modèle — depuis le Générateur, enregistre ton meilleur post comme modèle public et aide d'autres marques à se développer.",
  "TELEMETRÍA · 14 DÍAS": "TÉLÉMÉTRIE · 14 JOURS",
  "TEMAS (MÁX 10, COMA)": "THÈMES (MAX 10, VIRGULE)",
  "TIPO DE CONTENIDO": "TYPE DE CONTENU",
  "TONO DE VOZ": "TON DE VOIX",
  "TU CÓDIGO": "TON CODE",
  "Tienes el add-on de Video activo. Elige tu frecuencia máxima (nunca más de 1 video/día):": "Tu as l'add-on Vidéo actif. Choisis ta fréquence maximale (jamais plus d'1 vidéo/jour) :",
  "Tu cuenta está protegida.": "Ton compte est protégé.",
  "Tu marca,": "Ta marque,",
  "Tu plan": "Ton plan",
  "Tú eliges frecuencia": "Tu choisis la fréquence",
  "VER DETALLES": "VOIR DÉTAILS",
  "ZONA DE RIESGO · DESACTIVAR 2FA": "ZONE DE RISQUE · DÉSACTIVER 2FA",
  "cafeterías": "cafétérias",
  "café de especialidad": "café de spécialité",
  "con el código": "avec le code",
  "me gusta": "j'aime",
  "mi marca, producto…": "ma marque, produit…",
  "quedó activo. Bienvenido al nivel superior.": "est devenu actif. Bienvenue au niveau supérieur.",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "si tu en as besoin — double le prix du plan et tu obtiens jusqu'à 1 vidéo/jour.",
  "tu@empresa.com": "ton@entreprise.com",
  "y cualquier app compatible.": "et toute application compatible.",
  "y permite hasta": "et permet jusqu'à",
  "¿Cómo quieres pagar?": "Comment veux-tu payer ?",
  "¿Olvidaste tu contraseña?": "As-tu oublié ton mot de passe ?",
  "¿Quieres videos IA?": "Veux-tu des vidéos IA ?",
  "¿TIENES CÓDIGO DE REFERIDO?": "AS-TU UN CODE DE PARRAINAGE ?",
  "ÚLTIMOS PAGOS CONFIRMADOS": "DERNIERS PAIEMENTS CONFIRMÉS",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ POUR SOUSCRIRE TU AS BESOIN D'UN COMPTE ·",
});
Object.assign(DICT.de ||= {}, {
  "% DE MRR": "% MRR",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PREIS MIT VIDEO = 2× BASISPREIS · BEINHALTET BIS ZU 30 VIDEOS/MONAT · KONFIGURIERBARE FREQUENZ",
  "1 video por día": "1 Video pro Tag",
  "2,340 SEGUIDORES · HACE 2H": "2.340 FOLLOWERS · VOR 2H",
  "2× el precio de tu plan": "2× der Preis deines Plans",
  "30 días Pro": "30 Tage Pro",
  "30 días Pro gratis": "30 Tage Pro gratis",
  "30 días de Pro": "30 Tage Pro",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 Kommentare · 67 Reposts",
  "ABRIR CALCULADORA DE PRECIOS": "PREISRECHNER ÖFFNEN",
  "ACTIVAR ADD-ON DE VIDEO": "VIDEO-ADD-ON AKTIVIEREN",
  "ADD-ON DE VIDEO IA ACTIVO": "KI-VIDEO-ADD-ON AKTIV",
  "ADMIN · TELEMETRÍA FINANCIERA": "ADMIN · FINANZTELEMETRIE",
  "AGENDA · PRÓXIMOS": "AGENDA · BEVORSTEHENDE",
  "ANTES": "VORHER",
  "API pública · solo Agencia": "Öffentliche API · nur Agentur",
  "APROBAR Y PROGRAMAR": "GENEHMIGEN UND PLANEN",
  "ARCHIVO VACÍO": "ARCHIV LEER",
  "ARCHIVO VISUAL · IA DE IMAGEN": "VISUELLES ARCHIV · BILD-KI",
  "AUTOMATIZACIÓN IA": "KI-AUTOMATISIERUNG",
  "Activa el módulo de Video IA": "Aktiviere das KI-Video-Modul",
  "Actualiza tu plan para desbloquear blog generator, keyword research y on-page audit.": "Aktualisiere deinen Plan, um Blog-Generator, Keyword-Recherche und On-Page-Audit freizuschalten.",
  "Actívalo para proteger tu cuenta.": "Aktiviere es, um dein Konto zu schützen.",
  "Agrega al menos un keyword para ver actividad.": "Füge mindestens ein Keyword hinzu, um Aktivität zu sehen.",
  "Agrega competidores para monitorearlos.": "Füge Wettbewerber hinzu, um sie zu überwachen.",
  "Algo falló.": "Etwas ist schiefgelaufen.",
  "Así se ve tu contenido en cada red.": "So sieht dein Inhalt in jedem Netzwerk aus.",
  "Autenticación de 2 factores": "Zwei-Faktor-Authentifizierung",
  "AÑADIR VIDEOS IA": "KI-VIDEOS HINZUFÜGEN",
  "Aún no has generado imágenes.": "Du hast noch keine Bilder generiert.",
  "Aún no hay keywords. Agrega al menos una.": "Es gibt noch keine Keywords. Füge mindestens eins hinzu.",
  "Aún no tienes CMS conectado. Conecta uno para publicar automáticamente.": "Du hast noch kein CMS verbunden. Verbinde eins, um automatisch zu veröffentlichen.",
  "BANDEJA VACÍA": "POSTFACH LEER",
  "BANDEJA · APROBACIÓN": "POSTFACH · GENEHMIGUNG",
  "BIBLIOTECA VACÍA": "BIBLIOTHEK LEER",
  "Banco de contenido": "Inhaltsbank",
  "Banco de imágenes IA": "KI-Bildbank",
  "CADA CUÁNTOS DÍAS:": "ALLE WIEVIELE TAGE:",
  "CARGANDO TELEMETRÍA…": "TELEMETRIE WIRD GELADEN…",
  "CDMX · MÉXICO": "CDMX · MEXIKO",
  "CIA MARKETING® CONVIERTE EL MD A HTML E INYECTA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBLE).": "CIA MARKETING® KONVERTIERT MD ZU HTML UND INJIZIERT SCHEMA.ORG JSON-LD + META TAGS (YOAST KOMPATIBEL).",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "CIA MARKETING® · OPERACIÓN": "CIA MARKETING® · OPERATION",
  "COLA · PENDIENTES DE APROBACIÓN": "WARTESCHLANGE · PENDENT ZUR GENEHMIGUNG",
  "CON VIDEOS IA · 2×": "MIT KI-VIDEOS · 2×",
  "CONECTAR UN CMS · WORDPRESS / SHOPIFY": "EIN CMS VERBINDEN · WORDPRESS / SHOPIFY",
  "CONECTAR Y GUARDAR": "VERBINDEN UND SPEICHERN",
  "CONTRASEÑA (MÍN 6)": "PASSWORT (MIN. 6)",
  "COPIA ESTA CLAVE AHORA — NO SE VOLVERÁ A MOSTRAR": "KOPIERE DIESEN SCHLÜSSEL JETZT — ER WIRD NICHT WIEDER ANGEZEIGT",
  "COPIAR CÓDIGO": "CODE KOPIEREN",
  "COPIAR LINK DE INVITACIÓN": "EINLADUNGS-LINK KOPIEREN",
  "CREA TU CUENTA CIA MARKETING®": "ERSTELLE DEIN CIA MARKETING® KONTO",
  "CREA UNA CUSTOM APP EN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content": "CREA UNA CUSTOM APP EN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content",
  "CREAR CUENTA PARA ELEGIR": "KONTO ERSTELLEN ZUM WÄHLEN",
  "Cada amigo que se registre con tu código, ambos ganan": "Jeder Freund, der sich mit deinem Code registriert, beide gewinnen",
  "Completa contraseña y código": "Passwort und Code eingeben",
  "Completa los datos": "Daten eingeben",
  "Completa todos los campos requeridos": "Alle erforderlichen Felder ausfüllen",
  "Conexión eliminada": "Verbindung gelöscht",
  "Conexión verificada y guardada": "Verbindung überprüft und gespeichert",
  "Contraseña actual": "Aktuelles Passwort",
  "Contraseña actualizada. Inicia sesión.": "Passwort aktualisiert. Melden Sie sich an.",
  "Crea una": "Erstelle ein",
  "CÓDIGO DE REFERIDO (OPCIONAL)": "REFERRAL-CODE (OPTIONAL)",
  "Código 2FA actual · 6 dígitos": "Aktueller 2FA-Code · 6 Ziffern",
  "DESGLOSE POR PLAN": "AUFTEILUNG NACH PLAN",
  "DESPUÉS": "DANACH",
  "DETALLE POR RED": "DETAILS PRO NETZWERK",
  "DOCUMENTACIÓN · ENDPOINTS PÚBLICOS": "DOKUMENTATION · ÖFFENTLICHE ENDPUNKTE",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · MUSTER",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · STIMMEN",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · TARIFE",
  "DURACIÓN": "DAUER",
  "Describe el tema del artículo": "Beschreibe das Thema des Artikels",
  "Describe el tema del post": "Beschreibe das Thema des Posts",
  "Describe el tema para la imagen": "Beschreibe das Thema für das Bild",
  "Describe la imagen: fondo minimalista, producto en primer plano…": "Beschreibe das Bild: minimalistischer Hintergrund, Produkt im Vordergrund…",
  "Describe tu video con al menos 5 caracteres": "Beschreibe dein Video mit mindestens 5 Zeichen",
  "DÍAS BONUS": "BONUSTAGE",
  "DÍAS PRO BONUS": "PRO-BONUSTAGE",
  "EN VIVO": "LIVE",
  "ESPERANDO ÓRDENES": "WARTET AUF BESTELLUNGEN",
  "ESTÁNDAR": "STANDARD",
  "Ej: Barista sirviendo café especialidad en CDMX, cámara lenta, luz cálida, enfoque suave en el vapor del café.": "Bsp.: Barista serviert Spezialitätenkaffee in CDMX, Zeitlupe, warmes Licht, weicher Fokus auf den Kaffeedampf.",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Bsp.: Wie man das beste CRM für KMU im Jahr 2026 auswählt",
  "Ej: Lanzamiento de nuevo café frío para oficina en CDMX": "Bsp.: Einführung eines neuen Cold Brew Kaffees für das Büro in CDMX",
  "Ej: Zapier producción": "Bsp.: Zapier Produktion",
  "El copy que enganchó a miles.": "Der Text, der Tausende begeistert hat.",
  "El código debe tener 6 dígitos": "Der Code muss 6 Ziffern haben",
  "El marketplace está apenas arrancando.": "Der Marktplatz fängt gerade erst an.",
  "Elige red, tipo y describe el tema. La IA generará variantes listas para publicar.": "Wähle Netzwerk, Typ und beschreibe das Thema. Die KI generiert Varianten, die zur Veröffentlichung bereit sind.",
  "Elige tu plan": "Wähle deinen Plan",
  "Elige tu plan. Añade el módulo de": "Wähle deinen Plan. Füge das Modul für",
  "Elige un blog post y una conexión": "Wähle einen Blog-Post und eine Verbindung",
  "Escribe tu usuario": "Gib deinen Benutzernamen ein",
  "Escribe un prompt": "Schreibe einen Prompt",
  "Español": "Spanisch",
  "Español (MX)": "Spanisch (MX)",
  "FLUJO EN VIVO · ÚLTIMAS MENCIONES": "LIVE-FEED · NEUESTE ERWÄHNUNGEN",
  "GENERA UN APP PASSWORD EN: USUARIOS → PERFIL → APPLICATION PASSWORDS": "GENERIERE EIN APP-PASSWORT UNTER: BENUTZER → PROFIL → APPLICATION PASSWORDS",
  "GENERADO": "GENERIERT",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GENERIERT · 8S · AUTOMATISCH VERÖFFENTLICHT 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERIERT · AUTOMATISCH GENEHMIGT · VERÖFFENTLICHT 18:00",
  "GENERAR MI PRIMER POST GRATIS": "MEINEN ERSTEN POST KOSTENLOS GENERIEREN",
  "GESTIONAR MARCAS": "MARKEN VERWALTEN",
  "Genera artículos optimizados, encuentra keywords que valen la pena, y audita tu sitio web en minutos.": "Generiere optimierte Artikel, finde wertvolle Keywords und überprüfe deine Website in wenigen Minuten.",
  "Genera keys para conectar integraciones externas. Cabecera:": "Generiere Schlüssel, um externe Integrationen zu verbinden. Header:",
  "Genera tu primer video con IA.": "Generiere dein erstes Video mit KI.",
  "Genera, programa y publica en todas tus redes sociales con IA. Sin contratar agencia.": "Generiere, plane und veröffentliche auf all deinen sozialen Netzwerken mit KI. Ohne eine Agentur zu beauftragen.",
  "Generado por IA.": "Von KI generiert.",
  "Generador de contenido IA": "KI-Content-Generator",
  "Generador de videos IA": "KI-Video-Generator",
  "Guarda posts desde el Generador para reutilizarlos.": "Speichere Posts aus dem Generator, um sie wiederzuverwenden.",
  "Guardado en el banco": "Im Speicher abgelegt",
  "Hasta 1 video/día": "Bis zu 1 Video/Tag",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, Captions und Skripte, die bereits weltweit Metriken sprengen. Alle entstanden aus einem 2-zeiligen Prompt.",
  "INGRESA EL CÓDIGO DE TU APP DE AUTENTICACIÓN": "GIB DEN CODE DEINER AUTHENTIFIZIERUNGS-APP EIN",
  "INICIA SESIÓN EN TU CUENTA": "MELDEN SIE SICH BEI IHREM KONTO AN",
  "INTELIGENCIA · MÉTRICAS": "INTELLIGENZ · METRIKEN",
  "Ingresa tu correo y te enviaremos un link para crear una contraseña nueva.": "Gib deine E-Mail-Adresse ein und wir senden dir einen Link, um ein neues Passwort zu erstellen.",
  "Ingresa una URL": "Gib eine URL ein",
  "Ingresa una keyword semilla": "Gib ein Seed-Keyword ein",
  "Inicia sesión": "Anmelden",
  "Invita y gana": "Einladen und verdienen",
  "Invita y gana Pro gratis": "Einladen und Pro kostenlos erhalten",
  "LO QUE LES FUNCIONA": "WAS FUNKTIONIERT",
  "La API REST (": "Die REST-API (",
  "La IA crea además el caption de Instagram, hook de TikTok, tweet y hashtags — listos para publicar.": "Die KI erstellt außerdem die Instagram-Caption, den TikTok-Hook, den Tweet und Hashtags – bereit zum Veröffentlichen.",
  "La IA tarda aproximadamente 2–5 min. Te avisamos cuando esté listo.": "Die KI benötigt ca. 2–5 Min. Wir benachrichtigen dich, sobald es fertig ist.",
  "MARCA": "MARKE",
  "MARCAS DEL DOSSIER": "MARKEN IM DOSSIER",
  "MISIÓN · GENERACIÓN": "MISSION · GENERIERUNG",
  "Mi Empresa SA": "Meine Firma AG",
  "Mi blog WordPress": "Mein WordPress Blog",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Echte Mockups dessen, was die Plattform veröffentlicht: vertikales Video, Instagram-Feed, Karussell und LinkedIn-Post.",
  "Monitor de competidores": "Wettbewerbsmonitor",
  "Muchos pagos pendientes. Revisa el flujo de checkout.": "Viele ausstehende Zahlungen. Überprüfe den Checkout-Fluss.",
  "MÁXIMO MENSUAL CON ESTA FRECUENCIA": "MONATLICHES MAXIMUM MIT DIESER FREQUENZ",
  "Mínimo 2 caracteres": "Mindestens 2 Zeichen",
  "Módulo SEO": "SEO-Modul",
  "Módulo SEO · solo Pro y Agencia": "SEO-Modul · nur Pro und Agentur",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "KEINE KARTE ERFORDERLICH · JEDERZEIT KÜNDBAR",
  "NOMBRE DE LA MARCA": "MARKENNAME",
  "NUEVA CONTRASEÑA (MÍN 6)": "NEUES PASSWORT (MIN. 6)",
  "No has creado ninguna key todavía.": "Du hast noch keinen Key erstellt.",
  "No hay posts pendientes de aprobación.": "Es gibt keine Posts, die auf Genehmigung warten.",
  "Nueva contraseña": "Neues Passwort",
  "Nómbrala para identificarla después": "Benenne sie, um sie später zu identifizieren",
  "O ingresa esta clave manualmente:": "Oder gib diesen Schlüssel manuell ein:",
  "OK, ya la guardé": "OK, ich habe es gespeichert",
  "OLVIDÉ MI CONTRASEÑA": "PASSWORT VERGESSEN",
  "OPERACIÓN · PANEL CENTRAL": "BETRIEB · ZENTRALES PANEL",
  "PAQUETE COMPLETO · LISTO PARA PUBLICAR": "KOMPLETTPAKET · BEREIT ZUM VERÖFFENTLICHEN",
  "PASO 1 · ESCANEA ESTE CÓDIGO": "SCHRITT 1 · SCANNEN SIE DIESEN CODE",
  "PASO 2 · INGRESA EL CÓDIGO DE 6 DÍGITOS": "SCHRITT 2 · GEBEN SIE DEN 6-STELLIGEN CODE EIN",
  "POR RED · IMPRESIONES": "PRO NETZWERK · IMPRESSIONEN",
  "PRECIOS APROXIMADOS · CARGO REAL EN USD POR STRIPE ·": "GESCHÄTZTE PREISE · TATSÄCHLICHE GEBÜHR IN USD ÜBER STRIPE ·",
  "PROGRAMA DE REFERIDOS": "EMPFIEHLUNGS-PROGRAMM",
  "PROMPT · DESCRIBE EL VIDEO": "PROMPT · BESCHREIBEN SIE DAS VIDEO",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOKOLL · WIE ES FUNKTIONIERT",
  "PUBLICAR BLOG POST EN UN CLIC": "BLOG-POST MIT EINEM KLICK VERÖFFENTLICHEN",
  "Paga 1 vez al año": "Einmal jährlich zahlen",
  "Plantilla cargada en el generador": "Vorlage im Generator geladen",
  "Plantilla cargada · edita y regenera": "Vorlage geladen · bearbeiten und neu generieren",
  "Precio claro. Sin letras chiquitas.": "Klarer Preis. Ohne Kleingedrucktes.",
  "Precios sin trampas.": "Preise ohne Fallen.",
  "Programado para mañana a esta hora": "Für morgen um diese Zeit geplant",
  "Protege tu cuenta con TOTP. Funciona con": "Schützen Sie Ihr Konto mit TOTP. Funktioniert mit",
  "REQUIERE PLAN PAGO · ELIGE UN PLAN DE ABAJO CON LA OPCIÓN +VIDEO": "KOSTENPFLICHTIGEN PLAN ERFORDERLICH · WÄHLEN SIE EINEN PLAN UNTEN MIT DER OPTION +VIDEO",
  "Recibimos tu pedido de": "Wir haben Ihre Bestellung erhalten von",
  "Recupera tu acceso": "Zugriff wiederherstellen",
  "SALIR": "ABMELDEN",
  "SE APLICA A BOTONES, BADGES Y ACENTOS DEL DASHBOARD CUANDO ESTA MARCA ESTÁ ACTIVA.": "WIRD AUF SCHALTFLÄCHEN, BADGES UND AKZENTE DES DASHBOARDS ANGEWENDET, WENN DIESE MARKE AKTIV IST.",
  "SIN ITEMS": "KEINE ARTIKEL",
  "SIN MENCIONES": "KEINE ERWÄHNUNGEN",
  "SIN OBJETIVOS": "KEINE ZIELE",
  "SIN REGISTROS": "KEINE EINTRÄGE",
  "SIN VIDEO": "OHNE VIDEO",
  "Selecciona una marca para editarla.": "Wählen Sie eine Marke zur Bearbeitung aus.",
  "Servicio de Branding": "Branding-Service",
  "Si no, usamos el primero disponible": "Wenn nicht, verwenden wir den ersten verfügbaren",
  "Sin issues críticos": "Keine kritischen Probleme",
  "Sin pagos confirmados todavía.": "Noch keine bestätigten Zahlungen.",
  "Solicitud de acceso": "Zugriffsanfrage",
  "Solo texto + imágenes": "Nur Text + Bilder",
  "Suscripción y uso": "Abonnement und Nutzung",
  "Sé el primero en publicar una plantilla — desde el Generador, guarda tu mejor post como plantilla pública y ayuda a otras marcas a crecer.": "Seien Sie der Erste, der eine Vorlage veröffentlicht — speichern Sie vom Generator aus Ihren besten Beitrag als öffentliche Vorlage und helfen Sie anderen Marken zu wachsen.",
  "TELEMETRÍA · 14 DÍAS": "TELEMETRIE · 14 TAGE",
  "TEMAS (MÁX 10, COMA)": "THEMEN (MAX 10, KOMMA)",
  "TIPO DE CONTENIDO": "INHALTSTYP",
  "TONO DE VOZ": "TON DER STIMME",
  "TU CÓDIGO": "DEIN CODE",
  "Tienes el add-on de Video activo. Elige tu frecuencia máxima (nunca más de 1 video/día):": "Sie haben das Video-Add-on aktiviert. Wählen Sie Ihre maximale Frequenz (nie mehr als 1 Video/Tag):",
  "Tu cuenta está protegida.": "Ihr Konto ist geschützt.",
  "Tu marca,": "Ihre Marke,",
  "Tu plan": "Ihr Plan",
  "Tú eliges frecuencia": "Sie wählen die Frequenz",
  "VER DETALLES": "DETAILS ANZEIGEN",
  "ZONA DE RIESGO · DESACTIVAR 2FA": "RISIKOBEREICH · 2FA DEAKTIVIEREN",
  "cafeterías": "Cafés",
  "café de especialidad": "Spezialitätenkaffee",
  "con el código": "mit dem Code",
  "me gusta": "Gefällt mir",
  "mi marca, producto…": "meine Marke, mein Produkt…",
  "quedó activo. Bienvenido al nivel superior.": "wurde aktiviert. Willkommen auf der nächsten Stufe.",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "falls Sie es brauchen — verdoppeln Sie den Preis des Plans und erhalten Sie bis zu 1 Video/Tag.",
  "tu@empresa.com": "deine@firma.com",
  "y cualquier app compatible.": "und jede kompatible App.",
  "y permite hasta": "und erlaubt bis zu",
  "¿Cómo quieres pagar?": "Wie möchten Sie bezahlen?",
  "¿Olvidaste tu contraseña?": "Passwort vergessen?",
  "¿Quieres videos IA?": "Möchten Sie KI-Videos?",
  "¿TIENES CÓDIGO DE REFERIDO?": "HABEN SIE EINEN EMPFEHLUNGSCODE?",
  "ÚLTIMOS PAGOS CONFIRMADOS": "LETZTE BESTÄTIGTE ZAHLUNGEN",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ UM BUCHEN ZU KÖNNEN, BENÖTIGEN SIE EIN KONTO ·",
});
Object.assign(DICT.it ||= {}, {
  "% DE MRR": "% DI MRR",
  "* PRECIO CON VIDEO = 2× PRECIO BASE · INCLUYE HASTA 30 VIDEOS/MES · FRECUENCIA CONFIGURABLE": "* PREZZO CON VIDEO = 2× PREZZO BASE · INCLUDE FINO A 30 VIDEO/MESE · FREQUENZA CONFIGURABILE",
  "1 video por día": "1 video al giorno",
  "2,340 SEGUIDORES · HACE 2H": "2.340 FOLLOWER · 2 ORE FA",
  "2× el precio de tu plan": "2× il prezzo del tuo piano",
  "30 días Pro": "30 giorni Pro",
  "30 días Pro gratis": "30 giorni Pro gratis",
  "30 días de Pro": "30 giorni di Pro",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 commenti · 67 ripubblicazioni",
  "ABRIR CALCULADORA DE PRECIOS": "APRI CALCOLATORE PREZZI",
  "ACTIVAR ADD-ON DE VIDEO": "ATTIVA ADD-ON VIDEO",
  "ADD-ON DE VIDEO IA ACTIVO": "ADD-ON VIDEO IA ATTIVO",
  "ADMIN · TELEMETRÍA FINANCIERA": "ADMIN · TELEMETRIA FINANZIARIA",
  "AGENDA · PRÓXIMOS": "AGENDA · PROSSIMI",
  "ANTES": "PRIMA",
  "API pública · solo Agencia": "API pubblica · solo Agenzia",
  "APROBAR Y PROGRAMAR": "APPROVA E PROGRAMMA",
  "ARCHIVO VACÍO": "ARCHIVIO VUOTO",
  "ARCHIVO VISUAL · IA DE IMAGEN": "ARCHIVIO VISUALE · IA IMMAGINI",
  "AUTOMATIZACIÓN IA": "AUTOMAZIONE IA",
  "Activa el módulo de Video IA": "Attiva il modulo Video IA",
  "Actualiza tu plan para desbloquear blog generator, keyword research y on-page audit.": "Aggiorna il tuo piano per sbloccare blog generator, keyword research e on-page audit.",
  "Actívalo para proteger tu cuenta.": "Attivalo per proteggere il tuo account.",
  "Agrega al menos un keyword para ver actividad.": "Aggiungi almeno una keyword per vedere l'attività.",
  "Agrega competidores para monitorearlos.": "Aggiungi competitor per monitorarli.",
  "Algo falló.": "Qualcosa è andato storto.",
  "Así se ve tu contenido en cada red.": "Ecco come appare il tuo contenuto in ogni rete.",
  "Autenticación de 2 factores": "Autenticazione a 2 fattori",
  "AÑADIR VIDEOS IA": "AGGIUNGI VIDEO IA",
  "Aún no has generado imágenes.": "Non hai ancora generato immagini.",
  "Aún no hay keywords. Agrega al menos una.": "Non ci sono ancora keyword. Aggiungine almeno una.",
  "Aún no tienes CMS conectado. Conecta uno para publicar automáticamente.": "Non hai ancora un CMS connesso. Connettine uno per pubblicare automaticamente.",
  "BANDEJA VACÍA": "CASELLA VUOTA",
  "BANDEJA · APROBACIÓN": "CASELLA · APPROVAZIONE",
  "BIBLIOTECA VACÍA": "LIBRERIA VUOTA",
  "Banco de contenido": "Banca di contenuti",
  "Banco de imágenes IA": "Banca di immagini IA",
  "CADA CUÁNTOS DÍAS:": "OGNI QUANTI GIORNI:",
  "CARGANDO TELEMETRÍA…": "CARICAMENTO TELEMETRIA…",
  "CDMX · MÉXICO": "CDMX · MESSICO",
  "CIA MARKETING® CONVIERTE EL MD A HTML E INYECTA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBLE).": "CIA MARKETING® CONVERTE L'MD IN HTML E INIETTA SCHEMA.ORG JSON-LD + META TAGS (YOAST COMPATIBILE).",
  "CIA MARKETING® · 2026 · GLOBAL": "CIA MARKETING® · 2026 · GLOBAL",
  "CIA MARKETING® · OPERACIÓN": "CIA MARKETING® · OPERAZIONE",
  "COLA · PENDIENTES DE APROBACIÓN": "CODA · IN ATTESA DI APPROVAZIONE",
  "CON VIDEOS IA · 2×": "CON VIDEO IA · 2×",
  "CONECTAR UN CMS · WORDPRESS / SHOPIFY": "CONNETTI UN CMS · WORDPRESS / SHOPIFY",
  "CONECTAR Y GUARDAR": "CONNETTI E SALVA",
  "CONTRASEÑA (MÍN 6)": "PASSWORD (MIN 6)",
  "COPIA ESTA CLAVE AHORA — NO SE VOLVERÁ A MOSTRAR": "COPIA QUESTA CHIAVE ORA — NON VERRÀ MOSTRATA DI NUOVO",
  "COPIAR CÓDIGO": "COPIA CODICE",
  "COPIAR LINK DE INVITACIÓN": "COPIA LINK INVITO",
  "CREA TU CUENTA CIA MARKETING®": "CREA IL TUO ACCOUNT CIA MARKETING®",
  "CREA UNA CUSTOM APP EN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content": "CREA UNA CUSTOM APP IN SETTINGS → APPS → DEVELOP APPS. SCOPE: write_content",
  "CREAR CUENTA PARA ELEGIR": "CREA ACCOUNT PER SCEGLIERE",
  "Cada amigo que se registre con tu código, ambos ganan": "Ogni amico che si registra con il tuo codice, entrambi guadagnano",
  "Completa contraseña y código": "Completa password e codice",
  "Completa los datos": "Completa i dati",
  "Completa todos los campos requeridos": "Completa tutti i campi richiesti",
  "Conexión eliminada": "Connessione eliminata",
  "Conexión verificada y guardada": "Connessione verificata e salvata",
  "Contraseña actual": "Password attuale",
  "Contraseña actualizada. Inicia sesión.": "Password aggiornata. Accedi.",
  "Crea una": "Crea una",
  "CÓDIGO DE REFERIDO (OPCIONAL)": "CODICE DI RIFERIMENTO (OPZIONALE)",
  "Código 2FA actual · 6 dígitos": "Codice 2FA attuale · 6 cifre",
  "DESGLOSE POR PLAN": "SUDDIVISIONE PER PIANO",
  "DESPUÉS": "DOPO",
  "DETALLE POR RED": "DETTAGLIO PER RETE",
  "DOCUMENTACIÓN · ENDPOINTS PÚBLICOS": "DOCUMENTAZIONE · ENDPOINT PUBBLICI",
  "DOSSIER 03 · MUESTRAS": "DOSSIER 03 · CAMPIONI",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOCI",
  "DOSSIER 04 · TARIFAS": "DOSSIER 04 · TARIFFE",
  "DURACIÓN": "DURATA",
  "Describe el tema del artículo": "Descrivi l'argomento dell'articolo",
  "Describe el tema del post": "Descrivi l'argomento del post",
  "Describe el tema para la imagen": "Descrivi l'argomento per l'immagine",
  "Describe la imagen: fondo minimalista, producto en primer plano…": "Descrivi l'immagine: sfondo minimalista, prodotto in primo piano…",
  "Describe tu video con al menos 5 caracteres": "Descrivi il tuo video con almeno 5 caratteri",
  "DÍAS BONUS": "GIORNI BONUS",
  "DÍAS PRO BONUS": "GIORNI PRO BONUS",
  "EN VIVO": "LIVE",
  "ESPERANDO ÓRDENES": "IN ATTESA DI ORDINI",
  "ESTÁNDAR": "STANDARD",
  "Ej: Barista sirviendo café especialidad en CDMX, cámara lenta, luz cálida, enfoque suave en el vapor del café.": "Es: Barista che serve caffè speciale a CDMX, slow motion, luce calda, messa a fuoco morbida sul vapore del caffè.",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Es: Come scegliere il miglior CRM per PMI nel 2026",
  "Ej: Lanzamiento de nuevo café frío para oficina en CDMX": "Es: Lancio di un nuovo caffè freddo per ufficio a CDMX",
  "Ej: Zapier producción": "Es: Zapier produzione",
  "El copy que enganchó a miles.": "Il copy che ha catturato migliaia.",
  "El código debe tener 6 dígitos": "Il codice deve avere 6 cifre",
  "El marketplace está apenas arrancando.": "Il marketplace è appena partito.",
  "Elige red, tipo y describe el tema. La IA generará variantes listas para publicar.": "Scegli rete, tipo e descrivi l'argomento. L'IA genererà varianti pronte per la pubblicazione.",
  "Elige tu plan": "Scegli il tuo piano",
  "Elige tu plan. Añade el módulo de": "Scegli il tuo piano. Aggiungi il modulo di",
  "Elige un blog post y una conexión": "Scegli un blog post e una connessione",
  "Escribe tu usuario": "Scrivi il tuo utente",
  "Escribe un prompt": "Scrivi un prompt",
  "Español": "Spagnolo",
  "Español (MX)": "Spagnolo (MX)",
  "FLUJO EN VIVO · ÚLTIMAS MENCIONES": "FLUSSO LIVE · ULTIME MENZIONI",
  "GENERA UN APP PASSWORD EN: USUARIOS → PERFIL → APPLICATION PASSWORDS": "GENERA UN'APP PASSWORD IN: UTENTI → PROFILO → APPLICATION PASSWORDS",
  "GENERADO": "GENERATO",
  "GENERADO · 8S · AUTO-PUBLICADO 09:32": "GENERATO · 8S · AUTO-PUBBLICATO 09:32",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERATO · APPROVATO AUTO · PUBBLICATO 18:00",
  "GENERAR MI PRIMER POST GRATIS": "GENERA IL MIO PRIMO POST GRATIS",
  "GESTIONAR MARCAS": "GESTISCI MARCHI",
  "Genera artículos optimizados, encuentra keywords que valen la pena, y audita tu sitio web en minutos.": "Genera articoli ottimizzati, trova keyword che valgono la pena e controlla il tuo sito web in pochi minuti.",
  "Genera keys para conectar integraciones externas. Cabecera:": "Genera chiavi per connettere integrazioni esterne. Intestazione:",
  "Genera tu primer video con IA.": "Genera il tuo primo video con IA.",
  "Genera, programa y publica en todas tus redes sociales con IA. Sin contratar agencia.": "Genera, programma e pubblica su tutti i tuoi social network con IA. Senza assumere un'agenzia.",
  "Generado por IA.": "Generato da IA.",
  "Generador de contenido IA": "Generatore di contenuti IA",
  "Generador de videos IA": "Generatore di video IA",
  "Guarda posts desde el Generador para reutilizarlos.": "Salva post dal Generatore per riutilizzarli.",
  "Guardado en el banco": "Salvato nella banca",
  "Hasta 1 video/día": "Fino a 1 video/giorno",
  "Hooks, captions y scripts que ya están rompiendo métricas a nivel global. Todos salieron de un prompt de 2 líneas.": "Hooks, caption e script che stanno già superando le metriche a livello globale. Tutti sono usciti da un prompt di 2 righe.",
  "INGRESA EL CÓDIGO DE TU APP DE AUTENTICACIÓN": "INSERISCI IL CODICE DELLA TUA APP DI AUTENTICAZIONE",
  "INICIA SESIÓN EN TU CUENTA": "ACCEDI AL TUO ACCOUNT",
  "INTELIGENCIA · MÉTRICAS": "INTELLIGENZA · METRICHE",
  "Ingresa tu correo y te enviaremos un link para crear una contraseña nueva.": "Inserisci la tua email e ti invieremo un link per creare una nuova password.",
  "Ingresa una URL": "Inserisci una URL",
  "Ingresa una keyword semilla": "Inserisci una keyword seme",
  "Inicia sesión": "Accedi",
  "Invita y gana": "Invita e guadagna",
  "Invita y gana Pro gratis": "Invita e guadagna Pro gratis",
  "LO QUE LES FUNCIONA": "CIÒ CHE FUNZIONA PER LORO",
  "La API REST (": "La API REST (",
  "La IA crea además el caption de Instagram, hook de TikTok, tweet y hashtags — listos para publicar.": "L'IA crea anche la caption di Instagram, l'hook di TikTok, il tweet e gli hashtag — pronti per la pubblicazione.",
  "La IA tarda aproximadamente 2–5 min. Te avisamos cuando esté listo.": "L'IA impiega circa 2–5 min. Ti avvisiamo quando è pronto.",
  "MARCA": "MARCA",
  "MARCAS DEL DOSSIER": "MARCHE DEL DOSSIER",
  "MISIÓN · GENERACIÓN": "MISSIONE · GENERAZIONE",
  "Mi Empresa SA": "Mia Azienda SpA",
  "Mi blog WordPress": "Il mio blog WordPress",
  "Mockups reales de lo que la plataforma publica: video vertical, feed de Instagram, carrusel y post de LinkedIn.": "Mockup reali di ciò che la piattaforma pubblica: video verticale, feed di Instagram, carosello e post di LinkedIn.",
  "Monitor de competidores": "Monitoraggio concorrenti",
  "Muchos pagos pendientes. Revisa el flujo de checkout.": "Molti pagamenti in sospeso. Controlla il flusso di checkout.",
  "MÁXIMO MENSUAL CON ESTA FRECUENCIA": "MASSIMO MENSILE CON QUESTA FREQUENZA",
  "Mínimo 2 caracteres": "Minimo 2 caratteri",
  "Módulo SEO": "Modulo SEO",
  "Módulo SEO · solo Pro y Agencia": "Modulo SEO · solo Pro e Agenzia",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "NON RICHIEDE CARTA · CANCELLA QUANDO VUOI",
  "NOMBRE DE LA MARCA": "NOME DEL MARCHIO",
  "NUEVA CONTRASEÑA (MÍN 6)": "NUOVA PASSWORD (MIN 6)",
  "No has creado ninguna key todavía.": "Non hai ancora creato nessuna key.",
  "No hay posts pendientes de aprobación.": "Non ci sono post in attesa di approvazione.",
  "Nueva contraseña": "Nuova password",
  "Nómbrala para identificarla después": "Nominala per identificarla dopo",
  "O ingresa esta clave manualmente:": "O inserisci questa chiave manualmente:",
  "OK, ya la guardé": "OK, l'ho salvata",
  "OLVIDÉ MI CONTRASEÑA": "HO DIMENTICATO LA MIA PASSWORD",
  "OPERACIÓN · PANEL CENTRAL": "OPERAZIONE · PANNELLO CENTRALE",
  "PAQUETE COMPLETO · LISTO PARA PUBLICAR": "PACCHETTO COMPLETO · PRONTO PER LA PUBBLICAZIONE",
  "PASO 1 · ESCANEA ESTE CÓDIGO": "PASSO 1 · SCANSIONA QUESTO CODICE",
  "PASO 2 · INGRESA EL CÓDIGO DE 6 DÍGITOS": "PASSO 2 · INSERISCI IL CODICE DI 6 CIFRE",
  "POR RED · IMPRESIONES": "PER RETE · IMPRESSIONI",
  "PRECIOS APROXIMADOS · CARGO REAL EN USD POR STRIPE ·": "PREZZI APPROSSIMATIVI · ADDEBITO REALE IN USD TRAMITE STRIPE ·",
  "PROGRAMA DE REFERIDOS": "PROGRAMMA DI REFERRAL",
  "PROMPT · DESCRIBE EL VIDEO": "PROMPT · DESCRIVI IL VIDEO",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOLLO · COME FUNZIONA",
  "PUBLICAR BLOG POST EN UN CLIC": "PUBBLICA POST DEL BLOG IN UN CLIC",
  "Paga 1 vez al año": "Paga 1 volta all'anno",
  "Plantilla cargada en el generador": "Template caricato nel generatore",
  "Plantilla cargada · edita y regenera": "Template caricato · modifica e rigenera",
  "Precio claro. Sin letras chiquitas.": "Prezzo chiaro. Senza clausole nascoste.",
  "Precios sin trampas.": "Prezzi senza sorprese.",
  "Programado para mañana a esta hora": "Programmato per domani a quest'ora",
  "Protege tu cuenta con TOTP. Funciona con": "Proteggi il tuo account con TOTP. Funziona con",
  "REQUIERE PLAN PAGO · ELIGE UN PLAN DE ABAJO CON LA OPCIÓN +VIDEO": "RICHIEDE PIANO A PAGAMENTO · SCEGLI UN PIANO QUI SOTTO CON L'OPZIONE +VIDEO",
  "Recibimos tu pedido de": "Abbiamo ricevuto il tuo ordine di",
  "Recupera tu acceso": "Recupera il tuo accesso",
  "SALIR": "ESCI",
  "SE APLICA A BOTONES, BADGES Y ACENTOS DEL DASHBOARD CUANDO ESTA MARCA ESTÁ ACTIVA.": "SI APPLICA A PULSANTI, BADGE E ACCENTI DELLA DASHBOARD QUANDO QUESTO MARCHIO È ATTIVO.",
  "SIN ITEMS": "SENZA ELEMENTI",
  "SIN MENCIONES": "SENZA MENZIONI",
  "SIN OBJETIVOS": "SENZA OBIETTIVI",
  "SIN REGISTROS": "SENZA REGISTRI",
  "SIN VIDEO": "SENZA VIDEO",
  "Selecciona una marca para editarla.": "Seleziona un marchio per modificarlo.",
  "Servicio de Branding": "Servizio di Branding",
  "Si no, usamos el primero disponible": "Se no, usiamo il primo disponibile",
  "Sin issues críticos": "Nessun problema critico",
  "Sin pagos confirmados todavía.": "Nessun pagamento confermato ancora.",
  "Solicitud de acceso": "Richiesta di accesso",
  "Solo texto + imágenes": "Solo testo + immagini",
  "Suscripción y uso": "Abbonamento e utilizzo",
  "Sé el primero en publicar una plantilla — desde el Generador, guarda tu mejor post como plantilla pública y ayuda a otras marcas a crecer.": "Sii il primo a pubblicare un modello — dal Generatore, salva il tuo miglior post come modello pubblico e aiuta altri brand a crescere.",
  "TELEMETRÍA · 14 DÍAS": "TELEMETRIA · 14 GIORNI",
  "TEMAS (MÁX 10, COMA)": "TEMI (MAX 10, VIRGOLA)",
  "TIPO DE CONTENIDO": "TIPO DI CONTENUTO",
  "TONO DE VOZ": "TONO DI VOCE",
  "TU CÓDIGO": "IL TUO CODICE",
  "Tienes el add-on de Video activo. Elige tu frecuencia máxima (nunca más de 1 video/día):": "Hai l'add-on Video attivo. Scegli la tua frequenza massima (mai più di 1 video/giorno):",
  "Tu cuenta está protegida.": "Il tuo account è protetto.",
  "Tu marca,": "Il tuo brand,",
  "Tu plan": "Il tuo piano",
  "Tú eliges frecuencia": "Scegli tu la frequenza",
  "VER DETALLES": "VEDI DETTAGLI",
  "ZONA DE RIESGO · DESACTIVAR 2FA": "ZONA DI RISCHIO · DISATTIVARE 2FA",
  "cafeterías": "caffetterie",
  "café de especialidad": "caffè di specialità",
  "con el código": "con il codice",
  "me gusta": "mi piace",
  "mi marca, producto…": "il mio brand, prodotto…",
  "quedó activo. Bienvenido al nivel superior.": "è stato attivato. Benvenuto al livello superiore.",
  "si lo necesitas — duplica el precio del plan y obtienes hasta 1 video/día.": "se ne hai bisogno — raddoppia il prezzo del piano e ottieni fino a 1 video/giorno.",
  "tu@empresa.com": "tu@azienda.com",
  "y cualquier app compatible.": "e qualsiasi app compatibile.",
  "y permite hasta": "e permette fino a",
  "¿Cómo quieres pagar?": "Come vuoi pagare?",
  "¿Olvidaste tu contraseña?": "Hai dimenticato la password?",
  "¿Quieres videos IA?": "Vuoi video IA?",
  "¿TIENES CÓDIGO DE REFERIDO?": "HAI UN CODICE REFERRAL?",
  "ÚLTIMOS PAGOS CONFIRMADOS": "ULTIMI PAGAMENTI CONFERMATI",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ PER ABBONARTI HAI BISOGNO DI UN ACCOUNT ·",
});


// Plan units + names
Object.assign(DICT.en ||= {}, {
  "mes": "mo",
  "año": "yr",
  "siempre": "forever",
  "Inicial": "Starter",
  "Básico": "Basic",
  "Agencia": "Agency",
  "Pro": "Pro",
  "ELEGIR": "CHOOSE",
  "Gratis": "Free",
});
Object.assign(DICT.pt ||= {}, {
  "mes": "mês",
  "año": "ano",
  "siempre": "sempre",
  "Inicial": "Inicial",
  "Básico": "Básico",
  "Agencia": "Agência",
  "Pro": "Pro",
  "ELEGIR": "ESCOLHER",
  "Gratis": "Grátis",
});
Object.assign(DICT.fr ||= {}, {
  "mes": "mois",
  "año": "an",
  "siempre": "toujours",
  "Inicial": "Initial",
  "Básico": "Basique",
  "Agencia": "Agence",
  "Pro": "Pro",
  "ELEGIR": "CHOISIR",
  "Gratis": "Gratuit",
});
Object.assign(DICT.de ||= {}, {
  "mes": "Monat",
  "año": "Jahr",
  "siempre": "immer",
  "Inicial": "Start",
  "Básico": "Basic",
  "Agencia": "Agency",
  "Pro": "Pro",
  "ELEGIR": "WÄHLEN",
  "Gratis": "Gratis",
});
Object.assign(DICT.it ||= {}, {
  "mes": "mese",
  "año": "anno",
  "siempre": "sempre",
  "Inicial": "Iniziale",
  "Básico": "Basic",
  "Agencia": "Agenzia",
  "Pro": "Pro",
  "ELEGIR": "SCEGLI",
  "Gratis": "Gratis",
});


// Pass 2 extra keys
Object.assign(DICT.en ||= {}, {
  "ACTIVAR": "ACTIVATE",
  "ENGAGEMENT": "ENGAGEMENT",
  "GENERANDO…": "GENERATING…",
  "GENERAR CONTENIDO": "GENERATE CONTENT",
  "IMPRESIONES": "IMPRESSIONS",
  "INVITADOS": "INVITED",
  "MEJORAR PLAN": "UPGRADE PLAN",
  "PLAN": "PLAN",
  "PLAN ACTIVO": "ACTIVE PLAN",
  "RESERVA · CONTENIDO EVERGREEN": "RESERVE · EVERGREEN CONTENT",
  "REVOCAR": "REVOKE",
  "SEGUIDORES": "FOLLOWERS",
  "VER CALENDARIO": "SEE CALENDAR",
  "VER TODO": "SEE ALL",
});
Object.assign(DICT.pt ||= {}, {
  "ACTIVAR": "ATIVAR",
  "ENGAGEMENT": "ENGAJAMENTO",
  "GENERANDO…": "GERANDO…",
  "GENERAR CONTENIDO": "GERAR CONTEÚDO",
  "IMPRESIONES": "IMPRESSÕES",
  "INVITADOS": "CONVIDADOS",
  "MEJORAR PLAN": "MELHORAR PLANO",
  "PLAN": "PLANO",
  "PLAN ACTIVO": "PLANO ATIVO",
  "RESERVA · CONTENIDO EVERGREEN": "RESERVA · CONTEÚDO EVERGREEN",
  "REVOCAR": "REVOGAR",
  "SEGUIDORES": "SEGUIDORES",
  "VER CALENDARIO": "VER CALENDÁRIO",
  "VER TODO": "VER TUDO",
});
Object.assign(DICT.fr ||= {}, {
  "ACTIVAR": "ACTIVER",
  "ENGAGEMENT": "ENGAGEMENT",
  "GENERANDO…": "GÉNÉRATION…",
  "GENERAR CONTENIDO": "GÉNÉRER DU CONTENU",
  "IMPRESIONES": "IMPRESSIONS",
  "INVITADOS": "INVITÉS",
  "MEJORAR PLAN": "AMÉLIORER LE PLAN",
  "PLAN": "PLAN",
  "PLAN ACTIVO": "PLAN ACTIF",
  "RESERVA · CONTENIDO EVERGREEN": "RÉSERVE · CONTENU EVERGREEN",
  "REVOCAR": "RÉVOQUER",
  "SEGUIDORES": "ABONNÉS",
  "VER CALENDARIO": "VOIR LE CALENDRIER",
  "VER TODO": "TOUT VOIR",
});
Object.assign(DICT.de ||= {}, {
  "ACTIVAR": "AKTIVIEREN",
  "ENGAGEMENT": "ENGAGEMENT",
  "GENERANDO…": "GENERIERE…",
  "GENERAR CONTENIDO": "CONTENT GENERIEREN",
  "IMPRESIONES": "IMPRESSIONEN",
  "INVITADOS": "EINGELADEN",
  "MEJORAR PLAN": "PLAN AUFWERTEN",
  "PLAN": "PLAN",
  "PLAN ACTIVO": "AKTIVER PLAN",
  "RESERVA · CONTENIDO EVERGREEN": "RESERVE · EVERGREEN-CONTENT",
  "REVOCAR": "WIDERRUFEN",
  "SEGUIDORES": "FOLLOWER",
  "VER CALENDARIO": "KALENDER ANSEHEN",
  "VER TODO": "ALLE ANSEHEN",
});
Object.assign(DICT.it ||= {}, {
  "ACTIVAR": "ATTIVA",
  "ENGAGEMENT": "ENGAGEMENT",
  "GENERANDO…": "GENERAZIONE…",
  "GENERAR CONTENIDO": "GENERA CONTENUTO",
  "IMPRESIONES": "IMPRESSIONI",
  "INVITADOS": "INVITATI",
  "MEJORAR PLAN": "MIGLIORA PIANO",
  "PLAN": "PIANO",
  "PLAN ACTIVO": "PIANO ATTIVO",
  "RESERVA · CONTENIDO EVERGREEN": "RISERVA · CONTENUTO EVERGREEN",
  "REVOCAR": "REVOCA",
  "SEGUIDORES": "FOLLOWER",
  "VER CALENDARIO": "VEDI CALENDARIO",
  "VER TODO": "VEDI TUTTO",
});


// Pass 3 - Overview specific
Object.assign(DICT.en ||= {}, {
  "Hola,": "Hi,",
  "agente": "agent",
  "PROGRAMA DE REFERIDOS": "REFERRAL PROGRAM",
  "Invita y gana": "Invite & earn",
  "30 días Pro": "30 days Pro",
  "gratis. Tu código:": "free. Your code:",
  "IMÁGENES": "IMAGES",
  "REDES": "NETWORKS",
  "POSTS GEN.": "POSTS GEN.",
  "POSTS PUBLICADOS": "POSTS PUBLISHED",
  "DÍAS BONUS": "BONUS DAYS",
  "DIAS BONUS": "BONUS DAYS",
  "Sin posts pendientes. La IA aún no ha generado nada. Ve al Generador.": "No pending posts. The AI hasn't generated anything yet. Go to the Generator.",
  "Nada programado.": "Nothing scheduled.",
});
Object.assign(DICT.pt ||= {}, {
  "Hola,": "Olá,",
  "agente": "agente",
  "PROGRAMA DE REFERIDOS": "PROGRAMA DE INDICAÇÕES",
  "Invita y gana": "Convide e ganhe",
  "30 días Pro": "30 dias Pro",
  "gratis. Tu código:": "grátis. Seu código:",
  "IMÁGENES": "IMAGENS",
  "REDES": "REDES",
  "POSTS GEN.": "POSTS GER.",
  "POSTS PUBLICADOS": "POSTS PUBLICADOS",
  "DÍAS BONUS": "DIAS BÔNUS",
  "DIAS BONUS": "DIAS BÔNUS",
  "Sin posts pendientes. La IA aún no ha generado nada. Ve al Generador.": "Sem posts pendentes. A IA ainda não gerou nada. Vá ao Gerador.",
  "Nada programado.": "Nada agendado.",
});
Object.assign(DICT.fr ||= {}, {
  "Hola,": "Salut,",
  "agente": "agent",
  "PROGRAMA DE REFERIDOS": "PROGRAMME DE PARRAINAGE",
  "Invita y gana": "Invitez et gagnez",
  "30 días Pro": "30 jours Pro",
  "gratis. Tu código:": "gratuits. Votre code :",
  "IMÁGENES": "IMAGES",
  "REDES": "RÉSEAUX",
  "POSTS GEN.": "POSTS GÉN.",
  "POSTS PUBLICADOS": "POSTS PUBLIÉS",
  "DÍAS BONUS": "JOURS BONUS",
  "DIAS BONUS": "JOURS BONUS",
  "Sin posts pendientes. La IA aún no ha generado nada. Ve al Generador.": "Aucun post en attente. L'IA n'a encore rien généré. Allez au Générateur.",
  "Nada programado.": "Rien de planifié.",
});
Object.assign(DICT.de ||= {}, {
  "Hola,": "Hallo,",
  "agente": "Agent",
  "PROGRAMA DE REFERIDOS": "EMPFEHLUNGSPROGRAMM",
  "Invita y gana": "Einladen & verdienen",
  "30 días Pro": "30 Tage Pro",
  "gratis. Tu código:": "gratis. Dein Code:",
  "IMÁGENES": "BILDER",
  "REDES": "NETZWERKE",
  "POSTS GEN.": "POSTS GEN.",
  "POSTS PUBLICADOS": "VERÖFFENTLICHTE POSTS",
  "DÍAS BONUS": "BONUS-TAGE",
  "DIAS BONUS": "BONUS-TAGE",
  "Sin posts pendientes. La IA aún no ha generado nada. Ve al Generador.": "Keine ausstehenden Posts. Die KI hat noch nichts generiert. Geh zum Generator.",
  "Nada programado.": "Nichts geplant.",
});
Object.assign(DICT.it ||= {}, {
  "Hola,": "Ciao,",
  "agente": "agente",
  "PROGRAMA DE REFERIDOS": "PROGRAMMA REFERRAL",
  "Invita y gana": "Invita e guadagna",
  "30 días Pro": "30 giorni Pro",
  "gratis. Tu código:": "gratis. Il tuo codice:",
  "IMÁGENES": "IMMAGINI",
  "REDES": "RETI",
  "POSTS GEN.": "POST GEN.",
  "POSTS PUBLICADOS": "POST PUBBLICATI",
  "DÍAS BONUS": "GIORNI BONUS",
  "DIAS BONUS": "GIORNI BONUS",
  "Sin posts pendientes. La IA aún no ha generado nada. Ve al Generador.": "Nessun post in attesa. L'IA non ha ancora generato nulla. Vai al Generatore.",
  "Nada programado.": "Niente programmato.",
});


// Pass 3 batch translations (Iter 17)
Object.assign(DICT.en ||= {}, {
  "% CONVERSIÓN": "% CONVERSION",
  "+VIDEO (2×)": "+VIDEO (2×)",
  "/MES": "/MONTH",
  "1 rede social": "1 social network",
  "10 posts/mes generados": "10 posts/month generated",
  "2 MESES GRATIS": "2 MONTHS FREE",
  "2 rondas de revisión": "2 rounds of review",
  "3 opciones de slogan": "3 slogan options",
  "ACTIVAR +VIDEO · $198/MES": "ACTIVATE +VIDEO · $198/MONTH",
  "ACTIVAR 2FA": "ACTIVATE 2FA",
  "AGENCIA": "AGENCY",
  "AGREGAR COMPETIDOR": "ADD COMPETITOR",
  "AHORRA HASTA 17%": "SAVE UP TO 17%",
  "ANUAL": "ANNUAL",
  "AUTOPILOT INACTIVO": "AUTOPILOT INACTIVE",
  "Activa el add-on de Video para generar contenido Reels/TikTok/Shorts con IA. Cuesta 2× o preço do seu plano e permite até 1 vídeo por día. Puedes elegir qué tan seguido: diario, semanal, cada 15 días o personalizado.": "Activate the Video add-on to generate AI-powered Reels/TikTok/Shorts content. It costs 2× the price of your plan and allows up to 1 video per day. You can choose how often: daily, weekly, bi-weekly, or custom.",
  "Ambos ganan 30 días Pro": "Both earn 30 days Pro",
  "Analytics básico": "Basic Analytics",
  "Brand voice": "Brand voice",
  "BÁSICO": "BASIC",
  "CAMBIAR PLAN": "CHANGE PLAN",
  "CAPTION": "CAPTION",
  "CARRUSEL": "CAROUSEL",
  "CONECTAR (DEMO)": "CONNECT (DEMO)",
  "Casual": "Casual",
  "Cuentas conectadas": "Connected accounts",
  "DIVERTIDO": "FUN",
  "Display + texto · licencia comercial": "Display + text · commercial license",
  "ELEGIR": "CHOOSE",
  "EMBUDO · 7D": "FUNNEL · 7D",
  "EMPEZAR GRATIS": "START FREE",
  "El bonus se activa automáticamente. Se acumula cuando el referido paga una suscripción.": "The bonus is activated automatically. It accumulates when the referral pays for a subscription.",
  "Elige tu plan · elige cómo pagar · opcionalmente añade el módulo de Videos IA. Cancela cuando quieras. Soporte en español.": "Choose your plan · choose how to pay · optionally add the AI Videos module. Cancel anytime. Support in Spanish.",
  "English": "English",
  "Español": "Spanish",
  "Español (AR)": "Spanish (AR)",
  "Español (CO)": "Spanish (CO)",
  "Español (ES)": "Spanish (ES)",
  "Español (MX)": "Spanish (MX)",
  "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.": "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.",
  "Experto": "Expert",
  "FAVORITOS": "FAVORITES",
  "FLEXIBILIDAD TOTAL": "TOTAL FLEXIBILITY",
  "Feed pendiente": "Pending feed",
  "GENERAR": "GENERATE",
  "GENERAR ARTÍCULO OPTIMIZADO": "GENERATE OPTIMIZED ARTICLE",
  "GENERAR IMAGEN": "GENERATE IMAGE",
  "GENERAR KEY": "GENERATE KEY",
  "GRATIS": "FREE",
  "GUARDAR": "SAVE",
  "Gratis": "Free",
  "Guía de marca": "Brand Guide",
  "HILO": "THREAD",
  "HOY": "TODAY",
  "IDIOMA": "LANGUAGE",
  "INDUSTRIA": "INDUSTRY",
  "INICIAL": "INITIAL",
  "INSTRUCCIONES EXTRA": "EXTRA INSTRUCTIONS",
  "Incluidas sin costo": "Included at no cost",
  "KEYWORDS (SEPARADAS POR COMA)": "KEYWORDS (COMMA SEPARATED)",
  "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)": "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)",
  "LOGO URL (OPCIONAL)": "LOGO URL (OPTIONAL)",
  "Landing de 1 página · responsive · hosting incluido 1er año": "1-page landing · responsive · hosting included 1st year",
  "Launch price -66%": "Launch price -66%",
  "Logo principal + variantes": "Main logo + variants",
  "MENSUAL": "MONTHLY",
  "Mejora cuando lo necesites": "Upgrade when you need it",
  "Multi-idioma · probados con IA + humanos": "Multi-language · tested with AI + humans",
  "NO": "NO",
  "NOMBRE": "NAME",
  "NUEVOS USUARIOS": "NEW USERS",
  "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly": "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly",
  "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT": "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT",
  "ORDEN": "ORDER",
  "PAGADOS": "PAID",
  "PAGOS PENDIENTES": "PENDING PAYMENTS",
  "PALABRAS": "WORDS",
  "PALABRAS PROHIBIDAS (COMA)": "FORBIDDEN WORDS (COMMA)",
  "PDF 12 páginas · uso correcto · ejemplos": "PDF 12 pages · correct use · examples",
  "PNG, SVG, AI, Figma · favicon incluido": "PNG, SVG, AI, Figma · favicon included",
  "POST": "POST",
  "PRO": "PRO",
  "PROFESIONAL": "PROFESSIONAL",
  "PROGRAMA · REFERIDOS": "PROGRAM · REFERRALS",
  "Paga cada mes": "Pay monthly",
  "Pago único. Sin suscripción. Entrega garantizada en 72h hábiles. Si no te gusta ninguna propuesta, devolvemos el 100%.": "One-time payment. No subscription. Guaranteed delivery in 72 business hours. If you don't like any proposal, we refund 100%.",
  "Paleta de colores": "Color palette",
  "Panel operativo": "Operational panel",
  "Persuasivo": "Persuasive",
  "Populares": "Popular",
  "Português": "Portuguese",
  "Português (BR)": "Portuguese (BR)",
  "Primarios · secundarios · de fondo · con códigos HEX/RGB": "Primary · secondary · background · with HEX/RGB codes",
  "Profesional": "Professional",
  "Programación manual": "Manual scheduling",
  "Página web básica": "Basic website",
  "QUOTE · ONE-TIME": "QUOTE · ONE-TIME",
  "RED": "NETWORK",
  "REFERIDOS TOTAL": "TOTAL REFERRALS",
  "Recientes": "Recent",
  "SCRIPT REEL": "SCRIPT REEL",
  "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE": "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE",
  "STANDARD": "STANDARD",
  "Sin imágenes AI": "No AI images",
  "Sin programación automática": "No automatic scheduling",
  "Sin videos IA": "No AI videos",
  "Spanish (MX)": "Spanish (MX)",
  "SÍ": "YES",
  "TARIFA · TRANSPARENTE": "RATE · TRANSPARENT",
  "TEMA": "THEME",
  "TEMA / BRIEF": "THEME / BRIEF",
  "TODOS": "ALL",
  "TONO": "TONE",
  "TOPICS (MAX 10, COMMA)": "TOPICS (MAX 10, COMMA)",
  "Tipografía": "Typography",
  "Todas las redes sociales": "All social networks",
  "Tono · palabras clave · palabras prohibidas · 3 ejemplos": "Tone · keywords · forbidden words · 3 examples",
  "URL / HANDLE": "URL / HANDLE",
  "USUARIOS": "USERS",
  "VARIANTES": "VARIANTS",
  "Videos IA verticales": "Vertical AI videos",
  "cafe": "coffee",
  "creada": "created",
  "ecommerce": "ecommerce",
  "ingreso promedio por usuario pagado": "average revenue per paid user",
  "ingresos mensuales recurrentes": "monthly recurring revenue",
  "proyección anualizada": "annualized projection",
  "retail": "retail",
  "saas": "SaaS",
  "servicios": "services",
  "tech": "tech",
  "todas": "all",
  "todos": "all",
  "último uso": "last use",
});
Object.assign(DICT.pt ||= {}, {
  "% CONVERSIÓN": "% CONVERSÃO",
  "+VIDEO (2×)": "+VÍDEO (2×)",
  "/MES": "/MÊS",
  "1 rede social": "1 rede social",
  "10 posts/mes generados": "10 posts/mês gerados",
  "2 MESES GRATIS": "2 MESES GRÁTIS",
  "2 rondas de revisión": "2 rodadas de revisão",
  "3 opciones de slogan": "3 opções de slogan",
  "ACTIVAR +VIDEO · $198/MES": "ATIVAR +VÍDEO · $198/MÊS",
  "ACTIVAR 2FA": "ATIVAR 2FA",
  "AGENCIA": "AGÊNCIA",
  "AGREGAR COMPETIDOR": "ADICIONAR CONCORRENTE",
  "AHORRA HASTA 17%": "ECONOMIZE ATÉ 17%",
  "ANUAL": "ANUAL",
  "AUTOPILOT INACTIVO": "PILOTO AUTOMÁTICO INATIVO",
  "Activa el add-on de Video para generar contenido Reels/TikTok/Shorts con IA. Cuesta 2× o preço do seu plano e permite hasta 1 vídeo por día. Puedes elegir qué tan seguido: diario, semanal, cada 15 días o personalizado.": "Ative o add-on de Vídeo para gerar conteúdo Reels/TikTok/Shorts com IA. Custa 2× o preço do seu plano e permite até 1 vídeo por dia. Você pode escolher a frequência: diária, semanal, a cada 15 dias ou personalizada.",
  "Ambos ganan 30 días Pro": "Ambos ganham 30 dias Pro",
  "Analytics básico": "Analytics básico",
  "Brand voice": "Brand voice",
  "BÁSICO": "BÁSICO",
  "CAMBIAR PLAN": "MUDAR PLANO",
  "CAPTION": "LEGENDA",
  "CARRUSEL": "CARROSSEL",
  "CONECTAR (DEMO)": "CONECTAR (DEMO)",
  "Casual": "Casual",
  "Cuentas conectadas": "Contas conectadas",
  "DIVERTIDO": "DIVERTIDO",
  "Display + texto · licencia comercial": "Display + texto · licença comercial",
  "ELEGIR": "ESCOLHER",
  "EMBUDO · 7D": "FUNIL · 7D",
  "EMPEZAR GRATIS": "COMEÇAR GRÁTIS",
  "El bonus se activa automáticamente. Se acumula cuando el referido paga una suscripción.": "O bônus é ativado automaticamente. Ele se acumula quando o indicado paga uma assinatura.",
  "Elige tu plan · elige cómo pagar · opcionalmente añade el módulo de Videos IA. Cancela cuando quieras. Soporte en español.": "Escolha seu plano · escolha como pagar · opcionalmente adicione o módulo de Vídeos IA. Cancele quando quiser. Suporte em português.",
  "English": "English",
  "Español": "Espanhol",
  "Español (AR)": "Espanhol (AR)",
  "Español (CO)": "Espanhol (CO)",
  "Español (ES)": "Espanhol (ES)",
  "Español (MX)": "Espanhol (MX)",
  "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.": "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.",
  "Experto": "Especialista",
  "FAVORITOS": "FAVORITOS",
  "FLEXIBILIDAD TOTAL": "FLEXIBILIDADE TOTAL",
  "Feed pendiente": "Feed pendente",
  "GENERAR": "GERAR",
  "GENERAR ARTÍCULO OPTIMIZADO": "GERAR ARTIGO OTIMIZADO",
  "GENERAR IMAGEN": "GERAR IMAGEM",
  "GENERAR KEY": "GERAR CHAVE",
  "GRATIS": "GRÁTIS",
  "GUARDAR": "SALVAR",
  "Gratis": "Grátis",
  "Guía de marca": "Guia de marca",
  "HILO": "FIO",
  "HOY": "HOJE",
  "IDIOMA": "IDIOMA",
  "INDUSTRIA": "SETOR",
  "INICIAL": "INICIAL",
  "INSTRUCCIONES EXTRA": "INSTRUÇÕES EXTRAS",
  "Incluidas sin costo": "Incluídas sem custo",
  "KEYWORDS (SEPARADAS POR COMA)": "PALAVRAS-CHAVE (SEPARADAS POR VÍRGULA)",
  "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)": "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)",
  "LOGO URL (OPCIONAL)": "URL DO LOGO (OPCIONAL)",
  "Landing de 1 página · responsive · hosting incluido 1er año": "Landing page de 1 página · responsiva · hospedagem incluída 1º ano",
  "Launch price -66%": "Launch price -66%",
  "Logo principal + variantes": "Logo principal + variantes",
  "MENSUAL": "MENSAL",
  "Mejora cuando lo necesites": "Melhore quando precisar",
  "Multi-idioma · probados con IA + humanos": "Multi-idioma · testados com IA + humanos",
  "NO": "NÃO",
  "NOMBRE": "NOME",
  "NUEVOS USUARIOS": "NOVOS USUÁRIOS",
  "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly": "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly",
  "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT": "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT",
  "ORDEN": "ORDEM",
  "PAGADOS": "PAGOS",
  "PAGOS PENDIENTES": "PAGAMENTOS PENDENTES",
  "PALABRAS": "PALAVRAS",
  "PALABRAS PROHIBIDAS (COMA)": "PALAVRAS PROIBIDAS (VÍRGULA)",
  "PDF 12 páginas · uso correcto · ejemplos": "PDF 12 páginas · uso correto · exemplos",
  "PNG, SVG, AI, Figma · favicon incluido": "PNG, SVG, AI, Figma · favicon incluído",
  "POST": "POST",
  "PRO": "PRO",
  "PROFESIONAL": "PROFISSIONAL",
  "PROGRAMA · REFERIDOS": "PROGRAMA · DE REFERÊNCIA",
  "Paga cada mes": "Pague a cada mês",
  "Pago único. Sin suscripción. Entrega garantizada en 72h hábiles. Si no te gusta ninguna propuesta, devolvemos el 100%.": "Pagamento único. Sem assinatura. Entrega garantida em 72h úteis. Se não gostar de nenhuma proposta, devolvemos 100%.",
  "Paleta de colores": "Paleta de cores",
  "Panel operativo": "Painel operacional",
  "Persuasivo": "Persuasivo",
  "Populares": "Populares",
  "Português": "Português",
  "Português (BR)": "Português (BR)",
  "Primarios · secundarios · de fondo · con códigos HEX/RGB": "Primárias · secundárias · de fundo · com códigos HEX/RGB",
  "Profesional": "Profissional",
  "Programación manual": "Programação manual",
  "Página web básica": "Página web básica",
  "QUOTE · ONE-TIME": "QUOTE · ONE-TIME",
  "RED": "REDE",
  "REFERIDOS TOTAL": "TOTAL DE INDICADOS",
  "Recientes": "Recentes",
  "SCRIPT REEL": "SCRIPT REEL",
  "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE": "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE",
  "STANDARD": "STANDARD",
  "Sin imágenes AI": "Sem imagens IA",
  "Sin programación automática": "Sem agendamento automático",
  "Sin videos IA": "Sem vídeos IA",
  "Spanish (MX)": "Espanhol (MX)",
  "SÍ": "SIM",
  "TARIFA · TRANSPARENTE": "TARIFA · TRANSPARENTE",
  "TEMA": "TEMA",
  "TEMA / BRIEF": "TEMA / BRIEF",
  "TODOS": "TODOS",
  "TONO": "TOM",
  "TOPICS (MAX 10, COMMA)": "TOPICS (MAX 10, COMMA)",
  "Tipografía": "Tipografia",
  "Todas las redes sociales": "Todas as redes sociais",
  "Tono · palabras clave · palabras prohibidas · 3 ejemplos": "Tom · palavras-chave · palavras proibidas · 3 exemplos",
  "URL / HANDLE": "URL / HANDLE",
  "USUARIOS": "USUÁRIOS",
  "VARIANTES": "VARIANTES",
  "Videos IA verticales": "Vídeos IA verticais",
  "cafe": "café",
  "creada": "criada",
  "ecommerce": "e-commerce",
  "ingreso promedio por usuario pagado": "receita média por usuário pago",
  "ingresos mensuales recurrentes": "receita mensal recorrente",
  "proyección anualizada": "projeção anualizada",
  "retail": "varejo",
  "saas": "saas",
  "servicios": "serviços",
  "tech": "tecnologia",
  "todas": "todas",
  "todos": "todos",
  "último uso": "último uso",
});
Object.assign(DICT.fr ||= {}, {
  "% CONVERSIÓN": "% CONVERSION",
  "+VIDEO (2×)": "+VIDÉO (2×)",
  "/MES": "/MOIS",
  "1 rede social": "1 réseau social",
  "10 posts/mes generados": "10 publications/mois générées",
  "2 MESES GRATIS": "2 MOIS GRATUITS",
  "2 rondas de revisión": "2 séries de révisions",
  "3 opciones de slogan": "3 options de slogan",
  "ACTIVAR +VIDEO · $198/MES": "ACTIVER +VIDÉO · 198 $/MOIS",
  "ACTIVAR 2FA": "ACTIVER 2FA",
  "AGENCIA": "AGENCE",
  "AGREGAR COMPETIDOR": "AJOUTER UN CONCURRENT",
  "AHORRA HASTA 17%": "ÉCONOMISEZ JUSQU'À 17%",
  "ANUAL": "ANNUEL",
  "AUTOPILOT INACTIVO": "PILOTE AUTOMATIQUE INACTIF",
  "Activa el add-on de Video para generar contenido Reels/TikTok/Shorts con IA. Cuesta 2× o preço do seu plano e permite hasta 1 vídeo por día. Puedes elegir qué tan seguido: diario, semanal, cada 15 días o personalizado.": "Active l'add-on Vidéo pour générer du contenu Reels/TikTok/Shorts avec l'IA. Cela coûte 2× le prix de votre plan et permet jusqu'à 1 vidéo par jour. Vous pouvez choisir la fréquence : quotidienne, hebdomadaire, tous les 15 jours ou personnalisée.",
  "Ambos ganan 30 días Pro": "Les deux gagnent 30 jours Pro",
  "Analytics básico": "Analytiques de base",
  "Brand voice": "Brand voice",
  "BÁSICO": "BASIQUE",
  "CAMBIAR PLAN": "CHANGER DE PLAN",
  "CAPTION": "CAPTION",
  "CARRUSEL": "CARROUSEL",
  "CONECTAR (DEMO)": "CONNECTER (DÉMO)",
  "Casual": "Décontracté",
  "Cuentas conectadas": "Comptes connectés",
  "DIVERTIDO": "AMUSANT",
  "Display + texto · licencia comercial": "Affichage + texte · licence commerciale",
  "ELEGIR": "CHOISIR",
  "EMBUDO · 7D": "ENTONNOIR · 7J",
  "EMPEZAR GRATIS": "COMMENCER GRATUITEMENT",
  "El bonus se activa automáticamente. Se acumula cuando el referido paga una suscripción.": "Le bonus est activé automatiquement. Il est accumulé lorsque le filleul paie un abonnement.",
  "Elige tu plan · elige cómo pagar · opcionalmente añade el módulo de Videos IA. Cancela cuando quieras. Soporte en español.": "Choisissez votre plan · choisissez comment payer · ajoutez éventuellement le module Vidéos IA. Annulez quand vous voulez. Support en espagnol.",
  "English": "English",
  "Español": "Español",
  "Español (AR)": "Español (AR)",
  "Español (CO)": "Español (CO)",
  "Español (ES)": "Español (ES)",
  "Español (MX)": "Español (MX)",
  "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.": "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.",
  "Experto": "Expert",
  "FAVORITOS": "FAVORIS",
  "FLEXIBILIDAD TOTAL": "FLEXIBILITÉ TOTALE",
  "Feed pendiente": "Flux en attente",
  "GENERAR": "GÉNÉRER",
  "GENERAR ARTÍCULO OPTIMIZADO": "GÉNÉRER UN ARTICLE OPTIMISÉ",
  "GENERAR IMAGEN": "GÉNÉRER UNE IMAGE",
  "GENERAR KEY": "GÉNÉRER UNE CLÉ",
  "GRATIS": "GRATUIT",
  "GUARDAR": "ENREGISTRER",
  "Gratis": "Gratuit",
  "Guía de marca": "Guide de marque",
  "HILO": "FIL",
  "HOY": "AUJOURD'HUI",
  "IDIOMA": "LANGUE",
  "INDUSTRIA": "INDUSTRIE",
  "INICIAL": "INITIAL",
  "INSTRUCCIONES EXTRA": "INSTRUCTIONS SUPPLÉMENTAIRES",
  "Incluidas sin costo": "Inclus sans frais",
  "KEYWORDS (SEPARADAS POR COMA)": "MOTS-CLÉS (SÉPARÉS PAR UNE VIRGULE)",
  "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)": "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)",
  "LOGO URL (OPCIONAL)": "URL DU LOGO (OPTIONNEL)",
  "Landing de 1 página · responsive · hosting incluido 1er año": "Page d'atterrissage 1 page · responsive · hébergement inclus 1ère année",
  "Launch price -66%": "Launch price -66%",
  "Logo principal + variantes": "Logo principal + variantes",
  "MENSUAL": "MENSUEL",
  "Mejora cuando lo necesites": "Passez à la version supérieure quand vous en avez besoin",
  "Multi-idioma · probados con IA + humanos": "Multi-langues · testés avec IA + humains",
  "NO": "NON",
  "NOMBRE": "NOM",
  "NUEVOS USUARIOS": "NOUVEAUX UTILISATEURS",
  "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly": "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly",
  "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT": "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT",
  "ORDEN": "ORDRE",
  "PAGADOS": "PAYÉS",
  "PAGOS PENDIENTES": "PAIEMENTS EN ATTENTE",
  "PALABRAS": "MOTS",
  "PALABRAS PROHIBIDAS (COMA)": "MOTS INTERDITS (VIRGULE)",
  "PDF 12 páginas · uso correcto · ejemplos": "PDF 12 pages · utilisation correcte · exemples",
  "PNG, SVG, AI, Figma · favicon incluido": "PNG, SVG, AI, Figma · favicon inclus",
  "POST": "POST",
  "PRO": "PRO",
  "PROFESIONAL": "PROFESSIONNEL",
  "PROGRAMA · REFERIDOS": "PROGRAMME · PARRAINAGE",
  "Paga cada mes": "Payez chaque mois",
  "Pago único. Sin suscripción. Entrega garantizada en 72h hábiles. Si no te gusta ninguna propuesta, devolvemos el 100%.": "Paiement unique. Sans abonnement. Livraison garantie en 72h ouvrables. Si aucune proposition ne vous plaît, nous remboursons 100 %.",
  "Paleta de colores": "Palette de couleurs",
  "Panel operativo": "Tableau de bord",
  "Persuasivo": "Persuasif",
  "Populares": "Populaires",
  "Português": "Portugais",
  "Português (BR)": "Portugais (BR)",
  "Primarios · secundarios · de fondo · con códigos HEX/RGB": "Primaires · secondaires · de fond · avec codes HEX/RGB",
  "Profesional": "Professionnel",
  "Programación manual": "Planification manuelle",
  "Página web básica": "Site web basique",
  "QUOTE · ONE-TIME": "QUOTE · ONE-TIME",
  "RED": "RÉSEAU",
  "REFERIDOS TOTAL": "PARRAINAGES TOTAL",
  "Recientes": "Récents",
  "SCRIPT REEL": "SCRIPT REEL",
  "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE": "PAIEMENT SÉCURISÉ VIA STRIPE · MXN DISPONIBLE",
  "STANDARD": "STANDARD",
  "Sin imágenes AI": "Sans images IA",
  "Sin programación automática": "Sans programmation automatique",
  "Sin videos IA": "Sans vidéos IA",
  "Spanish (MX)": "Espagnol (MX)",
  "SÍ": "OUI",
  "TARIFA · TRANSPARENTE": "TARIF · TRANSPARENT",
  "TEMA": "THÈME",
  "TEMA / BRIEF": "THÈME / BRIEF",
  "TODOS": "TOUS",
  "TONO": "TON",
  "TOPICS (MAX 10, COMMA)": "TOPICS (MAX 10, COMMA)",
  "Tipografía": "Typographie",
  "Todas las redes sociales": "Tous les réseaux sociaux",
  "Tono · palabras clave · palabras prohibidas · 3 ejemplos": "Ton · mots-clés · mots interdits · 3 exemples",
  "URL / HANDLE": "URL / HANDLE",
  "USUARIOS": "UTILISATEURS",
  "VARIANTES": "VARIANTES",
  "Videos IA verticales": "Vidéos IA verticales",
  "cafe": "café",
  "creada": "créée",
  "ecommerce": "e-commerce",
  "ingreso promedio por usuario pagado": "revenu moyen par utilisateur payant",
  "ingresos mensuales recurrentes": "revenus mensuels récurrents",
  "proyección anualizada": "projection annualisée",
  "retail": "commerce de détail",
  "saas": "saas",
  "servicios": "services",
  "tech": "tech",
  "todas": "toutes",
  "todos": "tous",
  "último uso": "dernière utilisation",
});
Object.assign(DICT.de ||= {}, {
  "% CONVERSIÓN": "% KONVERSION",
  "+VIDEO (2×)": "+VIDEO (2×)",
  "/MES": "/MONAT",
  "1 rede social": "1 soziales Netzwerk",
  "10 posts/mes generados": "10 Posts/Monat generiert",
  "2 MESES GRATIS": "2 MONATE GRATIS",
  "2 rondas de revisión": "2 Revisionsrunden",
  "3 opciones de slogan": "3 Slogan-Optionen",
  "ACTIVAR +VIDEO · $198/MES": "AKTIVIEREN +VIDEO · 198 $/MONAT",
  "ACTIVAR 2FA": "2FA AKTIVIEREN",
  "AGENCIA": "AGENTUR",
  "AGREGAR COMPETIDOR": "WETTBEWERBER HINZUFÜGEN",
  "AHORRA HASTA 17%": "BIS ZU 17 % SPAREN",
  "ANUAL": "JÄHRLICH",
  "AUTOPILOT INACTIVO": "AUTOPILOT INAKTIV",
  "Activa el add-on de Video para generar contenido Reels/TikTok/Shorts con IA. Cuesta 2× o preço do seu plano e permite hasta 1 vídeo por día. Puedes elegir qué tan seguido: diario, semanal, cada 15 días o personalizado.": "Aktiviere das Video-Add-on, um Reels/TikTok/Shorts-Inhalte mit KI zu generieren. Es kostet das 2-fache des Preises deines Plans und erlaubt bis zu 1 Video pro Tag. Du kannst wählen, wie oft: täglich, wöchentlich, alle 15 Tage oder benutzerdefiniert.",
  "Ambos ganan 30 días Pro": "Beide erhalten 30 Tage Pro",
  "Analytics básico": "Basis-Analytics",
  "Brand voice": "Brand voice",
  "BÁSICO": "BASIS",
  "CAMBIAR PLAN": "PLAN ÄNDERN",
  "CAPTION": "CAPTION",
  "CARRUSEL": "KARUSSELL",
  "CONECTAR (DEMO)": "VERBINDEN (DEMO)",
  "Casual": "Casual",
  "Cuentas conectadas": "Verbundene Konten",
  "DIVERTIDO": "LUSTIG",
  "Display + texto · licencia comercial": "Display + Text · kommerzielle Lizenz",
  "ELEGIR": "AUSWÄHLEN",
  "EMBUDO · 7D": "TRICHTER · 7T",
  "EMPEZAR GRATIS": "KOSTENLOS STARTEN",
  "El bonus se activa automáticamente. Se acumula cuando el referido paga una suscripción.": "Der Bonus wird automatisch aktiviert. Er wird gutgeschrieben, wenn der Geworbene ein Abonnement bezahlt.",
  "Elige tu plan · elige cómo pagar · opcionalmente añade el módulo de Videos IA. Cancela cuando quieras. Soporte en español.": "Wähle deinen Plan · wähle, wie du bezahlen möchtest · füge optional das KI-Videos-Modul hinzu. Jederzeit kündbar. Support auf Spanisch.",
  "English": "English",
  "Español": "Spanisch",
  "Español (AR)": "Spanisch (AR)",
  "Español (CO)": "Spanisch (CO)",
  "Español (ES)": "Spanisch (ES)",
  "Español (MX)": "Spanisch (MX)",
  "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.": "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.",
  "Experto": "Experte",
  "FAVORITOS": "FAVORITEN",
  "FLEXIBILIDAD TOTAL": "VOLLE FLEXIBILITÄT",
  "Feed pendiente": "Ausstehender Feed",
  "GENERAR": "GENERIEREN",
  "GENERAR ARTÍCULO OPTIMIZADO": "OPTIMIERTEN ARTIKEL GENERIEREN",
  "GENERAR IMAGEN": "BILD GENERIEREN",
  "GENERAR KEY": "KEY GENERIEREN",
  "GRATIS": "GRATIS",
  "GUARDAR": "SPEICHERN",
  "Gratis": "Kostenlos",
  "Guía de marca": "Markenrichtlinien",
  "HILO": "THREAD",
  "HOY": "HEUTE",
  "IDIOMA": "SPRACHE",
  "INDUSTRIA": "BRANCHE",
  "INICIAL": "START",
  "INSTRUCCIONES EXTRA": "ZUSÄTZLICHE ANWEISUNGEN",
  "Incluidas sin costo": "Kostenlos enthalten",
  "KEYWORDS (SEPARADAS POR COMA)": "KEYWORDS (DURCH KOMMA GETRENNT)",
  "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)": "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)",
  "LOGO URL (OPCIONAL)": "LOGO URL (OPTIONAL)",
  "Landing de 1 página · responsive · hosting incluido 1er año": "1-seitige Landingpage · responsiv · Hosting im 1. Jahr inbegriffen",
  "Launch price -66%": "Launch price -66%",
  "Logo principal + variantes": "Hauptlogo + Varianten",
  "MENSUAL": "MONATLICH",
  "Mejora cuando lo necesites": "Upgrade, wenn du es brauchst",
  "Multi-idioma · probados con IA + humanos": "Mehrsprachig · mit KI + Menschen getestet",
  "NO": "NEIN",
  "NOMBRE": "NAME",
  "NUEVOS USUARIOS": "NEUE BENUTZER",
  "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly": "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly",
  "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT": "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT",
  "ORDEN": "BESTELLUNG",
  "PAGADOS": "BEZAHLT",
  "PAGOS PENDIENTES": "AUSSTEHENDE ZAHLUNGEN",
  "PALABRAS": "WÖRTER",
  "PALABRAS PROHIBIDAS (COMA)": "VERBOTENE WÖRTER (KOMMA)",
  "PDF 12 páginas · uso correcto · ejemplos": "PDF 12 Seiten · korrekte Anwendung · Beispiele",
  "PNG, SVG, AI, Figma · favicon incluido": "PNG, SVG, AI, Figma · Favicon enthalten",
  "POST": "BEITRAG",
  "PRO": "PRO",
  "PROFESIONAL": "PROFESSIONELL",
  "PROGRAMA · REFERIDOS": "PROGRAMM · EMPFEHLUNGEN",
  "Paga cada mes": "Jeden Monat zahlen",
  "Pago único. Sin suscripción. Entrega garantizada en 72h hábiles. Si no te gusta ninguna propuesta, devolvemos el 100%.": "Einmalzahlung. Kein Abonnement. Garantierte Lieferung innerhalb von 72 Arbeitsstunden. Wenn dir kein Vorschlag gefällt, erstatten wir 100% zurück.",
  "Paleta de colores": "Farbpalette",
  "Panel operativo": "Bedienfeld",
  "Persuasivo": "Überzeugend",
  "Populares": "Beliebte",
  "Português": "Portugiesisch",
  "Português (BR)": "Portugiesisch (BR)",
  "Primarios · secundarios · de fondo · con códigos HEX/RGB": "Primär · sekundär · Hintergrund · mit HEX/RGB-Codes",
  "Profesional": "Professionell",
  "Programación manual": "Manuelle Planung",
  "Página web básica": "Basis-Website",
  "QUOTE · ONE-TIME": "QUOTE · ONE-TIME",
  "RED": "NETZWERK",
  "REFERIDOS TOTAL": "GESAMTE EMPFEHLUNGEN",
  "Recientes": "Neueste",
  "SCRIPT REEL": "SKRIPT REEL",
  "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE": "SICHERE ZAHLUNG ÜBER STRIPE · MXN VERFÜGBAR",
  "STANDARD": "STANDARD",
  "Sin imágenes AI": "Keine KI-Bilder",
  "Sin programación automática": "Keine automatische Planung",
  "Sin videos IA": "Keine KI-Videos",
  "Spanish (MX)": "Spanisch (MX)",
  "SÍ": "JA",
  "TARIFA · TRANSPARENTE": "PREIS · TRANSPARENT",
  "TEMA": "THEMA",
  "TEMA / BRIEF": "THEMA / BRIEFING",
  "TODOS": "ALLE",
  "TONO": "TON",
  "TOPICS (MAX 10, COMMA)": "TOPICS (MAX 10, COMMA)",
  "Tipografía": "Typografie",
  "Todas las redes sociales": "Alle sozialen Netzwerke",
  "Tono · palabras clave · palabras prohibidas · 3 ejemplos": "Ton · Schlüsselwörter · verbotene Wörter · 3 Beispiele",
  "URL / HANDLE": "URL / HANDLE",
  "USUARIOS": "BENUTZER",
  "VARIANTES": "VARIANTEN",
  "Videos IA verticales": "Vertikale KI-Videos",
  "cafe": "Kaffee",
  "creada": "erstellt",
  "ecommerce": "E-Commerce",
  "ingreso promedio por usuario pagado": "durchschnittlicher Umsatz pro bezahltem Nutzer",
  "ingresos mensuales recurrentes": "monatlich wiederkehrender Umsatz",
  "proyección anualizada": "annualisierte Prognose",
  "retail": "Einzelhandel",
  "saas": "saas",
  "servicios": "Dienstleistungen",
  "tech": "Technologie",
  "todas": "alle",
  "todos": "alle",
  "último uso": "letzte Verwendung",
});
Object.assign(DICT.it ||= {}, {
  "% CONVERSIÓN": "% CONVERSIONE",
  "+VIDEO (2×)": "+VIDEO (2×)",
  "/MES": "/MESE",
  "1 rede social": "1 social network",
  "10 posts/mes generados": "10 post/mese generati",
  "2 MESES GRATIS": "2 MESI GRATIS",
  "2 rondas de revisión": "2 cicli di revisione",
  "3 opciones de slogan": "3 opzioni di slogan",
  "ACTIVAR +VIDEO · $198/MES": "ATTIVA +VIDEO · $198/MESE",
  "ACTIVAR 2FA": "ATTIVA 2FA",
  "AGENCIA": "AGENZIA",
  "AGREGAR COMPETIDOR": "AGGIUNGI CONCORRENTE",
  "AHORRA HASTA 17%": "RISPARMIA FINO AL 17%",
  "ANUAL": "ANNUALE",
  "AUTOPILOT INACTIVO": "AUTOPILOTA INATTIVO",
  "Activa el add-on de Video para generar contenido Reels/TikTok/Shorts con IA. Cuesta 2× o preço do seu plano e permite hasta 1 vídeo por día. Puedes elegir qué tan seguido: diario, semanal, cada 15 días o personalizado.": "Attiva l'add-on Video per generare contenuti Reels/TikTok/Shorts con IA. Costa 2× il prezzo del tuo piano e permette fino a 1 video al giorno. Puoi scegliere la frequenza: giornaliera, settimanale, ogni 15 giorni o personalizzata.",
  "Ambos ganan 30 días Pro": "Entrambi guadagnano 30 giorni Pro",
  "Analytics básico": "Analytics di base",
  "Brand voice": "Brand voice",
  "BÁSICO": "BASE",
  "CAMBIAR PLAN": "CAMBIA PIANO",
  "CAPTION": "DIDASCALIA",
  "CARRUSEL": "CAROSELLO",
  "CONECTAR (DEMO)": "COLLEGA (DEMO)",
  "Casual": "Casual",
  "Cuentas conectadas": "Account collegati",
  "DIVERTIDO": "DIVERTENTE",
  "Display + texto · licencia comercial": "Display + testo · licenza commerciale",
  "ELEGIR": "SCEGLI",
  "EMBUDO · 7D": "IMBUTO · 7G",
  "EMPEZAR GRATIS": "INIZIA GRATIS",
  "El bonus se activa automáticamente. Se acumula cuando el referido paga una suscripción.": "Il bonus si attiva automaticamente. Si accumula quando il referral paga un abbonamento.",
  "Elige tu plan · elige cómo pagar · opcionalmente añade el módulo de Videos IA. Cancela cuando quieras. Soporte en español.": "Scegli il tuo piano · scegli come pagare · opzionalmente aggiungi il modulo Video IA. Annulla quando vuoi. Supporto in spagnolo.",
  "English": "English",
  "Español": "Spagnolo",
  "Español (AR)": "Spagnolo (AR)",
  "Español (CO)": "Spagnolo (CO)",
  "Español (ES)": "Spagnolo (ES)",
  "Español (MX)": "Spagnolo (MX)",
  "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.": "Even in PT, /dashboard/subscription shows: 'Videos IA verticales', 'Mejora cuando lo necesites', 'AUTOPILOT INACTIVO', 'ACTIVAR +VIDEO · $198/MES', 'CAMBIAR PLAN', 'Inicial/Básico/Pro/Agencia' plan card bodies — confirming these strings are NOT wrapped by tr() at all.",
  "Experto": "Esperto",
  "FAVORITOS": "PREFERITI",
  "FLEXIBILIDAD TOTAL": "FLESSIBILITÀ TOTALE",
  "Feed pendiente": "Feed in sospeso",
  "GENERAR": "GENERA",
  "GENERAR ARTÍCULO OPTIMIZADO": "GENERA ARTICOLO OTTIMIZZATO",
  "GENERAR IMAGEN": "GENERA IMMAGINE",
  "GENERAR KEY": "GENERA CHIAVE",
  "GRATIS": "GRATIS",
  "GUARDAR": "SALVA",
  "Gratis": "Gratis",
  "Guía de marca": "Guida al brand",
  "HILO": "FILO",
  "HOY": "OGGI",
  "IDIOMA": "LINGUA",
  "INDUSTRIA": "SETTORE",
  "INICIAL": "INIZIALE",
  "INSTRUCCIONES EXTRA": "ISTRUZIONI AGGIUNTIVE",
  "Incluidas sin costo": "Incluse senza costo",
  "KEYWORDS (SEPARADAS POR COMA)": "KEYWORD (SEPARATE DA VIRGOLA)",
  "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)": "LATEST CONFIRMED PAYMENTS (eyebrow OK, verify row labels)",
  "LOGO URL (OPCIONAL)": "URL LOGO (OPZIONALE)",
  "Landing de 1 página · responsive · hosting incluido 1er año": "Landing page di 1 pagina · responsive · hosting incluso 1° anno",
  "Launch price -66%": "Launch price -66%",
  "Logo principal + variantes": "Logo principale + varianti",
  "MENSUAL": "MENSILE",
  "Mejora cuando lo necesites": "Aggiorna quando ne hai bisogno",
  "Multi-idioma · probados con IA + humanos": "Multilingua · testati con IA + umani",
  "NO": "NO",
  "NOMBRE": "NOME",
  "NUEVOS USUARIOS": "NUOVI UTENTI",
  "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly": "No ES hits detected in EN — Overview H1 'Hi, CIA.' translates; note 'POSTS GER./IMPRESSÕES' etc. flip correctly",
  "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT": "OPERAÇÃO · PAINEL CENTRAL eyebrow is correctly translated in PT",
  "ORDEN": "ORDINE",
  "PAGADOS": "PAGATI",
  "PAGOS PENDIENTES": "PAGAMENTI IN SOSPESO",
  "PALABRAS": "PAROLE",
  "PALABRAS PROHIBIDAS (COMA)": "PAROLE PROIBITE (VIRGOLA)",
  "PDF 12 páginas · uso correcto · ejemplos": "PDF 12 pagine · uso corretto · esempi",
  "PNG, SVG, AI, Figma · favicon incluido": "PNG, SVG, AI, Figma · favicon incluso",
  "POST": "POST",
  "PRO": "PRO",
  "PROFESIONAL": "PROFESSIONALE",
  "PROGRAMA · REFERIDOS": "PROGRAMMA · REFERRAL",
  "Paga cada mes": "Paga ogni mese",
  "Pago único. Sin suscripción. Entrega garantizada en 72h hábiles. Si no te gusta ninguna propuesta, devolvemos el 100%.": "Pagamento unico. Nessun abbonamento. Consegna garantita in 72h lavorative. Se nessuna proposta ti piace, rimborsiamo il 100%.",
  "Paleta de colores": "Palette colori",
  "Panel operativo": "Pannello operativo",
  "Persuasivo": "Persuasivo",
  "Populares": "Popolari",
  "Português": "Portoghese",
  "Português (BR)": "Portoghese (BR)",
  "Primarios · secundarios · de fondo · con códigos HEX/RGB": "Primari · secondari · di sfondo · con codici HEX/RGB",
  "Profesional": "Professionale",
  "Programación manual": "Programmazione manuale",
  "Página web básica": "Sito web di base",
  "QUOTE · ONE-TIME": "QUOTE · ONE-TIME",
  "RED": "RETE",
  "REFERIDOS TOTAL": "REFERRAL TOTALI",
  "Recientes": "Recenti",
  "SCRIPT REEL": "SCRIPT REEL",
  "SECURE PAYMENT VIA STRIPE · MXN AVAILABLE": "PAGAMENTO SICURO TRAMITE STRIPE · MXN DISPONIBILI",
  "STANDARD": "STANDARD",
  "Sin imágenes AI": "Senza immagini AI",
  "Sin programación automática": "Senza programmazione automatica",
  "Sin videos IA": "Senza video IA",
  "Spanish (MX)": "Spagnolo (MX)",
  "SÍ": "SÌ",
  "TARIFA · TRANSPARENTE": "TARIFFA · TRASPARENTE",
  "TEMA": "TEMA",
  "TEMA / BRIEF": "TEMA / BRIEF",
  "TODOS": "TUTTI",
  "TONO": "TONO",
  "TOPICS (MAX 10, COMMA)": "TOPICS (MAX 10, COMMA)",
  "Tipografía": "Tipografia",
  "Todas las redes sociales": "Tutti i social media",
  "Tono · palabras clave · palabras prohibidas · 3 ejemplos": "Tono · parole chiave · parole proibite · 3 esempi",
  "URL / HANDLE": "URL / HANDLE",
  "USUARIOS": "UTENTI",
  "VARIANTES": "VARIANTI",
  "Videos IA verticales": "Video IA verticali",
  "cafe": "caffè",
  "creada": "creata",
  "ecommerce": "ecommerce",
  "ingreso promedio por usuario pagado": "ricavo medio per utente pagante",
  "ingresos mensuales recurrentes": "ricavi mensili ricorrenti",
  "proyección anualizada": "proiezione annualizzata",
  "retail": "retail",
  "saas": "saas",
  "servicios": "servizi",
  "tech": "tech",
  "todas": "tutte",
  "todos": "tutti",
  "último uso": "ultimo utilizzo",
});


// Pricing toggle sentence-case variants
Object.assign(DICT.en ||= {}, {
  "Flexibilidad total": "Total flexibility",
  "Ahorra hasta 17%": "Save up to 17%",
  "2 meses gratis": "2 months free",
});
Object.assign(DICT.pt ||= {}, {
  "Flexibilidad total": "Flexibilidade total",
  "Ahorra hasta 17%": "Economize até 17%",
  "2 meses gratis": "2 meses grátis",
});
Object.assign(DICT.fr ||= {}, {
  "Flexibilidad total": "Flexibilité totale",
  "Ahorra hasta 17%": "Économisez jusqu'à 17%",
  "2 meses gratis": "2 mois gratuits",
});
Object.assign(DICT.de ||= {}, {
  "Flexibilidad total": "Volle Flexibilität",
  "Ahorra hasta 17%": "Bis zu 17% sparen",
  "2 meses gratis": "2 Monate gratis",
});
Object.assign(DICT.it ||= {}, {
  "Flexibilidad total": "Flessibilità totale",
  "Ahorra hasta 17%": "Risparmia fino al 17%",
  "2 meses gratis": "2 mesi gratis",
});


// Weekday headers + breadcrumbs
Object.assign(DICT.en ||= {}, {
  "LUN": "MON",
  "MAR": "TUE",
  "MIÉ": "WED",
  "JUE": "THU",
  "VIE": "FRI",
  "SÁB": "SAT",
  "DOM": "SUN",
  "DESPLIEGUE · CRONOGRAMA": "SCHEDULE · TIMELINE",
  "DOSSIER": "DOSSIER",
});
Object.assign(DICT.pt ||= {}, {
  "LUN": "SEG",
  "MAR": "TER",
  "MIÉ": "QUA",
  "JUE": "QUI",
  "VIE": "SEX",
  "SÁB": "SÁB",
  "DOM": "DOM",
  "DESPLIEGUE · CRONOGRAMA": "PROGRAMAÇÃO · CRONOGRAMA",
});
Object.assign(DICT.fr ||= {}, {
  "LUN": "LUN",
  "MAR": "MAR",
  "MIÉ": "MER",
  "JUE": "JEU",
  "VIE": "VEN",
  "SÁB": "SAM",
  "DOM": "DIM",
  "DESPLIEGUE · CRONOGRAMA": "DÉPLOIEMENT · CALENDRIER",
});
Object.assign(DICT.de ||= {}, {
  "LUN": "MO",
  "MAR": "DI",
  "MIÉ": "MI",
  "JUE": "DO",
  "VIE": "FR",
  "SÁB": "SA",
  "DOM": "SO",
  "DESPLIEGUE · CRONOGRAMA": "AUSSPIELUNG · ZEITPLAN",
});
Object.assign(DICT.it ||= {}, {
  "LUN": "LUN",
  "MAR": "MAR",
  "MIÉ": "MER",
  "JUE": "GIO",
  "VIE": "VEN",
  "SÁB": "SAB",
  "DOM": "DOM",
  "DESPLIEGUE · CRONOGRAMA": "DISTRIBUZIONE · CRONOLOGIA",
});


// Breadcrumbs batch
Object.assign(DICT.en ||= {}, {
  "2FA · ACTIVO": "2FA · ACTIVE",
  "ADD-ON BLOQUEADO": "ADD-ON BLOCKED",
  "ADD-ON · VIDEO IA": "ADD-ON · VIDEO AI",
  "AHORRAS": "YOU SAVE",
  "AUTOPILOT · PLAN PRO REQUERIDO": "AUTOPILOT · PRO PLAN REQUIRED",
  "AÑO": "YEAR",
  "COLOR PRIMARIO · WHITE-LABEL": "PRIMARY COLOR · WHITE-LABEL",
  "DESACTIVAR 2FA": "DEACTIVATE 2FA",
  "DOSSIER · MARKETPLACE · PLANTILLAS": "DOSSIER · MARKETPLACE · TEMPLATES",
  "DOSSIER · SEGURIDAD · 2FA": "DOSSIER · SECURITY · 2FA",
  "EMOJIS": "EMOJIS",
  "ENLACES · REDES SOCIALES": "LINKS · SOCIAL NETWORKS",
  "IMAGEN GENERADA · IA VISUAL": "GENERATED IMAGE · VISUAL AI",
  "INVITADOS EXITOSOS": "SUCCESSFUL GUESTS",
  "MARCAS": "BRANDS",
  "POSTS": "POSTS",
  "PRO · AGENCIA": "PRO · AGENCY",
  "PROGRAMADO": "SCHEDULED",
  "RECONOCIMIENTO · COMPETENCIA": "RECOGNITION · COMPETITION",
  "Reprogramado": "Rescheduled",
  "TARIFA · PLAN ACTIVO": "FEE · ACTIVE PLAN",
  "VIGILANCIA · MENCIONES": "MONITORING · MENTIONS",
});
Object.assign(DICT.pt ||= {}, {
  "2FA · ACTIVO": "2FA · ATIVO",
  "ADD-ON BLOQUEADO": "ADD-ON BLOQUEADO",
  "ADD-ON · VIDEO IA": "ADD-ON · VÍDEO IA",
  "AHORRAS": "VOCÊ ECONOMIZA",
  "AUTOPILOT · PLAN PRO REQUERIDO": "AUTOPILOT · PLANO PRO NECESSÁRIO",
  "AÑO": "ANO",
  "COLOR PRIMARIO · WHITE-LABEL": "COR PRIMÁRIA · WHITE-LABEL",
  "DESACTIVAR 2FA": "DESATIVAR 2FA",
  "DOSSIER · MARKETPLACE · PLANTILLAS": "DOSSIÊ · MARKETPLACE · MODELOS",
  "DOSSIER · SEGURIDAD · 2FA": "DOSSIÊ · SEGURANÇA · 2FA",
  "EMOJIS": "EMOJIS",
  "ENLACES · REDES SOCIALES": "LINKS · REDES SOCIAIS",
  "IMAGEN GENERADA · IA VISUAL": "IMAGEM GERADA · IA VISUAL",
  "INVITADOS EXITOSOS": "CONVIDADOS BEM-SUCEDIDOS",
  "MARCAS": "MARCAS",
  "POSTS": "POSTS",
  "PRO · AGENCIA": "PRO · AGÊNCIA",
  "PROGRAMADO": "PROGRAMADO",
  "RECONOCIMIENTO · COMPETENCIA": "RECONHECIMENTO · CONCORRÊNCIA",
  "Reprogramado": "Reprogramado",
  "TARIFA · PLAN ACTIVO": "TARIFA · PLANO ATIVO",
  "VIGILANCIA · MENCIONES": "MONITORAMENTO · MENÇÕES",
});
Object.assign(DICT.fr ||= {}, {
  "2FA · ACTIVO": "2FA · ACTIF",
  "ADD-ON BLOQUEADO": "ADD-ON BLOQUÉ",
  "ADD-ON · VIDEO IA": "ADD-ON · VIDEO IA",
  "AHORRAS": "VOUS ÉCONOMISEZ",
  "AUTOPILOT · PLAN PRO REQUERIDO": "AUTOPILOT · PLAN PRO REQUIS",
  "AÑO": "ANNÉE",
  "COLOR PRIMARIO · WHITE-LABEL": "COULEUR PRIMAIRE · WHITE-LABEL",
  "DESACTIVAR 2FA": "DÉSACTIVER 2FA",
  "DOSSIER · MARKETPLACE · PLANTILLAS": "DOSSIER · MARKETPLACE · MODÈLES",
  "DOSSIER · SEGURIDAD · 2FA": "DOSSIER · SÉCURITÉ · 2FA",
  "EMOJIS": "ÉMOJIS",
  "ENLACES · REDES SOCIALES": "LIENS · RÉSEAUX SOCIAUX",
  "IMAGEN GENERADA · IA VISUAL": "IMAGE GÉNÉRÉE · IA VISUELLE",
  "INVITADOS EXITOSOS": "INVITÉS RÉUSSIS",
  "MARCAS": "MARQUES",
  "POSTS": "POSTS",
  "PRO · AGENCIA": "PRO · AGENCE",
  "PROGRAMADO": "PROGRAMMÉ",
  "RECONOCIMIENTO · COMPETENCIA": "RECONNAISSANCE · CONCURRENCE",
  "Reprogramado": "Reprogrammé",
  "TARIFA · PLAN ACTIVO": "TARIF · PLAN ACTIF",
  "VIGILANCIA · MENCIONES": "VEILLE · MENTIONS",
});
Object.assign(DICT.de ||= {}, {
  "2FA · ACTIVO": "2FA · AKTIV",
  "ADD-ON BLOQUEADO": "ADD-ON GESPERRT",
  "ADD-ON · VIDEO IA": "ADD-ON · VIDEO IA",
  "AHORRAS": "DU SPRAST",
  "AUTOPILOT · PLAN PRO REQUERIDO": "AUTOPILOT · PLAN PRO ERFORDERLICH",
  "AÑO": "JAHR",
  "COLOR PRIMARIO · WHITE-LABEL": "PRIMÄRFARBE · WHITE-LABEL",
  "DESACTIVAR 2FA": "2FA DEAKTIVIEREN",
  "DOSSIER · MARKETPLACE · PLANTILLAS": "DOSSIER · MARKETPLACE · VORLAGEN",
  "DOSSIER · SEGURIDAD · 2FA": "DOSSIER · SICHERHEIT · 2FA",
  "EMOJIS": "EMOJIS",
  "ENLACES · REDES SOCIALES": "LINKS · SOZIALE NETZWERKE",
  "IMAGEN GENERADA · IA VISUAL": "GENERIERTE**S** BILD · IA VISUAL",
  "INVITADOS EXITOSOS": "ERFOLGREICH EINGELADENE",
  "MARCAS": "MARKEN",
  "POSTS": "POSTS",
  "PRO · AGENCIA": "PRO · AGENTUR",
  "PROGRAMADO": "GEPLANT",
  "RECONOCIMIENTO · COMPETENCIA": "WETTBEWERBERKENNUNG",
  "Reprogramado": "Umgeplant",
  "TARIFA · PLAN ACTIVO": "TARIF · AKTIVER PLAN",
  "VIGILANCIA · MENCIONES": "ÜBERWACHUNG · ERWÄHNUNGEN",
});
Object.assign(DICT.it ||= {}, {
  "2FA · ACTIVO": "2FA · ATTIVO",
  "ADD-ON BLOQUEADO": "ADD-ON BLOCCATO",
  "ADD-ON · VIDEO IA": "ADD-ON · VIDEO IA",
  "AHORRAS": "RISPARMI",
  "AUTOPILOT · PLAN PRO REQUERIDO": "AUTOPILOT · PIANO PRO RICHIEDUTO",
  "AÑO": "ANNO",
  "COLOR PRIMARIO · WHITE-LABEL": "COLORE PRIMARIO · WHITE-LABEL",
  "DESACTIVAR 2FA": "DISATTIVARE 2FA",
  "DOSSIER · MARKETPLACE · PLANTILLAS": "DOSSIER · MARKETPLACE · MODELLI",
  "DOSSIER · SEGURIDAD · 2FA": "DOSSIER · SICUREZZA · 2FA",
  "EMOJIS": "EMOJIS",
  "ENLACES · REDES SOCIALES": "LINK · SOCIAL NETWORK",
  "IMAGEN GENERADA · IA VISUAL": "IMMAGINE GENERATA · IA VISUAL",
  "INVITADOS EXITOSOS": "INVITATI RIUSCITI",
  "MARCAS": "MARCHI",
  "POSTS": "POSTS",
  "PRO · AGENCIA": "PRO · AGENZIA",
  "PROGRAMADO": "PROGRAMMATO",
  "RECONOCIMIENTO · COMPETENCIA": "RICONOSCIMENTO · CONCORRENZA",
  "Reprogramado": "RIPROGRAMMATO",
  "TARIFA · PLAN ACTIVO": "TARIFFA · PIANO ATTIVO",
  "VIGILANCIA · MENCIONES": "MONITORAGGIO · MENZIONI",
});


// 2FA extras
Object.assign(DICT.en ||= {}, {
  "2FA · DESACTIVADO": "2FA · DISABLED",
  "INICIANDO…": "STARTING…",
  "ACTIVAR 2FA": "ENABLE 2FA",
  "DESACTIVAR 2FA": "DISABLE 2FA",
});
Object.assign(DICT.pt ||= {}, {
  "2FA · DESACTIVADO": "2FA · DESATIVADO",
  "INICIANDO…": "INICIANDO…",
  "ACTIVAR 2FA": "ATIVAR 2FA",
  "DESACTIVAR 2FA": "DESATIVAR 2FA",
});
Object.assign(DICT.fr ||= {}, {
  "2FA · DESACTIVADO": "2FA · DÉSACTIVÉ",
  "INICIANDO…": "DÉMARRAGE…",
  "ACTIVAR 2FA": "ACTIVER 2FA",
  "DESACTIVAR 2FA": "DÉSACTIVER 2FA",
});
Object.assign(DICT.de ||= {}, {
  "2FA · DESACTIVADO": "2FA · DEAKTIVIERT",
  "INICIANDO…": "STARTE…",
  "ACTIVAR 2FA": "2FA AKTIVIEREN",
  "DESACTIVAR 2FA": "2FA DEAKTIVIEREN",
});
Object.assign(DICT.it ||= {}, {
  "2FA · DESACTIVADO": "2FA · DISATTIVATO",
  "INICIANDO…": "AVVIO…",
  "ACTIVAR 2FA": "ATTIVA 2FA",
  "DESACTIVAR 2FA": "DISATTIVA 2FA",
});


// Iter 18 tail fixes
Object.assign(DICT.en ||= {}, {
  "ACTIVAR +VIDEO": "ENABLE +VIDEO",
  "ACTUAL": "CURRENT",
  "ARPU": "ARPU",
  "AUTOPILOT": "AUTOPILOT",
  "CREANDO IMAGEN…": "CREATING IMAGE…",
  "CREANDO…": "CREATING…",
  "Cargando plantillas…": "Loading templates…",
  "Hasta 30 videos IA/mes": "Up to 30 AI videos/mo",
  "IMÁGENES/MES": "IMAGES/MONTH",
  "KEYWORDS VIGILADAS": "WATCHED KEYWORDS",
  "MES": "MONTH",
  "MRR": "MRR",
  "Orden": "Sort",
  "POSTS/MES": "POSTS/MONTH",
  "URL": "URL",
});
Object.assign(DICT.pt ||= {}, {
  "ACTIVAR +VIDEO": "ATIVAR +VÍDEO",
  "ACTUAL": "ATUAL",
  "ARPU": "ARPU",
  "AUTOPILOT": "AUTOPILOT",
  "CREANDO IMAGEN…": "CRIANDO IMAGEM…",
  "CREANDO…": "CRIANDO…",
  "Cargando plantillas…": "Carregando modelos…",
  "Hasta 30 videos IA/mes": "Até 30 vídeos IA/mês",
  "IMÁGENES/MES": "IMAGENS/MÊS",
  "KEYWORDS VIGILADAS": "PALAVRAS MONITORADAS",
  "MES": "MÊS",
  "MRR": "MRR",
  "Orden": "Ordem",
  "POSTS/MES": "POSTS/MÊS",
  "URL": "URL",
});
Object.assign(DICT.fr ||= {}, {
  "ACTIVAR +VIDEO": "ACTIVER +VIDÉO",
  "ACTUAL": "ACTUEL",
  "ARPU": "ARPU",
  "AUTOPILOT": "AUTOPILOT",
  "CREANDO IMAGEN…": "CRÉATION IMAGE…",
  "CREANDO…": "CRÉATION…",
  "Cargando plantillas…": "Chargement des modèles…",
  "Hasta 30 videos IA/mes": "Jusqu'à 30 vidéos IA/mois",
  "IMÁGENES/MES": "IMAGES/MOIS",
  "KEYWORDS VIGILADAS": "MOTS-CLÉS SURVEILLÉS",
  "MES": "MOIS",
  "MRR": "MRR",
  "Orden": "Ordre",
  "POSTS/MES": "POSTS/MOIS",
  "URL": "URL",
});
Object.assign(DICT.de ||= {}, {
  "ACTIVAR +VIDEO": "+VIDEO AKTIVIEREN",
  "ACTUAL": "AKTUELL",
  "ARPU": "ARPU",
  "AUTOPILOT": "AUTOPILOT",
  "CREANDO IMAGEN…": "BILD WIRD ERSTELLT…",
  "CREANDO…": "WIRD ERSTELLT…",
  "Cargando plantillas…": "Vorlagen werden geladen…",
  "Hasta 30 videos IA/mes": "Bis zu 30 KI-Videos/Monat",
  "IMÁGENES/MES": "BILDER/MONAT",
  "KEYWORDS VIGILADAS": "BEOBACHTETE KEYWORDS",
  "MES": "MONAT",
  "MRR": "MRR",
  "Orden": "Sortierung",
  "POSTS/MES": "POSTS/MONAT",
  "URL": "URL",
});
Object.assign(DICT.it ||= {}, {
  "ACTIVAR +VIDEO": "ATTIVA +VIDEO",
  "ACTUAL": "ATTUALE",
  "ARPU": "ARPU",
  "AUTOPILOT": "AUTOPILOT",
  "CREANDO IMAGEN…": "CREAZIONE IMMAGINE…",
  "CREANDO…": "CREAZIONE…",
  "Cargando plantillas…": "Caricamento modelli…",
  "Hasta 30 videos IA/mes": "Fino a 30 video IA/mese",
  "IMÁGENES/MES": "IMMAGINI/MESE",
  "KEYWORDS VIGILADAS": "KEYWORD MONITORATE",
  "MES": "MESE",
  "MRR": "MRR",
  "Orden": "Ordine",
  "POSTS/MES": "POST/MESE",
  "URL": "URL",
});


// Final round - Referrals + SEO + tones
Object.assign(DICT.en ||= {}, {
  "Compartes tu código": "Share your code",
  "Cópialo y mándalo a tus contactos, o comparte el link directo.": "Copy it and send to your contacts, or share the direct link.",
  "Tu amigo se registra": "Your friend signs up",
  "Al crear cuenta pone el código CIA-XXXXXX en el campo de referido.": "When creating an account, they enter CIA-XXXXXX in the referral field.",
  "El bonus se activa automáticamente. Se acumulan por cada invitado.": "The bonus activates automatically. It accumulates per invite.",
  "casual": "casual",
  "divertido": "fun",
  "formal": "formal",
  "profesional": "professional",
  "persuasivo": "persuasive",
  "experto": "expert",
  "Casual": "Casual",
  "Divertido": "Fun",
  "Formal": "Formal",
  "Profesional": "Professional",
  "Persuasivo": "Persuasive",
  "Experto": "Expert",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOL · HOW IT WORKS",
  "Español (MX)": "Spanish (MX)",
  "Español (AR)": "Spanish (AR)",
  "Español (ES)": "Spanish (ES)",
  "Español (CO)": "Spanish (CO)",
  "GENERAR ARTÍCULO OPTIMIZADO": "GENERATE OPTIMIZED ARTICLE",
  "TONO": "TONE",
  "PALABRAS": "WORDS",
  "TEMA": "TOPIC",
  "IDIOMA": "LANGUAGE",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "E.g.: How to pick the best CRM for SMBs in 2026",
});
Object.assign(DICT.pt ||= {}, {
  "Compartes tu código": "Compartilhe seu código",
  "Cópialo y mándalo a tus contactos, o comparte el link directo.": "Copie e envie aos seus contatos, ou compartilhe o link direto.",
  "Tu amigo se registra": "Seu amigo se cadastra",
  "Al crear cuenta pone el código CIA-XXXXXX en el campo de referido.": "Ao criar conta, insere o código CIA-XXXXXX no campo de indicação.",
  "El bonus se activa automáticamente. Se acumulan por cada invitado.": "O bônus é ativado automaticamente. Acumula por cada convidado.",
  "casual": "casual",
  "divertido": "divertido",
  "formal": "formal",
  "profesional": "profissional",
  "persuasivo": "persuasivo",
  "experto": "especialista",
  "Casual": "Casual",
  "Divertido": "Divertido",
  "Formal": "Formal",
  "Profesional": "Profissional",
  "Persuasivo": "Persuasivo",
  "Experto": "Especialista",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOLO · COMO FUNCIONA",
  "Español (MX)": "Espanhol (MX)",
  "Español (AR)": "Espanhol (AR)",
  "Español (ES)": "Espanhol (ES)",
  "Español (CO)": "Espanhol (CO)",
  "GENERAR ARTÍCULO OPTIMIZADO": "GERAR ARTIGO OTIMIZADO",
  "TONO": "TOM",
  "PALABRAS": "PALAVRAS",
  "TEMA": "TEMA",
  "IDIOMA": "IDIOMA",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Ex.: Como escolher o melhor CRM para PMEs em 2026",
});
Object.assign(DICT.fr ||= {}, {
  "Compartes tu código": "Partagez votre code",
  "Cópialo y mándalo a tus contactos, o comparte el link directo.": "Copiez-le et envoyez-le à vos contacts, ou partagez le lien direct.",
  "Tu amigo se registra": "Votre ami s'inscrit",
  "Al crear cuenta pone el código CIA-XXXXXX en el campo de referido.": "À la création de compte, il saisit CIA-XXXXXX dans le champ parrainage.",
  "El bonus se activa automáticamente. Se acumulan por cada invitado.": "Le bonus s'active automatiquement. Il s'accumule par invité.",
  "casual": "décontracté",
  "divertido": "amusant",
  "formal": "formel",
  "profesional": "professionnel",
  "persuasivo": "persuasif",
  "experto": "expert",
  "Casual": "Décontracté",
  "Divertido": "Amusant",
  "Formal": "Formel",
  "Profesional": "Professionnel",
  "Persuasivo": "Persuasif",
  "Experto": "Expert",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOLE · COMMENT ÇA MARCHE",
  "Español (MX)": "Espagnol (MX)",
  "Español (AR)": "Espagnol (AR)",
  "Español (ES)": "Espagnol (ES)",
  "Español (CO)": "Espagnol (CO)",
  "GENERAR ARTÍCULO OPTIMIZADO": "GÉNÉRER L'ARTICLE OPTIMISÉ",
  "TONO": "TON",
  "PALABRAS": "MOTS",
  "TEMA": "SUJET",
  "IDIOMA": "LANGUE",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Ex. : Comment choisir le meilleur CRM pour PME en 2026",
});
Object.assign(DICT.de ||= {}, {
  "Compartes tu código": "Teile deinen Code",
  "Cópialo y mándalo a tus contactos, o comparte el link directo.": "Kopiere und sende an deine Kontakte oder teile den direkten Link.",
  "Tu amigo se registra": "Dein Freund registriert sich",
  "Al crear cuenta pone el código CIA-XXXXXX en el campo de referido.": "Beim Anlegen eines Kontos gibt er CIA-XXXXXX im Empfehlungsfeld ein.",
  "El bonus se activa automáticamente. Se acumulan por cada invitado.": "Der Bonus wird automatisch aktiviert. Pro Einladung akkumuliert.",
  "casual": "locker",
  "divertido": "lustig",
  "formal": "formell",
  "profesional": "professionell",
  "persuasivo": "überzeugend",
  "experto": "Experte",
  "Casual": "Locker",
  "Divertido": "Lustig",
  "Formal": "Formell",
  "Profesional": "Professionell",
  "Persuasivo": "Überzeugend",
  "Experto": "Experte",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOKOLL · SO FUNKTIONIERT'S",
  "Español (MX)": "Spanisch (MX)",
  "Español (AR)": "Spanisch (AR)",
  "Español (ES)": "Spanisch (ES)",
  "Español (CO)": "Spanisch (CO)",
  "GENERAR ARTÍCULO OPTIMIZADO": "OPTIMIERTEN ARTIKEL GENERIEREN",
  "TONO": "TON",
  "PALABRAS": "WÖRTER",
  "TEMA": "THEMA",
  "IDIOMA": "SPRACHE",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Z.B.: Wie man das beste CRM für KMU 2026 auswählt",
});
Object.assign(DICT.it ||= {}, {
  "Compartes tu código": "Condividi il tuo codice",
  "Cópialo y mándalo a tus contactos, o comparte el link directo.": "Copialo e invialo ai tuoi contatti, o condividi il link diretto.",
  "Tu amigo se registra": "Il tuo amico si registra",
  "Al crear cuenta pone el código CIA-XXXXXX en el campo de referido.": "Alla creazione account, inserisce CIA-XXXXXX nel campo referral.",
  "El bonus se activa automáticamente. Se acumulan por cada invitado.": "Il bonus si attiva automaticamente. Si accumula per ogni invitato.",
  "casual": "casual",
  "divertido": "divertente",
  "formal": "formale",
  "profesional": "professionale",
  "persuasivo": "persuasivo",
  "experto": "esperto",
  "Casual": "Casual",
  "Divertido": "Divertente",
  "Formal": "Formale",
  "Profesional": "Professionale",
  "Persuasivo": "Persuasivo",
  "Experto": "Esperto",
  "PROTOCOLO · CÓMO FUNCIONA": "PROTOCOLLO · COME FUNZIONA",
  "Español (MX)": "Spagnolo (MX)",
  "Español (AR)": "Spagnolo (AR)",
  "Español (ES)": "Spagnolo (ES)",
  "Español (CO)": "Spagnolo (CO)",
  "GENERAR ARTÍCULO OPTIMIZADO": "GENERA ARTICOLO OTTIMIZZATO",
  "TONO": "TONO",
  "PALABRAS": "PAROLE",
  "TEMA": "TEMA",
  "IDIOMA": "LINGUA",
  "Ej: Cómo elegir el mejor CRM para PyMEs en 2026": "Es.: Come scegliere il miglior CRM per PMI nel 2026",
});


// Pricing page tail
Object.assign(DICT.en ||= {}, {
  "VOLVER AL DASHBOARD": "BACK TO DASHBOARD",
  "PRECIO 2×": "2× PRICE",
  "Precio base del plan": "Plan base price",
  "Incluye:": "Includes:",
  "generador de videos verticales (Reels, TikTok, Shorts) · 4, 8 ó 12 segundos · hasta 30 al mes · frecuencia configurable (diario · semanal · 15 días · personalizado).": "vertical video generator (Reels, TikTok, Shorts) · 4, 8 or 12 seconds · up to 30/month · configurable frequency (daily · weekly · 15 days · custom).",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ TO SUBSCRIBE YOU NEED AN ACCOUNT ·",
  "CREAR GRATIS": "CREATE FREE",
  "ENTRAR": "SIGN IN",
});
Object.assign(DICT.pt ||= {}, {
  "VOLVER AL DASHBOARD": "VOLTAR AO PAINEL",
  "PRECIO 2×": "PREÇO 2×",
  "Precio base del plan": "Preço base do plano",
  "Incluye:": "Inclui:",
  "generador de videos verticales (Reels, TikTok, Shorts) · 4, 8 ó 12 segundos · hasta 30 al mes · frecuencia configurable (diario · semanal · 15 días · personalizado).": "gerador de vídeos verticais (Reels, TikTok, Shorts) · 4, 8 ou 12 segundos · até 30/mês · frequência configurável (diário · semanal · 15 dias · personalizado).",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ PARA ASSINAR VOCÊ PRECISA DE UMA CONTA ·",
  "CREAR GRATIS": "CRIAR GRÁTIS",
  "ENTRAR": "ENTRAR",
});
Object.assign(DICT.fr ||= {}, {
  "VOLVER AL DASHBOARD": "RETOUR AU TABLEAU DE BORD",
  "PRECIO 2×": "PRIX 2×",
  "Precio base del plan": "Prix de base du plan",
  "Incluye:": "Inclut :",
  "generador de videos verticales (Reels, TikTok, Shorts) · 4, 8 ó 12 segundos · hasta 30 al mes · frecuencia configurable (diario · semanal · 15 días · personalizado).": "générateur de vidéos verticales (Reels, TikTok, Shorts) · 4, 8 ou 12 secondes · jusqu'à 30/mois · fréquence configurable (quotidien · hebdo · 15 jours · personnalisé).",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ POUR SOUSCRIRE IL FAUT UN COMPTE ·",
  "CREAR GRATIS": "CRÉER GRATUIT",
  "ENTRAR": "SE CONNECTER",
});
Object.assign(DICT.de ||= {}, {
  "VOLVER AL DASHBOARD": "ZURÜCK ZUM DASHBOARD",
  "PRECIO 2×": "2× PREIS",
  "Precio base del plan": "Grundpreis des Plans",
  "Incluye:": "Enthält:",
  "generador de videos verticales (Reels, TikTok, Shorts) · 4, 8 ó 12 segundos · hasta 30 al mes · frecuencia configurable (diario · semanal · 15 días · personalizado).": "Vertikal-Video-Generator (Reels, TikTok, Shorts) · 4, 8 oder 12 Sekunden · bis zu 30/Monat · konfigurierbare Frequenz (täglich · wöchentlich · 15 Tage · individuell).",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ ZUM ABSCHLIESSEN BENÖTIGST DU EIN KONTO ·",
  "CREAR GRATIS": "KOSTENLOS ERSTELLEN",
  "ENTRAR": "ANMELDEN",
});
Object.assign(DICT.it ||= {}, {
  "VOLVER AL DASHBOARD": "TORNA ALLA DASHBOARD",
  "PRECIO 2×": "PREZZO 2×",
  "Precio base del plan": "Prezzo base del piano",
  "Incluye:": "Include:",
  "generador de videos verticales (Reels, TikTok, Shorts) · 4, 8 ó 12 segundos · hasta 30 al mes · frecuencia configurable (diario · semanal · 15 días · personalizado).": "generatore di video verticali (Reels, TikTok, Shorts) · 4, 8 o 12 secondi · fino a 30/mese · frequenza configurabile (giornaliera · settimanale · 15 giorni · personalizzata).",
  "⚠ PARA CONTRATAR NECESITAS UNA CUENTA ·": "⚠ PER SOTTOSCRIVERE SERVE UN ACCOUNT ·",
  "CREAR GRATIS": "CREA GRATIS",
  "ENTRAR": "ACCEDI",
});


// Demo mockup content + voices
Object.assign(DICT.en ||= {}, {
  "Tu café del lunes no debería saber a lunes ☕ · Hecho en CDMX #coffee #cafedeespecialidad": "Your Monday coffee shouldn't taste like Monday ☕ · Made in CDMX #coffee #cafedeespecialidad",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Your next purchase isn't a decision, it's a sign. We're launching it Friday — turn on notifications 🔔",
  "ver 42 comentarios": "view 42 comments",
  "Llevamos 3 años automatizando operaciones para PyMEs alrededor del mundo. Un patrón se repite en el 84% de los casos:": "We've spent 3 years automating operations for SMEs worldwide. A pattern repeats in 84% of cases:",
  "No es falta de producto. Es falta de distribución constante.": "It's not a lack of product. It's a lack of consistent distribution.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "That's why we stopped hiring community managers and started publishing 5× more with AI.",
  "¿Resultado?": "Result?",
  "CPL -38% en 90 días.": "CPL -38% in 90 days.",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2.1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3.2M VIEWS",
  "INSTAGRAM · CAPTION": "INSTAGRAM · CAPTION",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\\n\\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Your marketing team sleeps, your sales do too. 😴\\n\\nWe automate the first part. You handle the second part. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\\n\\nMientras tú sigues pagándole a 3 personas.\"": "\"Nobody's going to tell you this, but 80% of your competition is already publishing with AI…\\n\\nWhile you're still paying 3 people.\"",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\\n\\nYa no más. 💛\"": "\"We know the feeling. Opening your feed on a Monday at 8 am and remembering you forgot to schedule last Friday's post.\\n\\nNo more. 💛\"",
  "287K impresiones · 4.8% engagement": "287K impressions · 4.8% engagement",
  "3.2M vistas · +14K seguidores": "3.2M views · +14K followers",
  "12,400 me gusta · +892 guardados": "12,400 likes · +892 saves",
});
Object.assign(DICT.pt ||= {}, {
  "Tu café del lunes no debería saber a lunes ☕ · Hecho en CDMX #coffee #cafedeespecialidad": "Seu café de segunda não deveria ter gosto de segunda ☕ · Feito na CDMX #coffee #cafedeespecialidad",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Sua próxima compra não é uma decisão, é um sinal. Lançamos na sexta-feira — ative as notificações 🔔",
  "ver 42 comentarios": "ver 42 comentários",
  "Llevamos 3 años automatizando operaciones para PyMEs alrededor del mundo. Un patrón se repite en el 84% de los casos:": "Há 3 anos automatizando operações para PMEs no mundo todo. Um padrão se repete em 84% dos casos:",
  "No es falta de producto. Es falta de distribución constante.": "Não é falta de produto. É falta de distribuição constante.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "Por isso paramos de contratar community managers e começamos a publicar 5× mais com IA.",
  "¿Resultado?": "Resultado?",
  "CPL -38% en 90 días.": "CPL -38% em 90 dias.",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2.1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3.2M VIEWS",
  "INSTAGRAM · CAPTION": "INSTAGRAM · LEGENDA",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\\n\\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Sua equipe de marketing dorme, suas vendas também. 😴\\n\\nNós automatizamos a primeira parte. Da segunda você se encarrega. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\\n\\nMientras tú sigues pagándole a 3 personas.\"": "\"Ninguém vai te dizer isso, mas 80% da sua concorrência já publica com IA…\\n\\nEnquanto você continua pagando 3 pessoas.\"",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\\n\\nYa no más. 💛\"": "\"Sabemos como é. Abrir o feed em uma segunda-feira às 8am e lembrar que você esqueceu de programar o post da sexta-feira passada.\\n\\nNunca mais. 💛\"",
  "287K impresiones · 4.8% engagement": "287K impressões · 4.8% de engajamento",
  "3.2M vistas · +14K seguidores": "3.2M visualizações · +14K seguidores",
  "12,400 me gusta · +892 guardados": "12.400 curtidas · +892 salvos",
});
Object.assign(DICT.fr ||= {}, {
  "Tu café del lunes no debería saber a lunes ☕ · Hecho en CDMX #coffee #cafedeespecialidad": "Ton café du lundi ne devrait pas avoir le goût du lundi ☕ · Fabriqué à CDMX #coffee #cafedeespecialidad",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Ton prochain achat n'est pas une décision, c'est un signe. Nous la lançons vendredi — active les notifications 🔔",
  "ver 42 comentarios": "voir 42 commentaires",
  "Llevamos 3 años automatizando operaciones para PyMEs alrededor del mundo. Un patrón se repite en el 84% de los casos:": "Nous automatisons les opérations pour les PME dans le monde entier depuis 3 ans. Un schéma se répète dans 84% des cas :",
  "No es falta de producto. Es falta de distribución constante.": "Ce n'est pas un manque de produit. C'est un manque de distribution constante.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "C'est pourquoi nous avons cessé d'embaucher des community managers et avons commencé à publier 5× plus avec l'IA.",
  "¿Resultado?": "Résultat ?",
  "CPL -38% en 90 días.": "CPL -38% en 90 jours.",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2.1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3.2M VUES",
  "INSTAGRAM · CAPTION": "INSTAGRAM · LÉGENDE",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\\n\\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "« Ton équipe marketing dort, tes ventes aussi. 😴\\n\\nNous automatisons la première partie. De la seconde, tu t'en occupes. ☕ »",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\\n\\nMientras tú sigues pagándole a 3 personas.\"": "« Personne ne te dira ça, mais 80% de ta concurrence publie déjà avec l'IA…\\n\\nPendant que tu continues de payer 3 personnes. »",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\\n\\nYa no más. 💛\"": "« On sait ce que ça fait. Ouvrir son feed un lundi à 8h et se souvenir que tu as oublié de programmer le post de vendredi dernier.\\n\\nPlus jamais. 💛 »",
  "287K impresiones · 4.8% engagement": "287K impressions · 4.8% d'engagement",
  "3.2M vistas · +14K seguidores": "3.2M vues · +14K abonnés",
  "12,400 me gusta · +892 guardados": "12 400 J'aime · +892 enregistrements",
});
Object.assign(DICT.de ||= {}, {
  "Tu café del lunes no debería saber a lunes ☕ · Hecho en CDMX #coffee #cafedeespecialidad": "Dein Montagskaffee sollte nicht nach Montag schmecken ☕ · Hergestellt in CDMX #coffee #cafedeespecialidad",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Dein nächster Kauf ist keine Entscheidung, sondern ein Zeichen. Wir launchen sie am Freitag — aktiviere die Benachrichtigungen 🔔",
  "ver 42 comentarios": "42 Kommentare anzeigen",
  "Llevamos 3 años automatizando operaciones para PyMEs alrededor del mundo. Un patrón se repite en el 84% de los casos:": "Seit 3 Jahren automatisieren wir Abläufe für KMU weltweit. Ein Muster wiederholt sich in 84 % der Fälle:",
  "No es falta de producto. Es falta de distribución constante.": "Es ist kein Produktmangel. Es mangelt an konstanter Distribution.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "Deshalb haben wir aufgehört, Community Manager einzustellen und angefangen, 5× mehr mit KI zu posten.",
  "¿Resultado?": "Das Ergebnis?",
  "CPL -38% en 90 días.": "CPL -38 % in 90 Tagen.",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2,1 Tsd. RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3,2 Mio. AUFRUFE",
  "INSTAGRAM · CAPTION": "INSTAGRAM · CAPTION",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\\n\\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Dein Marketingteam schläft, deine Verkäufe auch. 😴\\n\\nWir automatisieren den ersten Teil. Um den zweiten kümmerst du dich. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\\n\\nMientras tú sigues pagándole a 3 personas.\"": "\"Niemand wird dir das sagen, aber 80 % deiner Konkurrenz postet bereits mit KI…\\n\\nWährend du immer noch 3 Leuten bezahlst.\"",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\\n\\nYa no más. 💛\"": "\"Wir wissen, wie sich das anfühlt. Montags um 8 Uhr morgens den Feed zu öffnen und sich zu erinnern, dass du vergessen hast, den Post vom letzten Freitag zu planen.\\n\\nDamit ist jetzt Schluss. 💛\"",
  "287K impresiones · 4.8% engagement": "287 Tsd. Impressionen · 4,8 % Engagement",
  "3.2M vistas · +14K seguidores": "3,2 Mio. Aufrufe · +14 Tsd. Follower",
  "12,400 me gusta · +892 guardados": "12.400 Likes · +892 gespeichert",
});
Object.assign(DICT.it ||= {}, {
  "Tu café del lunes no debería saber a lunes ☕ · Hecho en CDMX #coffee #cafedeespecialidad": "Il tuo caffè del lunedì non dovrebbe sapere di lunedì ☕ · Fatto a CDMX #coffee #cafedeespecialidad",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Il tuo prossimo acquisto non è una decisione, è un segnale. Lo lanciamo venerdì — attiva le notifiche 🔔",
  "ver 42 comentarios": "vedi 42 commenti",
  "Llevamos 3 años automatizando operaciones para PyMEs alrededor del mundo. Un patrón se repite en el 84% de los casos:": "Da 3 anni automatizziamo le operazioni per le PMI in tutto il mondo. Un modello si ripete nell'84% dei casi:",
  "No es falta de producto. Es falta de distribución constante.": "Non è mancanza di prodotto. È mancanza di distribuzione costante.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "Per questo abbiamo smesso di assumere community manager e abbiamo iniziato a pubblicare 5× di più con l'IA.",
  "¿Resultado?": "Risultato?",
  "CPL -38% en 90 días.": "CPL -38% in 90 giorni.",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2.1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3.2M VIEWS",
  "INSTAGRAM · CAPTION": "INSTAGRAM · CAPTION",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\\n\\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Il tuo team di marketing dorme, le tue vendite anche. 😴\\n\\nNoi automatizziamo la prima parte. Della seconda ti occupi tu. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\\n\\nMientras tú sigues pagándole a 3 personas.\"": "\"Nessuno te lo dirà, ma l'80% della tua concorrenza pubblica già con l'IA…\\n\\nMentre tu continui a pagare 3 persone.\"",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\\n\\nYa no más. 💛\"": "\"Sappiamo cosa si prova. Aprire il feed un lunedì alle 8 del mattino e ricordarsi di aver dimenticato di programmare il post del venerdì scorso.\\n\\nMai più. 💛\"",
  "287K impresiones · 4.8% engagement": "287K impressioni · 4.8% engagement",
  "3.2M vistas · +14K seguidores": "3.2M visualizzazioni · +14K follower",
  "12,400 me gusta · +892 guardados": "12.400 mi piace · +892 salvati",
});


// Legal footer + pages
Object.assign(DICT.en ||= {}, {
  "TÉRMINOS": "TERMS",
  "PRIVACIDAD": "PRIVACY",
  "COOKIES": "COOKIES",
  "CONTRATO": "CONTRACT",
  "SOPORTE": "SUPPORT",
  "← INICIO": "← HOME",
  "DOCUMENTO LEGAL": "LEGAL DOCUMENT",
  "ÚLTIMA ACTUALIZACIÓN:": "LAST UPDATED:",
});
Object.assign(DICT.pt ||= {}, {
  "TÉRMINOS": "TERMOS",
  "PRIVACIDAD": "PRIVACIDADE",
  "COOKIES": "COOKIES",
  "CONTRATO": "CONTRATO",
  "SOPORTE": "SUPORTE",
  "← INICIO": "← INÍCIO",
  "DOCUMENTO LEGAL": "DOCUMENTO LEGAL",
  "ÚLTIMA ACTUALIZACIÓN:": "ÚLTIMA ATUALIZAÇÃO:",
});
Object.assign(DICT.fr ||= {}, {
  "TÉRMINOS": "CONDITIONS",
  "PRIVACIDAD": "CONFIDENTIALITÉ",
  "COOKIES": "COOKIES",
  "CONTRATO": "CONTRAT",
  "SOPORTE": "SUPPORT",
  "← INICIO": "← ACCUEIL",
  "DOCUMENTO LEGAL": "DOCUMENT LÉGAL",
  "ÚLTIMA ACTUALIZACIÓN:": "DERNIÈRE MISE À JOUR :",
});
Object.assign(DICT.de ||= {}, {
  "TÉRMINOS": "BEDINGUNGEN",
  "PRIVACIDAD": "DATENSCHUTZ",
  "COOKIES": "COOKIES",
  "CONTRATO": "VERTRAG",
  "SOPORTE": "SUPPORT",
  "← INICIO": "← START",
  "DOCUMENTO LEGAL": "RECHTLICHES DOKUMENT",
  "ÚLTIMA ACTUALIZACIÓN:": "ZULETZT AKTUALISIERT:",
});
Object.assign(DICT.it ||= {}, {
  "TÉRMINOS": "TERMINI",
  "PRIVACIDAD": "PRIVACY",
  "COOKIES": "COOKIE",
  "CONTRATO": "CONTRATTO",
  "SOPORTE": "ASSISTENZA",
  "← INICIO": "← HOME",
  "DOCUMENTO LEGAL": "DOCUMENTO LEGALE",
  "ÚLTIMA ACTUALIZACIÓN:": "ULTIMO AGGIORNAMENTO:",
});


// Geo targeting UI
Object.assign(DICT.en ||= {}, {
  "GEO · ALCANCE LOCAL": "GEO · LOCAL REACH",
  "Si tu marca es local (cafetería, gym, barbería, tienda), activa geo-targeting. La IA incluirá ubicación y hashtags locales en cada post para atraer a gente cerca de ti.": "If your brand is local (café, gym, barbershop, shop), enable geo-targeting. The AI will add location tags and local hashtags to every post to attract people nearby.",
  "PAÍS (ISO 2)": "COUNTRY (ISO 2)",
  "CIUDAD": "CITY",
  "COLONIA / BARRIO": "NEIGHBORHOOD",
  "RADIO DE ALCANCE (KM)": "REACH RADIUS (KM)",
  "Vista previa:": "Preview:",
  "(ciudad)": "(city)",
  "GUARDANDO…": "SAVING…",
  "CREAR MARCA": "CREATE BRAND",
  "EMOJIS": "EMOJIS",
  "GUARDAR": "SAVE",
});
Object.assign(DICT.pt ||= {}, {
  "GEO · ALCANCE LOCAL": "GEO · ALCANCE LOCAL",
  "Si tu marca es local (cafetería, gym, barbería, tienda), activa geo-targeting. La IA incluirá ubicación y hashtags locales en cada post para atraer a gente cerca de ti.": "Se sua marca é local (café, academia, barbearia, loja), ative o geo-targeting. A IA incluirá localização e hashtags locais em cada post para atrair pessoas próximas.",
  "PAÍS (ISO 2)": "PAÍS (ISO 2)",
  "CIUDAD": "CIDADE",
  "COLONIA / BARRIO": "BAIRRO",
  "RADIO DE ALCANCE (KM)": "RAIO DE ALCANCE (KM)",
  "Vista previa:": "Prévia:",
  "(ciudad)": "(cidade)",
  "GUARDANDO…": "SALVANDO…",
  "CREAR MARCA": "CRIAR MARCA",
  "EMOJIS": "EMOJIS",
  "GUARDAR": "SALVAR",
});
Object.assign(DICT.fr ||= {}, {
  "GEO · ALCANCE LOCAL": "GÉO · PORTÉE LOCALE",
  "Si tu marca es local (cafetería, gym, barbería, tienda), activa geo-targeting. La IA incluirá ubicación y hashtags locales en cada post para atraer a gente cerca de ti.": "Si votre marque est locale (café, salle de sport, coiffeur, boutique), activez le géo-ciblage. L'IA ajoutera la localisation et des hashtags locaux à chaque post pour attirer les personnes proches.",
  "PAÍS (ISO 2)": "PAYS (ISO 2)",
  "CIUDAD": "VILLE",
  "COLONIA / BARRIO": "QUARTIER",
  "RADIO DE ALCANCE (KM)": "RAYON (KM)",
  "Vista previa:": "Aperçu :",
  "(ciudad)": "(ville)",
  "GUARDANDO…": "ENREGISTREMENT…",
  "CREAR MARCA": "CRÉER MARQUE",
  "EMOJIS": "ÉMOJIS",
  "GUARDAR": "ENREGISTRER",
});
Object.assign(DICT.de ||= {}, {
  "GEO · ALCANCE LOCAL": "GEO · LOKALE REICHWEITE",
  "Si tu marca es local (cafetería, gym, barbería, tienda), activa geo-targeting. La IA incluirá ubicación y hashtags locales en cada post para atraer a gente cerca de ti.": "Wenn deine Marke lokal ist (Café, Gym, Barbershop, Laden), aktiviere Geo-Targeting. Die KI fügt Standort und lokale Hashtags zu jedem Post hinzu, um Leute in der Nähe anzusprechen.",
  "PAÍS (ISO 2)": "LAND (ISO 2)",
  "CIUDAD": "STADT",
  "COLONIA / BARRIO": "VIERTEL",
  "RADIO DE ALCANCE (KM)": "REICHWEITE (KM)",
  "Vista previa:": "Vorschau:",
  "(ciudad)": "(Stadt)",
  "GUARDANDO…": "SPEICHERE…",
  "CREAR MARCA": "MARKE ERSTELLEN",
  "EMOJIS": "EMOJIS",
  "GUARDAR": "SPEICHERN",
});
Object.assign(DICT.it ||= {}, {
  "GEO · ALCANCE LOCAL": "GEO · COPERTURA LOCALE",
  "Si tu marca es local (cafetería, gym, barbería, tienda), activa geo-targeting. La IA incluirá ubicación y hashtags locales en cada post para atraer a gente cerca de ti.": "Se il tuo brand è locale (caffetteria, palestra, barbiere, negozio), attiva il geo-targeting. L'IA aggiungerà posizione e hashtag locali a ogni post per attrarre persone vicine.",
  "PAÍS (ISO 2)": "PAESE (ISO 2)",
  "CIUDAD": "CITTÀ",
  "COLONIA / BARRIO": "QUARTIERE",
  "RADIO DE ALCANCE (KM)": "RAGGIO (KM)",
  "Vista previa:": "Anteprima:",
  "(ciudad)": "(città)",
  "GUARDANDO…": "SALVATAGGIO…",
  "CREAR MARCA": "CREA BRAND",
  "EMOJIS": "EMOJI",
  "GUARDAR": "SALVA",
});

// === Smart Cards (CIA · IA INTELLIGENCE section) ===
const _SMART_CARDS_KEYS = [
  "Tu agencia con cerebro propio.",
  "Mientras los demás te dejan al frente del calendario, CIA Marketing aprende cómo escribe tu marca, a qué hora rinde mejor cada red, y arregla problemas operativos antes de que los reportes lleguen a tu bandeja.",
  "NUEVO · 2026",
  "A/B TESTING IA",
  "Dos variantes contrastantes en cada generación.",
  "Activas el modo A/B y la IA produce 2 textos con estilos opuestos (directo vs narrativo). Eliges la que prefieres y la marca aprende: a partir del 4º post, te marca con un sello \"RECOMENDADA\" el estilo que tu cliente ya validó.",
  "BEST TIME · CRON",
  "Publica cuando tu audiencia está despierta, no cuando tú te acuerdas.",
  "Mientras no haya datos propios, usamos los slots óptimos de la industria (Instagram → Martes 7 PM, LinkedIn → Martes 9 AM…). En cuanto acumulas 5 posts publicados, basculamos a tu data real: el botón \"MEJOR HORA\" programa al próximo slot top de tu marca.",
  "AUTO-REPAIR · TICKETS",
  "Tickets que se arreglan solos, sin esperar a soporte.",
  "La IA clasifica cada ticket en data / config / user_error / code. Si es seguro (limpiar lock de fuerza bruta, cambiar idioma, reactivar usuario) ejecuta el fix sobre la base de datos en segundos. Sólo los bugs que requieren tocar código escalan a un humano.",
  "MULTI-BRAND · AGENCIA",
  "5 marcas, 5 voces, 5 calendarios — cero contaminación de datos.",
  "Cada marca tiene su brand_config, sus cuentas sociales, sus posts, su analytics, su brand voice. La vista 360 de Agencia consolida lo que importa sin mezclar nada. Ideal para freelancers que llevan varios clientes o holdings con productos hijos.",
  "BRAND BUILDER",
  "De idea a marca en 9 pasos.",
  "Logo con Nano Banana + slogan + paleta + landing HTML/CSS y e-commerce descargables en ZIP.",
  "EMAIL · SENDGRID",
  "Welcome, contratos y upsells reales.",
  "Cron diario manda recordatorios de renewal y upsell free→pago. Idempotente, con log auditable.",
  "OAUTH · NATIVO",
  "Conecta IG, FB, LinkedIn, TikTok, X.",
  "Tokens cifrados con AES, state firmado HMAC, refresh automático. Listo para escalar internacional.",
];

Object.assign(DICT.en ||= {}, {
  "Tu agencia con cerebro propio.": "Your agency with a brain of its own.",
  "Mientras los demás te dejan al frente del calendario, CIA Marketing aprende cómo escribe tu marca, a qué hora rinde mejor cada red, y arregla problemas operativos antes de que los reportes lleguen a tu bandeja.": "While others leave you stuck managing the calendar, CIA Marketing learns how your brand writes, what time each network performs best, and fixes operational issues before the reports reach your inbox.",
  "NUEVO · 2026": "NEW · 2026",
  "A/B TESTING IA": "A/B TESTING AI",
  "Dos variantes contrastantes en cada generación.": "Two contrasting variants in every generation.",
  "Activas el modo A/B y la IA produce 2 textos con estilos opuestos (directo vs narrativo). Eliges la que prefieres y la marca aprende: a partir del 4º post, te marca con un sello \"RECOMENDADA\" el estilo que tu cliente ya validó.": "Turn on A/B mode and the AI produces 2 texts with opposing styles (direct vs narrative). You pick your favorite and the brand learns: from the 4th post on, the style your client already validated is flagged \"RECOMMENDED\".",
  "BEST TIME · CRON": "BEST TIME · CRON",
  "Publica cuando tu audiencia está despierta, no cuando tú te acuerdas.": "Publish when your audience is awake, not when you remember.",
  "Mientras no haya datos propios, usamos los slots óptimos de la industria (Instagram → Martes 7 PM, LinkedIn → Martes 9 AM…). En cuanto acumulas 5 posts publicados, basculamos a tu data real: el botón \"MEJOR HORA\" programa al próximo slot top de tu marca.": "Until we have your own data, we use industry-optimal slots (Instagram → Tuesday 7 PM, LinkedIn → Tuesday 9 AM…). Once you've published 5 posts, we switch to your real data: the \"BEST TIME\" button schedules to your brand's next top slot.",
  "AUTO-REPAIR · TICKETS": "AUTO-REPAIR · TICKETS",
  "Tickets que se arreglan solos, sin esperar a soporte.": "Tickets that fix themselves, no need to wait for support.",
  "La IA clasifica cada ticket en data / config / user_error / code. Si es seguro (limpiar lock de fuerza bruta, cambiar idioma, reactivar usuario) ejecuta el fix sobre la base de datos en segundos. Sólo los bugs que requieren tocar código escalan a un humano.": "The AI classifies each ticket as data / config / user_error / code. If safe (clearing a brute-force lock, changing language, reactivating a user) it runs the fix on the database in seconds. Only bugs that need code changes are escalated to a human.",
  "MULTI-BRAND · AGENCIA": "MULTI-BRAND · AGENCY",
  "5 marcas, 5 voces, 5 calendarios — cero contaminación de datos.": "5 brands, 5 voices, 5 calendars — zero data contamination.",
  "Cada marca tiene su brand_config, sus cuentas sociales, sus posts, su analytics, su brand voice. La vista 360 de Agencia consolida lo que importa sin mezclar nada. Ideal para freelancers que llevan varios clientes o holdings con productos hijos.": "Each brand has its own brand_config, social accounts, posts, analytics, and brand voice. The Agency 360 view consolidates what matters without mixing anything. Perfect for freelancers handling multiple clients or holdings with sub-brands.",
  "BRAND BUILDER": "BRAND BUILDER",
  "De idea a marca en 9 pasos.": "From idea to brand in 9 steps.",
  "Logo con Nano Banana + slogan + paleta + landing HTML/CSS y e-commerce descargables en ZIP.": "Logo with Nano Banana + slogan + palette + landing HTML/CSS and e-commerce downloadable as a ZIP.",
  "EMAIL · SENDGRID": "EMAIL · SENDGRID",
  "Welcome, contratos y upsells reales.": "Real welcome emails, contracts and upsells.",
  "Cron diario manda recordatorios de renewal y upsell free→pago. Idempotente, con log auditable.": "Daily cron sends renewal reminders and free→paid upsells. Idempotent, with an auditable log.",
  "OAUTH · NATIVO": "OAUTH · NATIVE",
  "Conecta IG, FB, LinkedIn, TikTok, X.": "Connect IG, FB, LinkedIn, TikTok, X.",
  "Tokens cifrados con AES, state firmado HMAC, refresh automático. Listo para escalar internacional.": "AES-encrypted tokens, HMAC-signed state, automatic refresh. Ready to scale internationally.",
});

Object.assign(DICT.pt ||= {}, {
  "Tu agencia con cerebro propio.": "Sua agência com cérebro próprio.",
  "Mientras los demás te dejan al frente del calendario, CIA Marketing aprende cómo escribe tu marca, a qué hora rinde mejor cada red, y arregla problemas operativos antes de que los reportes lleguen a tu bandeja.": "Enquanto os outros deixam você gerenciando o calendário, a CIA Marketing aprende como sua marca escreve, em que horário cada rede rende melhor e corrige problemas operacionais antes que os relatórios cheguem à sua caixa.",
  "NUEVO · 2026": "NOVO · 2026",
  "A/B TESTING IA": "A/B TESTING IA",
  "Dos variantes contrastantes en cada generación.": "Duas variantes contrastantes em cada geração.",
  "Activas el modo A/B y la IA produce 2 textos con estilos opuestos (directo vs narrativo). Eliges la que prefieres y la marca aprende: a partir del 4º post, te marca con un sello \"RECOMENDADA\" el estilo que tu cliente ya validó.": "Ative o modo A/B e a IA produz 2 textos com estilos opostos (direto vs narrativo). Você escolhe seu favorito e a marca aprende: a partir do 4º post, o estilo já validado pelo cliente é marcado como \"RECOMENDADO\".",
  "BEST TIME · CRON": "BEST TIME · CRON",
  "Publica cuando tu audiencia está despierta, no cuando tú te acuerdas.": "Publique quando sua audiência está acordada, não quando você lembra.",
  "Mientras no haya datos propios, usamos los slots óptimos de la industria (Instagram → Martes 7 PM, LinkedIn → Martes 9 AM…). En cuanto acumulas 5 posts publicados, basculamos a tu data real: el botón \"MEJOR HORA\" programa al próximo slot top de tu marca.": "Enquanto não houver dados próprios, usamos os horários ótimos da indústria (Instagram → Terça 19h, LinkedIn → Terça 9h…). Após 5 posts publicados, mudamos para seus dados reais: o botão \"MELHOR HORA\" agenda para o próximo slot top da sua marca.",
  "AUTO-REPAIR · TICKETS": "AUTO-REPAIR · TICKETS",
  "Tickets que se arreglan solos, sin esperar a soporte.": "Tickets que se resolvem sozinhos, sem esperar pelo suporte.",
  "La IA clasifica cada ticket en data / config / user_error / code. Si es seguro (limpiar lock de fuerza bruta, cambiar idioma, reactivar usuario) ejecuta el fix sobre la base de datos en segundos. Sólo los bugs que requieren tocar código escalan a un humano.": "A IA classifica cada ticket em data / config / user_error / code. Se for seguro (limpar lock de força bruta, mudar idioma, reativar usuário) executa o fix no banco em segundos. Apenas bugs que exigem código escalonam para um humano.",
  "MULTI-BRAND · AGENCIA": "MULTI-BRAND · AGÊNCIA",
  "5 marcas, 5 voces, 5 calendarios — cero contaminación de datos.": "5 marcas, 5 vozes, 5 calendários — zero contaminação de dados.",
  "Cada marca tiene su brand_config, sus cuentas sociales, sus posts, su analytics, su brand voice. La vista 360 de Agencia consolida lo que importa sin mezclar nada. Ideal para freelancers que llevan varios clientes o holdings con productos hijos.": "Cada marca tem seu brand_config, contas sociais, posts, analytics e brand voice. A visão 360 de Agência consolida o que importa sem misturar nada. Ideal para freelancers com múltiplos clientes ou holdings com sub-marcas.",
  "BRAND BUILDER": "BRAND BUILDER",
  "De idea a marca en 9 pasos.": "De ideia a marca em 9 passos.",
  "Logo con Nano Banana + slogan + paleta + landing HTML/CSS y e-commerce descargables en ZIP.": "Logo com Nano Banana + slogan + paleta + landing HTML/CSS e e-commerce baixáveis em ZIP.",
  "EMAIL · SENDGRID": "EMAIL · SENDGRID",
  "Welcome, contratos y upsells reales.": "Welcome, contratos e upsells reais.",
  "Cron diario manda recordatorios de renewal y upsell free→pago. Idempotente, con log auditable.": "Cron diário envia lembretes de renovação e upsell free→pago. Idempotente, com log auditável.",
  "OAUTH · NATIVO": "OAUTH · NATIVO",
  "Conecta IG, FB, LinkedIn, TikTok, X.": "Conecte IG, FB, LinkedIn, TikTok, X.",
  "Tokens cifrados con AES, state firmado HMAC, refresh automático. Listo para escalar internacional.": "Tokens criptografados com AES, state assinado com HMAC, refresh automático. Pronto para escalar internacionalmente.",
});

Object.assign(DICT.fr ||= {}, {
  "Tu agencia con cerebro propio.": "Votre agence avec son propre cerveau.",
  "Mientras los demás te dejan al frente del calendario, CIA Marketing aprende cómo escribe tu marca, a qué hora rinde mejor cada red, y arregla problemas operativos antes de que los reportes lleguen a tu bandeja.": "Alors que les autres vous laissent gérer le calendrier, CIA Marketing apprend comment votre marque écrit, à quelle heure chaque réseau performe le mieux, et corrige les problèmes opérationnels avant que les rapports n'arrivent dans votre boîte.",
  "NUEVO · 2026": "NOUVEAU · 2026",
  "A/B TESTING IA": "A/B TESTING IA",
  "Dos variantes contrastantes en cada generación.": "Deux variantes contrastées à chaque génération.",
  "Activas el modo A/B y la IA produce 2 textos con estilos opuestos (directo vs narrativo). Eliges la que prefieres y la marca aprende: a partir del 4º post, te marca con un sello \"RECOMENDADA\" el estilo que tu cliente ya validó.": "Activez le mode A/B et l'IA produit 2 textes avec des styles opposés (direct vs narratif). Vous choisissez votre préféré et la marque apprend : dès le 4e post, le style validé par votre client est marqué \"RECOMMANDÉ\".",
  "BEST TIME · CRON": "BEST TIME · CRON",
  "Publica cuando tu audiencia está despierta, no cuando tú te acuerdas.": "Publiez quand votre audience est éveillée, pas quand vous y pensez.",
  "Mientras no haya datos propios, usamos los slots óptimos de la industria (Instagram → Martes 7 PM, LinkedIn → Martes 9 AM…). En cuanto acumulas 5 posts publicados, basculamos a tu data real: el botón \"MEJOR HORA\" programa al próximo slot top de tu marca.": "Sans données propres, nous utilisons les créneaux optimaux du secteur (Instagram → Mardi 19h, LinkedIn → Mardi 9h…). Après 5 posts publiés, nous basculons sur vos vraies données : le bouton \"MEILLEUR MOMENT\" programme au prochain créneau top de votre marque.",
  "AUTO-REPAIR · TICKETS": "AUTO-REPAIR · TICKETS",
  "Tickets que se arreglan solos, sin esperar a soporte.": "Des tickets qui se résolvent seuls, sans attendre le support.",
  "La IA clasifica cada ticket en data / config / user_error / code. Si es seguro (limpiar lock de fuerza bruta, cambiar idioma, reactivar usuario) ejecuta el fix sobre la base de datos en segundos. Sólo los bugs que requieren tocar código escalan a un humano.": "L'IA classe chaque ticket en data / config / user_error / code. Si c'est sûr (nettoyer un lock brute-force, changer la langue, réactiver un utilisateur), elle exécute le fix sur la base en quelques secondes. Seuls les bugs nécessitant du code sont escaladés à un humain.",
  "MULTI-BRAND · AGENCIA": "MULTI-MARQUE · AGENCE",
  "5 marcas, 5 voces, 5 calendarios — cero contaminación de datos.": "5 marques, 5 voix, 5 calendriers — zéro contamination de données.",
  "Cada marca tiene su brand_config, sus cuentas sociales, sus posts, su analytics, su brand voice. La vista 360 de Agencia consolida lo que importa sin mezclar nada. Ideal para freelancers que llevan varios clientes o holdings con productos hijos.": "Chaque marque a son brand_config, ses comptes sociaux, ses posts, ses analytics, sa brand voice. La vue 360 d'Agence consolide ce qui compte sans tout mélanger. Idéal pour les freelances avec plusieurs clients ou les holdings avec sous-marques.",
  "BRAND BUILDER": "BRAND BUILDER",
  "De idea a marca en 9 pasos.": "De l'idée à la marque en 9 étapes.",
  "Logo con Nano Banana + slogan + paleta + landing HTML/CSS y e-commerce descargables en ZIP.": "Logo avec Nano Banana + slogan + palette + landing HTML/CSS et e-commerce téléchargeables en ZIP.",
  "EMAIL · SENDGRID": "EMAIL · SENDGRID",
  "Welcome, contratos y upsells reales.": "Vrais emails de bienvenue, contrats et upsells.",
  "Cron diario manda recordatorios de renewal y upsell free→pago. Idempotente, con log auditable.": "Cron quotidien envoie les rappels de renouvellement et upsells free→payé. Idempotent, avec log auditable.",
  "OAUTH · NATIVO": "OAUTH · NATIF",
  "Conecta IG, FB, LinkedIn, TikTok, X.": "Connectez IG, FB, LinkedIn, TikTok, X.",
  "Tokens cifrados con AES, state firmado HMAC, refresh automático. Listo para escalar internacional.": "Tokens chiffrés AES, state signé HMAC, refresh automatique. Prêt à passer à l'international.",
});

Object.assign(DICT.de ||= {}, {
  "Tu agencia con cerebro propio.": "Ihre Agentur mit eigenem Gehirn.",
  "Mientras los demás te dejan al frente del calendario, CIA Marketing aprende cómo escribe tu marca, a qué hora rinde mejor cada red, y arregla problemas operativos antes de que los reportes lleguen a tu bandeja.": "Während andere Sie mit dem Kalender allein lassen, lernt CIA Marketing, wie Ihre Marke schreibt, zu welcher Uhrzeit jedes Netzwerk am besten performt, und behebt operative Probleme, bevor die Berichte in Ihrem Postfach landen.",
  "NUEVO · 2026": "NEU · 2026",
  "A/B TESTING IA": "A/B-TEST KI",
  "Dos variantes contrastantes en cada generación.": "Zwei kontrastierende Varianten bei jeder Generierung.",
  "Activas el modo A/B y la IA produce 2 textos con estilos opuestos (directo vs narrativo). Eliges la que prefieres y la marca aprende: a partir del 4º post, te marca con un sello \"RECOMENDADA\" el estilo que tu cliente ya validó.": "Aktivieren Sie den A/B-Modus und die KI erstellt 2 Texte mit gegensätzlichen Stilen (direkt vs. erzählend). Sie wählen Ihren Favoriten und die Marke lernt: Ab dem 4. Post wird der vom Kunden bestätigte Stil als \"EMPFOHLEN\" markiert.",
  "BEST TIME · CRON": "BESTE ZEIT · CRON",
  "Publica cuando tu audiencia está despierta, no cuando tú te acuerdas.": "Posten, wenn Ihre Zielgruppe wach ist, nicht wenn Sie daran denken.",
  "Mientras no haya datos propios, usamos los slots óptimos de la industria (Instagram → Martes 7 PM, LinkedIn → Martes 9 AM…). En cuanto acumulas 5 posts publicados, basculamos a tu data real: el botón \"MEJOR HORA\" programa al próximo slot top de tu marca.": "Solange keine eigenen Daten vorhanden sind, nutzen wir branchenoptimale Slots (Instagram → Dienstag 19 Uhr, LinkedIn → Dienstag 9 Uhr…). Nach 5 veröffentlichten Posts wechseln wir zu Ihren echten Daten: Der \"BESTE ZEIT\"-Button plant den nächsten Top-Slot Ihrer Marke.",
  "AUTO-REPAIR · TICKETS": "AUTO-REPAIR · TICKETS",
  "Tickets que se arreglan solos, sin esperar a soporte.": "Tickets, die sich selbst lösen, ohne auf den Support zu warten.",
  "La IA clasifica cada ticket en data / config / user_error / code. Si es seguro (limpiar lock de fuerza bruta, cambiar idioma, reactivar usuario) ejecuta el fix sobre la base de datos en segundos. Sólo los bugs que requieren tocar código escalan a un humano.": "Die KI klassifiziert jedes Ticket als data / config / user_error / code. Bei sicheren Fällen (Brute-Force-Lock entfernen, Sprache ändern, Nutzer reaktivieren) führt sie den Fix in Sekunden auf der Datenbank aus. Nur Bugs, die Code erfordern, werden an Menschen eskaliert.",
  "MULTI-BRAND · AGENCIA": "MULTI-MARKE · AGENTUR",
  "5 marcas, 5 voces, 5 calendarios — cero contaminación de datos.": "5 Marken, 5 Stimmen, 5 Kalender — null Datenvermischung.",
  "Cada marca tiene su brand_config, sus cuentas sociales, sus posts, su analytics, su brand voice. La vista 360 de Agencia consolida lo que importa sin mezclar nada. Ideal para freelancers que llevan varios clientes o holdings con productos hijos.": "Jede Marke hat eigene brand_config, Social-Konten, Posts, Analytics und Brand Voice. Die 360-Agentur-Ansicht konsolidiert das Wesentliche, ohne etwas zu vermischen. Perfekt für Freelancer mit mehreren Kunden oder Holdings mit Sub-Marken.",
  "BRAND BUILDER": "BRAND BUILDER",
  "De idea a marca en 9 pasos.": "Von der Idee zur Marke in 9 Schritten.",
  "Logo con Nano Banana + slogan + paleta + landing HTML/CSS y e-commerce descargables en ZIP.": "Logo mit Nano Banana + Slogan + Palette + Landing HTML/CSS und E-Commerce als ZIP herunterladbar.",
  "EMAIL · SENDGRID": "EMAIL · SENDGRID",
  "Welcome, contratos y upsells reales.": "Echte Welcome-Mails, Verträge und Upsells.",
  "Cron diario manda recordatorios de renewal y upsell free→pago. Idempotente, con log auditable.": "Täglicher Cron sendet Renewal-Erinnerungen und Free→Paid-Upsells. Idempotent, mit auditierbarem Log.",
  "OAUTH · NATIVO": "OAUTH · NATIV",
  "Conecta IG, FB, LinkedIn, TikTok, X.": "Verbinden Sie IG, FB, LinkedIn, TikTok, X.",
  "Tokens cifrados con AES, state firmado HMAC, refresh automático. Listo para escalar internacional.": "AES-verschlüsselte Tokens, HMAC-signierter State, automatischer Refresh. Bereit für internationale Skalierung.",
});

Object.assign(DICT.it ||= {}, {
  "Tu agencia con cerebro propio.": "La tua agenzia con cervello proprio.",
  "Mientras los demás te dejan al frente del calendario, CIA Marketing aprende cómo escribe tu marca, a qué hora rinde mejor cada red, y arregla problemas operativos antes de que los reportes lleguen a tu bandeja.": "Mentre gli altri ti lasciano a gestire il calendario, CIA Marketing impara come scrive il tuo brand, a che ora ogni rete rende meglio e risolve problemi operativi prima che i report arrivino nella tua casella.",
  "NUEVO · 2026": "NUOVO · 2026",
  "A/B TESTING IA": "A/B TESTING IA",
  "Dos variantes contrastantes en cada generación.": "Due varianti contrastanti per ogni generazione.",
  "Activas el modo A/B y la IA produce 2 textos con estilos opuestos (directo vs narrativo). Eliges la que prefieres y la marca aprende: a partir del 4º post, te marca con un sello \"RECOMENDADA\" el estilo que tu cliente ya validó.": "Attivi la modalità A/B e l'IA produce 2 testi con stili opposti (diretto vs narrativo). Scegli il preferito e il brand impara: dal 4° post, lo stile validato dal cliente viene marcato \"CONSIGLIATO\".",
  "BEST TIME · CRON": "BEST TIME · CRON",
  "Publica cuando tu audiencia está despierta, no cuando tú te acuerdas.": "Pubblica quando la tua audience è sveglia, non quando ti ricordi.",
  "Mientras no haya datos propios, usamos los slots óptimos de la industria (Instagram → Martes 7 PM, LinkedIn → Martes 9 AM…). En cuanto acumulas 5 posts publicados, basculamos a tu data real: el botón \"MEJOR HORA\" programa al próximo slot top de tu marca.": "Senza dati propri, usiamo gli slot ottimali del settore (Instagram → Martedì 19, LinkedIn → Martedì 9…). Dopo 5 post pubblicati passiamo ai tuoi dati reali: il pulsante \"MIGLIOR ORA\" programma al prossimo slot top del brand.",
  "AUTO-REPAIR · TICKETS": "AUTO-REPAIR · TICKETS",
  "Tickets que se arreglan solos, sin esperar a soporte.": "Ticket che si risolvono da soli, senza aspettare il supporto.",
  "La IA clasifica cada ticket en data / config / user_error / code. Si es seguro (limpiar lock de fuerza bruta, cambiar idioma, reactivar usuario) ejecuta el fix sobre la base de datos en segundos. Sólo los bugs que requieren tocar código escalan a un humano.": "L'IA classifica ogni ticket come data / config / user_error / code. Se è sicuro (pulire lock brute-force, cambiare lingua, riattivare utente) esegue il fix sul database in secondi. Solo i bug che richiedono codice scalano a un umano.",
  "MULTI-BRAND · AGENCIA": "MULTI-BRAND · AGENZIA",
  "5 marcas, 5 voces, 5 calendarios — cero contaminación de datos.": "5 brand, 5 voci, 5 calendari — zero contaminazione di dati.",
  "Cada marca tiene su brand_config, sus cuentas sociales, sus posts, su analytics, su brand voice. La vista 360 de Agencia consolida lo que importa sin mezclar nada. Ideal para freelancers que llevan varios clientes o holdings con productos hijos.": "Ogni brand ha il suo brand_config, account social, post, analytics e brand voice. La vista 360 di Agenzia consolida ciò che conta senza mischiare nulla. Ideale per freelance con più clienti o holding con sotto-brand.",
  "BRAND BUILDER": "BRAND BUILDER",
  "De idea a marca en 9 pasos.": "Da idea a brand in 9 passi.",
  "Logo con Nano Banana + slogan + paleta + landing HTML/CSS y e-commerce descargables en ZIP.": "Logo con Nano Banana + slogan + palette + landing HTML/CSS ed e-commerce scaricabili in ZIP.",
  "EMAIL · SENDGRID": "EMAIL · SENDGRID",
  "Welcome, contratos y upsells reales.": "Email di benvenuto, contratti e upsell veri.",
  "Cron diario manda recordatorios de renewal y upsell free→pago. Idempotente, con log auditable.": "Cron giornaliero invia promemoria di rinnovo e upsell free→pagamento. Idempotente, con log auditabile.",
  "OAUTH · NATIVO": "OAUTH · NATIVO",
  "Conecta IG, FB, LinkedIn, TikTok, X.": "Collega IG, FB, LinkedIn, TikTok, X.",
  "Tokens cifrados con AES, state firmado HMAC, refresh automático. Listo para escalar internacional.": "Token cifrati AES, state firmato HMAC, refresh automatico. Pronto per scalare a livello internazionale.",
});

void _SMART_CARDS_KEYS;

// === Auth (Login/Register) ===
Object.assign(DICT.en ||= {}, {
  "Acceso autorizado": "Authorized access",
  "VERIFICANDO…": "VERIFYING…",
  "ENTRAR": "SIGN IN",
  "¿Sin cuenta?": "No account?",
  "REGISTRANDO…": "REGISTERING…",
  "CREAR CUENTA": "CREATE ACCOUNT",
  "¿Ya tienes cuenta?": "Already have an account?",
  "Debes confirmar que eres mayor de 18 años.": "You must confirm you are at least 18 years old.",
  "Debes aceptar los Términos de Servicio y la Política de Privacidad.": "You must accept the Terms of Service and Privacy Policy.",
  "Confirmo que tengo al menos 18 años (o la edad legal de mayoría en mi jurisdicción).": "I confirm I am at least 18 years old (or the legal age of majority in my jurisdiction).",
  "Acepto los": "I accept the",
  "Términos de Servicio": "Terms of Service",
  "Política de Privacidad": "Privacy Policy",
  "Política de Cookies": "Cookie Policy",
  "y": "and",
});
Object.assign(DICT.pt ||= {}, {
  "Acceso autorizado": "Acesso autorizado",
  "VERIFICANDO…": "VERIFICANDO…",
  "ENTRAR": "ENTRAR",
  "¿Sin cuenta?": "Sem conta?",
  "REGISTRANDO…": "REGISTRANDO…",
  "CREAR CUENTA": "CRIAR CONTA",
  "¿Ya tienes cuenta?": "Já tem conta?",
  "Debes confirmar que eres mayor de 18 años.": "Você deve confirmar que tem pelo menos 18 anos.",
  "Debes aceptar los Términos de Servicio y la Política de Privacidad.": "Você deve aceitar os Termos de Serviço e a Política de Privacidade.",
  "Confirmo que tengo al menos 18 años (o la edad legal de mayoría en mi jurisdicción).": "Confirmo que tenho pelo menos 18 anos (ou a idade legal de maioridade na minha jurisdição).",
  "Acepto los": "Aceito os",
  "Términos de Servicio": "Termos de Serviço",
  "Política de Privacidad": "Política de Privacidade",
  "Política de Cookies": "Política de Cookies",
  "y": "e",
});
Object.assign(DICT.fr ||= {}, {
  "Acceso autorizado": "Accès autorisé",
  "VERIFICANDO…": "VÉRIFICATION…",
  "ENTRAR": "SE CONNECTER",
  "¿Sin cuenta?": "Pas de compte ?",
  "REGISTRANDO…": "INSCRIPTION…",
  "CREAR CUENTA": "CRÉER UN COMPTE",
  "¿Ya tienes cuenta?": "Déjà un compte ?",
  "Debes confirmar que eres mayor de 18 años.": "Vous devez confirmer que vous avez au moins 18 ans.",
  "Debes aceptar los Términos de Servicio y la Política de Privacidad.": "Vous devez accepter les Conditions de Service et la Politique de Confidentialité.",
  "Confirmo que tengo al menos 18 años (o la edad legal de mayoría en mi jurisdicción).": "Je confirme avoir au moins 18 ans (ou l'âge légal de majorité dans ma juridiction).",
  "Acepto los": "J'accepte les",
  "Términos de Servicio": "Conditions de Service",
  "Política de Privacidad": "Politique de Confidentialité",
  "Política de Cookies": "Politique de Cookies",
  "y": "et",
});
Object.assign(DICT.de ||= {}, {
  "Acceso autorizado": "Autorisierter Zugang",
  "VERIFICANDO…": "ÜBERPRÜFE…",
  "ENTRAR": "ANMELDEN",
  "¿Sin cuenta?": "Noch kein Konto?",
  "REGISTRANDO…": "REGISTRIERE…",
  "CREAR CUENTA": "KONTO ERSTELLEN",
  "¿Ya tienes cuenta?": "Bereits ein Konto?",
  "Debes confirmar que eres mayor de 18 años.": "Sie müssen bestätigen, dass Sie mindestens 18 Jahre alt sind.",
  "Debes aceptar los Términos de Servicio y la Política de Privacidad.": "Sie müssen die Nutzungsbedingungen und die Datenschutzrichtlinie akzeptieren.",
  "Confirmo que tengo al menos 18 años (o la edad legal de mayoría en mi jurisdicción).": "Ich bestätige, dass ich mindestens 18 Jahre alt bin (oder das gesetzliche Mündigkeitsalter in meiner Jurisdiktion erreicht habe).",
  "Acepto los": "Ich akzeptiere die",
  "Términos de Servicio": "Nutzungsbedingungen",
  "Política de Privacidad": "Datenschutzrichtlinie",
  "Política de Cookies": "Cookie-Richtlinie",
  "y": "und",
});
Object.assign(DICT.it ||= {}, {
  "Acceso autorizado": "Accesso autorizzato",
  "VERIFICANDO…": "VERIFICA…",
  "ENTRAR": "ACCEDI",
  "¿Sin cuenta?": "Nessun account?",
  "REGISTRANDO…": "REGISTRAZIONE…",
  "CREAR CUENTA": "CREA ACCOUNT",
  "¿Ya tienes cuenta?": "Hai già un account?",
  "Debes confirmar que eres mayor de 18 años.": "Devi confermare di avere almeno 18 anni.",
  "Debes aceptar los Términos de Servicio y la Política de Privacidad.": "Devi accettare i Termini di Servizio e l'Informativa sulla Privacy.",
  "Confirmo que tengo al menos 18 años (o la edad legal de mayoría en mi jurisdicción).": "Confermo di avere almeno 18 anni (o l'età legale di maggioranza nella mia giurisdizione).",
  "Acepto los": "Accetto i",
  "Términos de Servicio": "Termini di Servizio",
  "Política de Privacidad": "Informativa sulla Privacy",
  "Política de Cookies": "Informativa sui Cookie",
  "y": "e",
});

// === Live Demo Widget ===
const _LIVE_DEMO_KEYS = [
  "DEMO EN VIVO · GRATIS · 1 POR DISPOSITIVO",
  "SIN REGISTRARTE",
  "Pruébalo ahora — escribe un tema y mira la IA en vivo.",
  "Para descargar y usar el resultado: crea cuenta y elige un plan. Una demo por IP cada 24 h.",
  "YA USASTE TU DEMO",
  "Para generar más, descargar este caption o abrir el generador completo, crea tu cuenta gratis.",
  "CREAR CUENTA GRATIS",
  "YA TENGO CUENTA",
  "Ej: Lanzamiento del nuevo café frío de oficina con descuento del 15%",
  "RESULTADO · PREVIEW",
  "¿Te gusta? Crea cuenta para descargar y agendar:",
  "Error al generar",
];
Object.assign(DICT.en ||= {}, {
  "DEMO EN VIVO · GRATIS · 1 POR DISPOSITIVO": "LIVE DEMO · FREE · 1 PER DEVICE",
  "SIN REGISTRARTE": "NO SIGNUP",
  "Pruébalo ahora — escribe un tema y mira la IA en vivo.": "Try it now — type a topic and watch the AI live.",
  "Para descargar y usar el resultado: crea cuenta y elige un plan. Una demo por IP cada 24 h.": "To download and use the result: create an account and choose a plan. One demo per IP every 24 h.",
  "YA USASTE TU DEMO": "YOU ALREADY USED YOUR DEMO",
  "Para generar más, descargar este caption o abrir el generador completo, crea tu cuenta gratis.": "To generate more, download this caption, or open the full generator, create your free account.",
  "CREAR CUENTA GRATIS": "CREATE FREE ACCOUNT",
  "YA TENGO CUENTA": "I ALREADY HAVE AN ACCOUNT",
  "Ej: Lanzamiento del nuevo café frío de oficina con descuento del 15%": "E.g.: Launching the new office cold brew with a 15% discount",
  "RESULTADO · PREVIEW": "RESULT · PREVIEW",
  "¿Te gusta? Crea cuenta para descargar y agendar:": "Like it? Create an account to download and schedule:",
  "Error al generar": "Error while generating",
});
Object.assign(DICT.pt ||= {}, {
  "DEMO EN VIVO · GRATIS · 1 POR DISPOSITIVO": "DEMO AO VIVO · GRÁTIS · 1 POR DISPOSITIVO",
  "SIN REGISTRARTE": "SEM CADASTRO",
  "Pruébalo ahora — escribe un tema y mira la IA en vivo.": "Teste agora — escreva um tema e veja a IA ao vivo.",
  "Para descargar y usar el resultado: crea cuenta y elige un plan. Una demo por IP cada 24 h.": "Para baixar e usar o resultado: crie conta e escolha um plano. Uma demo por IP a cada 24 h.",
  "YA USASTE TU DEMO": "VOCÊ JÁ USOU SUA DEMO",
  "Para generar más, descargar este caption o abrir el generador completo, crea tu cuenta gratis.": "Para gerar mais, baixar essa legenda ou abrir o gerador completo, crie sua conta grátis.",
  "CREAR CUENTA GRATIS": "CRIAR CONTA GRÁTIS",
  "YA TENGO CUENTA": "JÁ TENHO CONTA",
  "Ej: Lanzamiento del nuevo café frío de oficina con descuento del 15%": "Ex: Lançamento do novo café gelado de escritório com 15% de desconto",
  "RESULTADO · PREVIEW": "RESULTADO · PREVIEW",
  "¿Te gusta? Crea cuenta para descargar y agendar:": "Gostou? Crie conta para baixar e agendar:",
  "Error al generar": "Erro ao gerar",
});
Object.assign(DICT.fr ||= {}, {
  "DEMO EN VIVO · GRATIS · 1 POR DISPOSITIVO": "DÉMO EN DIRECT · GRATUIT · 1 PAR APPAREIL",
  "SIN REGISTRARTE": "SANS INSCRIPTION",
  "Pruébalo ahora — escribe un tema y mira la IA en vivo.": "Essayez maintenant — tapez un sujet et regardez l'IA en direct.",
  "Para descargar y usar el resultado: crea cuenta y elige un plan. Una demo por IP cada 24 h.": "Pour télécharger et utiliser le résultat : créez un compte et choisissez un plan. Une démo par IP toutes les 24 h.",
  "YA USASTE TU DEMO": "VOUS AVEZ DÉJÀ UTILISÉ VOTRE DÉMO",
  "Para generar más, descargar este caption o abrir el generador completo, crea tu cuenta gratis.": "Pour générer plus, télécharger cette légende ou ouvrir le générateur complet, créez votre compte gratuit.",
  "CREAR CUENTA GRATIS": "CRÉER UN COMPTE GRATUIT",
  "YA TENGO CUENTA": "J'AI DÉJÀ UN COMPTE",
  "Ej: Lanzamiento del nuevo café frío de oficina con descuento del 15%": "Ex : Lancement du nouveau café froid de bureau avec 15 % de remise",
  "RESULTADO · PREVIEW": "RÉSULTAT · APERÇU",
  "¿Te gusta? Crea cuenta para descargar y agendar:": "Vous aimez ? Créez un compte pour télécharger et planifier :",
  "Error al generar": "Erreur lors de la génération",
});
Object.assign(DICT.de ||= {}, {
  "DEMO EN VIVO · GRATIS · 1 POR DISPOSITIVO": "LIVE-DEMO · KOSTENLOS · 1 PRO GERÄT",
  "SIN REGISTRARTE": "OHNE REGISTRIERUNG",
  "Pruébalo ahora — escribe un tema y mira la IA en vivo.": "Jetzt ausprobieren — Thema eingeben und KI live ansehen.",
  "Para descargar y usar el resultado: crea cuenta y elige un plan. Una demo por IP cada 24 h.": "Um das Ergebnis herunterzuladen und zu verwenden: Konto erstellen und Plan wählen. Eine Demo pro IP alle 24 h.",
  "YA USASTE TU DEMO": "SIE HABEN IHRE DEMO BEREITS GENUTZT",
  "Para generar más, descargar este caption o abrir el generador completo, crea tu cuenta gratis.": "Um mehr zu generieren, diese Caption herunterzuladen oder den vollständigen Generator zu öffnen, erstellen Sie Ihr kostenloses Konto.",
  "CREAR CUENTA GRATIS": "KOSTENLOSES KONTO ERSTELLEN",
  "YA TENGO CUENTA": "ICH HABE BEREITS EIN KONTO",
  "Ej: Lanzamiento del nuevo café frío de oficina con descuento del 15%": "z. B.: Launch des neuen Office-Cold-Brews mit 15 % Rabatt",
  "RESULTADO · PREVIEW": "ERGEBNIS · VORSCHAU",
  "¿Te gusta? Crea cuenta para descargar y agendar:": "Gefällt es? Konto erstellen, um herunterzuladen und zu planen:",
  "Error al generar": "Fehler beim Generieren",
});
Object.assign(DICT.it ||= {}, {
  "DEMO EN VIVO · GRATIS · 1 POR DISPOSITIVO": "DEMO LIVE · GRATIS · 1 PER DISPOSITIVO",
  "SIN REGISTRARTE": "SENZA REGISTRARSI",
  "Pruébalo ahora — escribe un tema y mira la IA en vivo.": "Provalo ora — scrivi un tema e guarda l'IA in diretta.",
  "Para descargar y usar el resultado: crea cuenta y elige un plan. Una demo por IP cada 24 h.": "Per scaricare e usare il risultato: crea un account e scegli un piano. Una demo per IP ogni 24 h.",
  "YA USASTE TU DEMO": "HAI GIÀ USATO LA TUA DEMO",
  "Para generar más, descargar este caption o abrir el generador completo, crea tu cuenta gratis.": "Per generarne altri, scaricare questa caption o aprire il generatore completo, crea il tuo account gratuito.",
  "CREAR CUENTA GRATIS": "CREA ACCOUNT GRATUITO",
  "YA TENGO CUENTA": "HO GIÀ UN ACCOUNT",
  "Ej: Lanzamiento del nuevo café frío de oficina con descuento del 15%": "Es: Lancio del nuovo caffè freddo da ufficio con sconto del 15%",
  "RESULTADO · PREVIEW": "RISULTATO · ANTEPRIMA",
  "¿Te gusta? Crea cuenta para descargar y agendar:": "Ti piace? Crea un account per scaricare e pianificare:",
  "Error al generar": "Errore durante la generazione",
});
void _LIVE_DEMO_KEYS;

void _LIVE_DEMO_KEYS;

// === Landing mock previews + voices (DOSSIER 03 · MUESTRAS / VOCES) ===
Object.assign(DICT.en ||= {}, {
  "CDMX · MÉXICO": "MEXICO CITY · MEXICO",
  "me gusta": "likes",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Your next purchase isn't a decision, it's a signal. We launch Friday — turn on notifications 🔔",
  "ver 42 comentarios": "view 42 comments",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERATED · AUTO-APPROVED · PUBLISHED 6:00 PM",
  "2,340 SEGUIDORES · HACE 2H": "2,340 FOLLOWERS · 2H AGO",
  "No es falta de producto. Es falta de distribución constante.": "It's not lack of product. It's lack of consistent distribution.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "That's why we stopped hiring community managers and started publishing 5× more with AI.",
  "¿Resultado?": "Result?",
  "CPL -38% en 90 días.": "CPL -38% in 90 days.",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 comments · 67 reposts",
  "GENERADO": "GENERATED",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOICES",
  "El copy que enganchó a miles.": "The copy that hooked thousands.",
  "Generado por IA.": "AI-generated.",
  "INSTAGRAM · CAPTION": "INSTAGRAM · CAPTION",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2.1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3.2M VIEWS",
  "287K impresiones · 4.8% engagement": "287K impressions · 4.8% engagement",
  "3.2M vistas · +14K seguidores": "3.2M views · +14K followers",
  "12,400 me gusta · +892 guardados": "12,400 likes · +892 saved",
  "GENERAR MI PRIMER POST GRATIS": "GENERATE MY FIRST POST FREE",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "NO CARD REQUIRED · CANCEL ANYTIME",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\n\nYa no más. 💛\"": "\"We know the feeling. Opening the feed on a Monday at 8am and remembering you forgot to schedule last Friday's post.\n\nNot anymore. 💛\"",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\n\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Your marketing team sleeps, so do your sales. 😴\n\nWe automate the first one. The second is on you. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\n\nMientras tú sigues pagándole a 3 personas.\"": "\"Nobody is going to tell you this, but 80% of your competition already posts with AI…\n\nMeanwhile you're paying three people.\"",
});
Object.assign(DICT.pt ||= {}, {
  "CDMX · MÉXICO": "CDMX · MÉXICO",
  "me gusta": "curtidas",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Sua próxima compra não é uma decisão, é um sinal. Lançamos sexta — ative as notificações 🔔",
  "ver 42 comentarios": "ver 42 comentários",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GERADO · APROVADO AUTO · PUBLICADO 18:00",
  "2,340 SEGUIDORES · HACE 2H": "2.340 SEGUIDORES · HÁ 2H",
  "No es falta de producto. Es falta de distribución constante.": "Não é falta de produto. É falta de distribuição constante.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "Por isso paramos de contratar community managers e começamos a publicar 5× mais com IA.",
  "¿Resultado?": "Resultado?",
  "CPL -38% en 90 días.": "CPL -38% em 90 dias.",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 comentários · 67 republicações",
  "GENERADO": "GERADO",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOZES",
  "El copy que enganchó a miles.": "O copy que conquistou milhares.",
  "Generado por IA.": "Gerado por IA.",
  "INSTAGRAM · CAPTION": "INSTAGRAM · LEGENDA",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2.1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3.2M VIEWS",
  "287K impresiones · 4.8% engagement": "287K impressões · 4,8% engajamento",
  "3.2M vistas · +14K seguidores": "3,2M visualizações · +14K seguidores",
  "12,400 me gusta · +892 guardados": "12.400 curtidas · +892 salvos",
  "GENERAR MI PRIMER POST GRATIS": "GERAR MEU PRIMEIRO POST GRÁTIS",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "SEM CARTÃO · CANCELE QUANDO QUISER",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\n\nYa no más. 💛\"": "\"Sabemos como é. Abrir o feed numa segunda às 8h e lembrar que esqueceu de agendar o post da sexta passada.\n\nNunca mais. 💛\"",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\n\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Sua equipe de marketing dorme, suas vendas também. 😴\n\nNós automatizamos a primeira parte. Da segunda você cuida. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\n\nMientras tú sigues pagándole a 3 personas.\"": "\"Ninguém vai te dizer isso, mas 80% dos seus concorrentes já publicam com IA…\n\nEnquanto você continua pagando 3 pessoas.\"",
});
Object.assign(DICT.fr ||= {}, {
  "CDMX · MÉXICO": "CDMX · MEXIQUE",
  "me gusta": "j'aime",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Votre prochain achat n'est pas une décision, c'est un signal. Lancement vendredi — activez les notifications 🔔",
  "ver 42 comentarios": "voir 42 commentaires",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GÉNÉRÉ · AUTO-APPROUVÉ · PUBLIÉ 18H00",
  "2,340 SEGUIDORES · HACE 2H": "2 340 ABONNÉS · IL Y A 2H",
  "No es falta de producto. Es falta de distribución constante.": "Ce n'est pas un manque de produit. C'est un manque de distribution constante.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "C'est pourquoi nous avons cessé d'embaucher des community managers et commencé à publier 5× plus avec l'IA.",
  "¿Resultado?": "Résultat ?",
  "CPL -38% en 90 días.": "CPL -38% en 90 jours.",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 commentaires · 67 partages",
  "GENERADO": "GÉNÉRÉ",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOIX",
  "El copy que enganchó a miles.": "Le copy qui a accroché des milliers.",
  "Generado por IA.": "Généré par l'IA.",
  "INSTAGRAM · CAPTION": "INSTAGRAM · LÉGENDE",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2,1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · ACCROCHE · 3,2M VUES",
  "287K impresiones · 4.8% engagement": "287K impressions · 4,8% engagement",
  "3.2M vistas · +14K seguidores": "3,2M vues · +14K abonnés",
  "12,400 me gusta · +892 guardados": "12 400 j'aime · +892 enregistrés",
  "GENERAR MI PRIMER POST GRATIS": "GÉNÉRER MON PREMIER POST GRATUIT",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "SANS CARTE · ANNULEZ QUAND VOUS VOULEZ",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\n\nYa no más. 💛\"": "\"On connaît la sensation. Ouvrir le feed un lundi à 8h et se rappeler qu'on a oublié de programmer le post de vendredi dernier.\n\nFini tout ça. 💛\"",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\n\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Votre équipe marketing dort, vos ventes aussi. 😴\n\nOn automatise la première partie. La seconde, c'est vous. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\n\nMientras tú sigues pagándole a 3 personas.\"": "\"Personne ne va vous le dire, mais 80% de vos concurrents publient déjà avec l'IA…\n\nPendant que vous payez encore 3 personnes.\"",
});
Object.assign(DICT.de ||= {}, {
  "CDMX · MÉXICO": "MEXIKO-STADT · MEXIKO",
  "me gusta": "Gefällt mir",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Ihr nächster Kauf ist keine Entscheidung, sondern ein Signal. Launch am Freitag — Benachrichtigungen aktivieren 🔔",
  "ver 42 comentarios": "42 Kommentare ansehen",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERIERT · AUTO-FREIGEGEBEN · VERÖFFENTLICHT 18:00",
  "2,340 SEGUIDORES · HACE 2H": "2.340 FOLLOWER · VOR 2 STD",
  "No es falta de producto. Es falta de distribución constante.": "Es ist nicht Produktmangel. Es ist Mangel an konstanter Distribution.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "Deshalb haben wir aufgehört, Community Manager einzustellen, und veröffentlichen 5× mehr mit KI.",
  "¿Resultado?": "Ergebnis?",
  "CPL -38% en 90 días.": "CPL -38% in 90 Tagen.",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 Kommentare · 67 Reposts",
  "GENERADO": "GENERIERT",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · STIMMEN",
  "El copy que enganchó a miles.": "Der Copy, der Tausende fesselte.",
  "Generado por IA.": "KI-generiert.",
  "INSTAGRAM · CAPTION": "INSTAGRAM · CAPTION",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2,1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3,2M AUFRUFE",
  "287K impresiones · 4.8% engagement": "287K Impressionen · 4,8% Engagement",
  "3.2M vistas · +14K seguidores": "3,2M Aufrufe · +14K Follower",
  "12,400 me gusta · +892 guardados": "12.400 Gefällt mir · +892 gespeichert",
  "GENERAR MI PRIMER POST GRATIS": "MEINEN ERSTEN POST KOSTENLOS GENERIEREN",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "KEINE KARTE NÖTIG · JEDERZEIT KÜNDBAR",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\n\nYa no más. 💛\"": "\"Wir kennen das Gefühl. Montag um 8 Uhr den Feed öffnen und merken, dass man den Post vom letzten Freitag vergessen hat.\n\nNie wieder. 💛\"",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\n\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Ihr Marketing-Team schläft, Ihre Verkäufe auch. 😴\n\nWir automatisieren den ersten Teil. Der zweite liegt bei Ihnen. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\n\nMientras tú sigues pagándole a 3 personas.\"": "\"Niemand wird Ihnen das sagen, aber 80 % Ihrer Konkurrenz posten schon mit KI…\n\nWährend Sie weiterhin drei Leute bezahlen.\"",
});
Object.assign(DICT.it ||= {}, {
  "CDMX · MÉXICO": "CITTÀ DEL MESSICO · MESSICO",
  "me gusta": "mi piace",
  "Tu próxima compra no es una decisión, es una señal. La lanzamos el viernes — activa las notificaciones 🔔": "Il tuo prossimo acquisto non è una decisione, è un segnale. Lanciamo venerdì — attiva le notifiche 🔔",
  "ver 42 comentarios": "vedi 42 commenti",
  "GENERADO · APROBADO AUTO · PUBLICADO 18:00": "GENERATO · APPROVATO AUTO · PUBBLICATO 18:00",
  "2,340 SEGUIDORES · HACE 2H": "2.340 FOLLOWER · 2 ORE FA",
  "No es falta de producto. Es falta de distribución constante.": "Non è mancanza di prodotto. È mancanza di distribuzione costante.",
  "Por eso dejamos de contratar community managers y empezamos a publicar 5× más con IA.": "Per questo abbiamo smesso di assumere community manager e abbiamo iniziato a pubblicare 5× di più con l'IA.",
  "¿Resultado?": "Risultato?",
  "CPL -38% en 90 días.": "CPL -38% in 90 giorni.",
  "892 · 104 comentarios · 67 republicaciones": "892 · 104 commenti · 67 repost",
  "GENERADO": "GENERATO",
  "DOSSIER 03.2 · VOCES": "DOSSIER 03.2 · VOCI",
  "El copy que enganchó a miles.": "Il copy che ha agganciato migliaia.",
  "Generado por IA.": "Generato dall'IA.",
  "INSTAGRAM · CAPTION": "INSTAGRAM · DIDASCALIA",
  "TWITTER / X · 2.1K RT": "TWITTER / X · 2,1K RT",
  "TIKTOK · HOOK · 3.2M VIEWS": "TIKTOK · HOOK · 3,2M VISUALIZZAZIONI",
  "287K impresiones · 4.8% engagement": "287K impressioni · 4,8% engagement",
  "3.2M vistas · +14K seguidores": "3,2M visualizzazioni · +14K follower",
  "12,400 me gusta · +892 guardados": "12.400 mi piace · +892 salvati",
  "GENERAR MI PRIMER POST GRATIS": "GENERA IL MIO PRIMO POST GRATIS",
  "NO REQUIERE TARJETA · CANCELA CUANDO QUIERAS": "SENZA CARTA · ANNULLA QUANDO VUOI",
  "\"Sabemos lo que se siente. Abrir el feed un lunes a las 8am y recordar que olvidaste programar el post del viernes pasado.\n\nYa no más. 💛\"": "\"Sappiamo come ci si sente. Aprire il feed un lunedì alle 8 e ricordarsi di aver dimenticato di programmare il post di venerdì scorso.\n\nMai più. 💛\"",
  "\"Tu equipo de marketing duerme, tus ventas también. 😴\n\nNosotros automatizamos la primera parte. De la segunda te encargas tú. ☕\"": "\"Il tuo team di marketing dorme, anche le tue vendite. 😴\n\nNoi automatizziamo la prima parte. Della seconda ti occupi tu. ☕\"",
  "\"Nadie te va a decir esto, pero el 80% de tu competencia ya publica con IA…\n\nMientras tú sigues pagándole a 3 personas.\"": "\"Nessuno te lo dirà, ma l'80% della tua concorrenza pubblica già con l'IA…\n\nMentre tu continui a pagare 3 persone.\"",
});

/* ───────────────────────────────────────────────────────────── */
/*  AUTOPILOT landing section (Director de Marketing Autónomo)   */
/* ───────────────────────────────────────────────────────────── */
const AUTOPILOT = {
  en: {
    "NUEVO · FLAGSHIP 2026": "NEW · FLAGSHIP 2026",
    "Un Director de Marketing": "A Marketing Director",
    "que nunca duerme.": "that never sleeps.",
    "Tú das el brief. CIA ejecuta. La primera IA que planea, genera, programa, publica y reporta campañas multi-red — sin un human@ tocando un botón.": "You give the brief. CIA executes. The first AI that plans, generates, schedules, publishes and reports multi-channel campaigns — no human touching a button.",
    "PRECIO DE MERCADO": "MARKET PRICE",
    "INCLUIDO EN TU PLAN CON VIDEO": "INCLUDED IN YOUR VIDEO PLAN",
    "sin costos por campaña · sin límite de piezas": "no per-campaign fees · no piece limits",
    "Briefing IA": "AI Briefing",
    "5 preguntas: marca, objetivo, tono, audiencia y geo. La IA entiende tu contexto completo.": "5 questions: brand, goal, tone, audience and geo. The AI understands your full context.",
    "Plan generado": "Plan generated",
    "Planifica cada pieza por red y hora pico, distribuida en los días que dures la campaña.": "Plans every piece per network and peak hour, spread across the campaign duration.",
    "Contenido real": "Real content",
    "IA redacta copy, ilustra imágenes y graba video vertical. Todo listo 30 min antes de publicar.": "AI writes copy, illustrates images and records vertical video. Ready 30 min before publishing.",
    "Publicación multi-red": "Multi-channel publishing",
    "Instagram, Facebook, X, LinkedIn, TikTok — cada post sale a su mejor hora con las credenciales de la marca.": "Instagram, Facebook, X, LinkedIn, TikTok — each post goes out at its best hour using the brand's own credentials.",
    "Reporte final IA": "Final AI report",
    "Al cierre recibes análisis vs competencia, engagement y recomendaciones para la siguiente campaña.": "At wrap-up you receive competitor benchmarking, engagement and recommendations for next campaign.",
    "BLACK FRIDAY 2026 · VENTAS · AGRESIVO": "BLACK FRIDAY 2026 · SALES · AGGRESSIVE",
    "Campaña Activa": "Active Campaign",
    "Generando post 74 · Instagram · próxima publicación en 17 min": "Generating post 74 · Instagram · next publish in 17 min",
    "No es un generador. Es tu equipo de marketing operando 24/7.": "Not a generator. Your marketing team operating 24/7.",
    "100% autónomo": "100% autonomous",
    "Cierras el navegador. CIA sigue generando y publicando. Tú revisas cuando quieras.": "Close the browser. CIA keeps generating and publishing. You check in whenever you want.",
    "Multi-marca, multi-red": "Multi-brand, multi-channel",
    "Cada marca con su voz, su tono, sus hashtags y sus mejores horarios — sin contaminación de datos.": "Every brand with its own voice, tone, hashtags and best hours — zero data cross-contamination.",
    "Duración 100% flexible": "100% flexible duration",
    "7 días, 30, 60 o 365. Cadencia configurable por red: 1 post, 3 imágenes y 1 video al día si quieres.": "7 days, 30, 60 or 365. Cadence configurable per network: 1 post, 3 images and 1 video per day if you want.",
    "Respeta tu presupuesto IA": "Respects your AI budget",
    "Generación por lotes, video solo si tu plan lo incluye. Sin cargos extra por campaña.": "Batched generation, video only if your plan includes it. No extra fees per campaign.",
    "Reporte de cierre con IA": "AI closing report",
    "Análisis vs competencia, engagement por red, mejor hora real y recomendaciones para la próxima campaña.": "Competitor analysis, engagement per network, real best hour and recommendations for next campaign.",
    "ACTIVAR MI DIRECTOR DE MARKETING": "ACTIVATE MY MARKETING DIRECTOR",
  },
  pt: {
    "NUEVO · FLAGSHIP 2026": "NOVO · FLAGSHIP 2026",
    "Un Director de Marketing": "Um Diretor de Marketing",
    "que nunca duerme.": "que nunca dorme.",
    "Tú das el brief. CIA ejecuta. La primera IA que planea, genera, programa, publica y reporta campañas multi-red — sin un human@ tocando un botón.": "Você dá o brief. CIA executa. A primeira IA que planeja, gera, agenda, publica e reporta campanhas multi-rede — sem um humano tocar um botão.",
    "PRECIO DE MERCADO": "PREÇO DE MERCADO",
    "INCLUIDO EN TU PLAN CON VIDEO": "INCLUÍDO NO SEU PLANO COM VÍDEO",
    "sin costos por campaña · sin límite de piezas": "sem custos por campanha · sem limite de peças",
    "Briefing IA": "Briefing IA",
    "5 preguntas: marca, objetivo, tono, audiencia y geo. La IA entiende tu contexto completo.": "5 perguntas: marca, objetivo, tom, audiência e geo. A IA entende seu contexto completo.",
    "Plan generado": "Plano gerado",
    "Planifica cada pieza por red y hora pico, distribuida en los días que dures la campaña.": "Planeja cada peça por rede e horário de pico, distribuída nos dias que durar a campanha.",
    "Contenido real": "Conteúdo real",
    "IA redacta copy, ilustra imágenes y graba video vertical. Todo listo 30 min antes de publicar.": "A IA escreve copy, ilustra imagens e grava vídeo vertical. Tudo pronto 30 min antes de publicar.",
    "Publicación multi-red": "Publicação multi-rede",
    "Instagram, Facebook, X, LinkedIn, TikTok — cada post sale a su mejor hora con las credenciales de la marca.": "Instagram, Facebook, X, LinkedIn, TikTok — cada post sai no melhor horário com as credenciais da marca.",
    "Reporte final IA": "Relatório final IA",
    "Al cierre recibes análisis vs competencia, engagement y recomendaciones para la siguiente campaña.": "No fechamento você recebe análise vs concorrência, engagement e recomendações para a próxima campanha.",
    "BLACK FRIDAY 2026 · VENTAS · AGRESIVO": "BLACK FRIDAY 2026 · VENDAS · AGRESSIVO",
    "Campaña Activa": "Campanha Ativa",
    "Generando post 74 · Instagram · próxima publicación en 17 min": "Gerando post 74 · Instagram · próxima publicação em 17 min",
    "No es un generador. Es tu equipo de marketing operando 24/7.": "Não é um gerador. É a sua equipe de marketing operando 24/7.",
    "100% autónomo": "100% autônomo",
    "Cierras el navegador. CIA sigue generando y publicando. Tú revisas cuando quieras.": "Você fecha o navegador. A CIA continua gerando e publicando. Você revisa quando quiser.",
    "Multi-marca, multi-red": "Multi-marca, multi-rede",
    "Cada marca con su voz, su tono, sus hashtags y sus mejores horarios — sin contaminación de datos.": "Cada marca com sua voz, tom, hashtags e melhores horários — sem contaminação de dados.",
    "Duración 100% flexible": "Duração 100% flexível",
    "7 días, 30, 60 o 365. Cadencia configurable por red: 1 post, 3 imágenes y 1 video al día si quieres.": "7 dias, 30, 60 ou 365. Cadência configurável por rede: 1 post, 3 imagens e 1 vídeo por dia, se quiser.",
    "Respeta tu presupuesto IA": "Respeita seu orçamento de IA",
    "Generación por lotes, video solo si tu plan lo incluye. Sin cargos extra por campaña.": "Geração em lotes, vídeo apenas se seu plano incluir. Sem cobranças extras por campanha.",
    "Reporte de cierre con IA": "Relatório de fechamento com IA",
    "Análisis vs competencia, engagement por red, mejor hora real y recomendaciones para la próxima campaña.": "Análise vs concorrência, engagement por rede, melhor horário real e recomendações para a próxima campanha.",
    "ACTIVAR MI DIRECTOR DE MARKETING": "ATIVAR MEU DIRETOR DE MARKETING",
  },
  fr: {
    "NUEVO · FLAGSHIP 2026": "NOUVEAU · FLAGSHIP 2026",
    "Un Director de Marketing": "Un Directeur Marketing",
    "que nunca duerme.": "qui ne dort jamais.",
    "Tú das el brief. CIA ejecuta. La primera IA que planea, genera, programa, publica y reporta campañas multi-red — sin un human@ tocando un botón.": "Vous donnez le brief. CIA exécute. La première IA qui planifie, génère, programme, publie et rapporte des campagnes multi-réseaux — sans humain qui touche un bouton.",
    "PRECIO DE MERCADO": "PRIX DU MARCHÉ",
    "INCLUIDO EN TU PLAN CON VIDEO": "INCLUS DANS VOTRE FORFAIT VIDÉO",
    "sin costos por campaña · sin límite de piezas": "sans frais par campagne · sans limite de pièces",
    "Briefing IA": "Briefing IA",
    "5 preguntas: marca, objetivo, tono, audiencia y geo. La IA entiende tu contexto completo.": "5 questions : marque, objectif, ton, audience et geo. L'IA comprend votre contexte complet.",
    "Plan generado": "Plan généré",
    "Planifica cada pieza por red y hora pico, distribuida en los días que dures la campaña.": "Planifie chaque pièce par réseau et heure de pointe, répartie sur la durée de la campagne.",
    "Contenido real": "Contenu réel",
    "IA redacta copy, ilustra imágenes y graba video vertical. Todo listo 30 min antes de publicar.": "L'IA rédige le copy, illustre les images et enregistre la vidéo verticale. Prêt 30 min avant publication.",
    "Publicación multi-red": "Publication multi-réseaux",
    "Instagram, Facebook, X, LinkedIn, TikTok — cada post sale a su mejor hora con las credenciales de la marca.": "Instagram, Facebook, X, LinkedIn, TikTok — chaque post est publié à sa meilleure heure avec les identifiants de la marque.",
    "Reporte final IA": "Rapport final IA",
    "Al cierre recibes análisis vs competencia, engagement y recomendaciones para la siguiente campaña.": "À la clôture vous recevez analyse vs concurrence, engagement et recommandations pour la prochaine campagne.",
    "BLACK FRIDAY 2026 · VENTAS · AGRESIVO": "BLACK FRIDAY 2026 · VENTES · AGRESSIF",
    "Campaña Activa": "Campagne Active",
    "Generando post 74 · Instagram · próxima publicación en 17 min": "Génération post 74 · Instagram · prochaine publication dans 17 min",
    "No es un generador. Es tu equipo de marketing operando 24/7.": "Ce n'est pas un générateur. C'est votre équipe marketing opérant 24/7.",
    "100% autónomo": "100% autonome",
    "Cierras el navegador. CIA sigue generando y publicando. Tú revisas cuando quieras.": "Vous fermez le navigateur. CIA continue à générer et publier. Vous vérifiez quand vous voulez.",
    "Multi-marca, multi-red": "Multi-marque, multi-réseaux",
    "Cada marca con su voz, su tono, sus hashtags y sus mejores horarios — sin contaminación de datos.": "Chaque marque avec sa voix, son ton, ses hashtags et ses meilleures heures — zéro contamination de données.",
    "Duración 100% flexible": "Durée 100% flexible",
    "7 días, 30, 60 o 365. Cadencia configurable por red: 1 post, 3 imágenes y 1 video al día si quieres.": "7 jours, 30, 60 ou 365. Cadence configurable par réseau : 1 post, 3 images et 1 vidéo par jour si vous voulez.",
    "Respeta tu presupuesto IA": "Respecte votre budget IA",
    "Generación por lotes, video solo si tu plan lo incluye. Sin cargos extra por campaña.": "Génération par lots, vidéo uniquement si votre forfait l'inclut. Aucun frais supplémentaire par campagne.",
    "Reporte de cierre con IA": "Rapport de clôture avec IA",
    "Análisis vs competencia, engagement por red, mejor hora real y recomendaciones para la próxima campaña.": "Analyse vs concurrence, engagement par réseau, meilleure heure réelle et recommandations pour la prochaine campagne.",
    "ACTIVAR MI DIRECTOR DE MARKETING": "ACTIVER MON DIRECTEUR MARKETING",
  },
  de: {
    "NUEVO · FLAGSHIP 2026": "NEU · FLAGSHIP 2026",
    "Un Director de Marketing": "Ein Marketingdirektor",
    "que nunca duerme.": "der nie schläft.",
    "Tú das el brief. CIA ejecuta. La primera IA que planea, genera, programa, publica y reporta campañas multi-red — sin un human@ tocando un botón.": "Du gibst das Briefing. CIA führt aus. Die erste KI, die Multi-Channel-Kampagnen plant, generiert, plant, veröffentlicht und berichtet — ohne dass ein Mensch einen Knopf drückt.",
    "PRECIO DE MERCADO": "MARKTPREIS",
    "INCLUIDO EN TU PLAN CON VIDEO": "IM VIDEO-TARIF ENTHALTEN",
    "sin costos por campaña · sin límite de piezas": "keine Kampagnen-Gebühr · keine Stück-Limits",
    "Briefing IA": "KI-Briefing",
    "5 preguntas: marca, objetivo, tono, audiencia y geo. La IA entiende tu contexto completo.": "5 Fragen: Marke, Ziel, Tonalität, Zielgruppe und Geo. Die KI versteht deinen gesamten Kontext.",
    "Plan generado": "Plan erstellt",
    "Planifica cada pieza por red y hora pico, distribuida en los días que dures la campaña.": "Plant jedes Stück pro Netzwerk und Hauptzeit, verteilt über die Kampagnendauer.",
    "Contenido real": "Echter Content",
    "IA redacta copy, ilustra imágenes y graba video vertical. Todo listo 30 min antes de publicar.": "KI schreibt Copy, illustriert Bilder und nimmt vertikales Video auf. 30 Min vor Veröffentlichung bereit.",
    "Publicación multi-red": "Multi-Channel-Veröffentlichung",
    "Instagram, Facebook, X, LinkedIn, TikTok — cada post sale a su mejor hora con las credenciales de la marca.": "Instagram, Facebook, X, LinkedIn, TikTok — jeder Post wird zur besten Zeit mit den Marken-Credentials veröffentlicht.",
    "Reporte final IA": "KI-Abschlussbericht",
    "Al cierre recibes análisis vs competencia, engagement y recomendaciones para la siguiente campaña.": "Zum Abschluss erhältst du Wettbewerbsanalyse, Engagement und Empfehlungen für die nächste Kampagne.",
    "BLACK FRIDAY 2026 · VENTAS · AGRESIVO": "BLACK FRIDAY 2026 · VERKAUF · AGGRESSIV",
    "Campaña Activa": "Aktive Kampagne",
    "Generando post 74 · Instagram · próxima publicación en 17 min": "Generiere Post 74 · Instagram · nächste Veröffentlichung in 17 Min",
    "No es un generador. Es tu equipo de marketing operando 24/7.": "Kein Generator. Dein Marketing-Team, das 24/7 arbeitet.",
    "100% autónomo": "100% autonom",
    "Cierras el navegador. CIA sigue generando y publicando. Tú revisas cuando quieras.": "Schließe den Browser. CIA generiert und veröffentlicht weiter. Du schaust rein, wann du willst.",
    "Multi-marca, multi-red": "Multi-Brand, Multi-Channel",
    "Cada marca con su voz, su tono, sus hashtags y sus mejores horarios — sin contaminación de datos.": "Jede Marke mit eigener Stimme, Tonalität, Hashtags und besten Zeiten — null Datenvermischung.",
    "Duración 100% flexible": "100% flexible Laufzeit",
    "7 días, 30, 60 o 365. Cadencia configurable por red: 1 post, 3 imágenes y 1 video al día si quieres.": "7 Tage, 30, 60 oder 365. Kadenz pro Netzwerk konfigurierbar: 1 Post, 3 Bilder und 1 Video pro Tag wenn du willst.",
    "Respeta tu presupuesto IA": "Respektiert dein KI-Budget",
    "Generación por lotes, video solo si tu plan lo incluye. Sin cargos extra por campaña.": "Batch-Generierung, Video nur wenn im Tarif enthalten. Keine Zusatzkosten pro Kampagne.",
    "Reporte de cierre con IA": "KI-Abschlussbericht",
    "Análisis vs competencia, engagement por red, mejor hora real y recomendaciones para la próxima campaña.": "Wettbewerbsanalyse, Engagement pro Netzwerk, echte beste Zeit und Empfehlungen für die nächste Kampagne.",
    "ACTIVAR MI DIRECTOR DE MARKETING": "MEINEN MARKETINGDIREKTOR AKTIVIEREN",
  },
  it: {
    "NUEVO · FLAGSHIP 2026": "NUOVO · FLAGSHIP 2026",
    "Un Director de Marketing": "Un Direttore Marketing",
    "que nunca duerme.": "che non dorme mai.",
    "Tú das el brief. CIA ejecuta. La primera IA que planea, genera, programa, publica y reporta campañas multi-red — sin un human@ tocando un botón.": "Tu dai il brief. CIA esegue. La prima IA che pianifica, genera, programma, pubblica e reportizza campagne multi-rete — senza un umano che tocchi un pulsante.",
    "PRECIO DE MERCADO": "PREZZO DI MERCATO",
    "INCLUIDO EN TU PLAN CON VIDEO": "INCLUSO NEL TUO PIANO CON VIDEO",
    "sin costos por campaña · sin límite de piezas": "senza costi per campagna · senza limiti di pezzi",
    "Briefing IA": "Briefing IA",
    "5 preguntas: marca, objetivo, tono, audiencia y geo. La IA entiende tu contexto completo.": "5 domande: brand, obiettivo, tono, audience e geo. L'IA comprende il tuo contesto completo.",
    "Plan generado": "Piano generato",
    "Planifica cada pieza por red y hora pico, distribuida en los días que dures la campaña.": "Pianifica ogni pezzo per rete e orario di punta, distribuito sui giorni di durata della campagna.",
    "Contenido real": "Contenuto reale",
    "IA redacta copy, ilustra imágenes y graba video vertical. Todo listo 30 min antes de publicar.": "L'IA scrive copy, illustra immagini e registra video verticale. Tutto pronto 30 min prima della pubblicazione.",
    "Publicación multi-red": "Pubblicazione multi-rete",
    "Instagram, Facebook, X, LinkedIn, TikTok — cada post sale a su mejor hora con las credenciales de la marca.": "Instagram, Facebook, X, LinkedIn, TikTok — ogni post esce al suo miglior orario con le credenziali del brand.",
    "Reporte final IA": "Report finale IA",
    "Al cierre recibes análisis vs competencia, engagement y recomendaciones para la siguiente campaña.": "Alla chiusura ricevi analisi vs concorrenza, engagement e raccomandazioni per la campagna successiva.",
    "BLACK FRIDAY 2026 · VENTAS · AGRESIVO": "BLACK FRIDAY 2026 · VENDITE · AGGRESSIVO",
    "Campaña Activa": "Campagna Attiva",
    "Generando post 74 · Instagram · próxima publicación en 17 min": "Generazione post 74 · Instagram · prossima pubblicazione tra 17 min",
    "No es un generador. Es tu equipo de marketing operando 24/7.": "Non è un generatore. È il tuo team di marketing che opera 24/7.",
    "100% autónomo": "100% autonomo",
    "Cierras el navegador. CIA sigue generando y publicando. Tú revisas cuando quieras.": "Chiudi il browser. CIA continua a generare e pubblicare. Tu controlli quando vuoi.",
    "Multi-marca, multi-red": "Multi-brand, multi-rete",
    "Cada marca con su voz, su tono, sus hashtags y sus mejores horarios — sin contaminación de datos.": "Ogni brand con la sua voce, tono, hashtag e orari migliori — zero contaminazione di dati.",
    "Duración 100% flexible": "Durata 100% flessibile",
    "7 días, 30, 60 o 365. Cadencia configurable por red: 1 post, 3 imágenes y 1 video al día si quieres.": "7 giorni, 30, 60 o 365. Cadenza configurabile per rete: 1 post, 3 immagini e 1 video al giorno se vuoi.",
    "Respeta tu presupuesto IA": "Rispetta il tuo budget IA",
    "Generación por lotes, video solo si tu plan lo incluye. Sin cargos extra por campaña.": "Generazione a lotti, video solo se incluso nel piano. Nessun costo extra per campagna.",
    "Reporte de cierre con IA": "Report di chiusura con IA",
    "Análisis vs competencia, engagement por red, mejor hora real y recomendaciones para la próxima campaña.": "Analisi vs concorrenza, engagement per rete, migliore orario reale e raccomandazioni per la prossima campagna.",
    "ACTIVAR MI DIRECTOR DE MARKETING": "ATTIVA IL MIO DIRETTORE MARKETING",
  },
};

for (const lang of ["en", "pt", "fr", "de", "it"]) {
  Object.assign(DICT[lang], AUTOPILOT[lang]);
}

export default DICT;
